/* eslint-disable */

export default class T {
  static ABILITY_TO_CHANGE_ROUTE = 'Ability of the driver to change route'
  static ABILITY_TO_CHANGE_TRUCK = 'Ability of the driver to change truck'
  static ABOUT_ALWAYS_APPLIES_TO = 'About always applies to'
  static ABOUT_OVERRIDES = 'About overrides'
  static ACCEPT = 'Accept'
  static ACCEPTED_UPPER = 'ACCEPTED'
  static ACCESS_MODIFY_SETTINGS = 'Access / Modify Settings'
  static ACCOUNT = 'Account'
  static ACCOUNTING_INFORMATION_OPTIONAL = 'Accounting Information (optional)'
  static ACCOUNTS = 'Accounts'
  static ACCOUNTS_LOAD_FAILED = "Couldn't load accounts. Try again in a moment."
  static ACCOUNTS_LOWERCASE = 'accounts'
  static ACCOUNTS_RECEIVABLE = 'Accounts receivable'
  static ACCOUNTS_SUSPENDED_SUCCESSFULLY = 'Accounts suspended successfully'
  static ACCOUNTS_UNSUSPENDED_SUCCESSFULLY = 'Accounts unsuspended successfully'
  static ACCOUNT_ACTIVATED = 'Account activated'
  static ACCOUNT_ACTIVATED_DESCRIPTION = 'Account was successfully activated. Please reactivate locations.'
  static ACCOUNT_ACTIVATED_TITLE = 'Account activated'
  static ACCOUNT_ALREADY_ACTIVE = 'This account is already active.'
  static ACCOUNT_BALANCE = 'Account balance'
  static ACCOUNT_CONTACTS = 'Account contacts'
  static ACCOUNT_CONTAINERS_COULD_NOT_LOAD =
    "We couldn't load this account's containers. Deactivating now leaves them unresolved — you can settle them from each service afterwards."
  static ACCOUNT_CREATED = 'Account created'
  static ACCOUNT_CREDIT = 'Account Credit'
  static ACCOUNT_DEACTIVATED_SUCCESSFULLY = 'Account deactivated successfully'
  static ACCOUNT_DEACTIVATION_ALREADY_RUNNING = 'A deactivation is already in progress for this account'
  static ACCOUNT_DEACTIVATION_FAILED = 'Failed to deactivate the account. Please try again.'
  static ACCOUNT_DEACTIVATION_IN_PROGRESS = 'Deactivating'
  static ACCOUNT_DEACTIVATION_MSG = 'This account has been deactivated'
  static ACCOUNT_DEACTIVATION_SCHEDULED = 'Deactivation scheduled'
  static ACCOUNT_DEACTIVATION_STARTED = 'Deactivation started'
  static ACCOUNT_DEACTIVATION_STARTED_DESCRIPTION =
    "You can leave this page — we'll notify you in the notification center when it's finished."
  static ACCOUNT_DEBIT = 'Account Debit'
  static ACCOUNT_DETAILS_UPDATED_SUCCESSFULLY = 'Account details updated successfully'
  static ACCOUNT_DOESNT_EXIST = "Account doesn't exist"
  static ACCOUNT_GROUPS = 'Account groups'
  static ACCOUNT_GROUPS_OPEN_HINT = "Click a group's name or anywhere on its card to view the accounts in that group"
  static ACCOUNT_GROUP_CREATED_SUCCESS_MSG = 'Account group created successfully'
  static ACCOUNT_GROUP_NAME = 'Account group name'
  static ACCOUNT_GROUP_TABS = 'Account group type'
  static ACCOUNT_GROUP_UPDATED_SUCCESS_MSG = 'Account group updated successfully'
  static ACCOUNT_GROUP_VIEW = 'Account group view'
  static ACCOUNT_IS_REQUIRED = 'Account is required'
  static ACCOUNT_LOWERCASE = 'account'
  static ACCOUNT_NAME = 'Account Name'
  static ACCOUNT_NAME_PLACEHOLDER = 'Account # / Name'
  static ACCOUNT_NOTE = 'Account note'
  static ACCOUNT_NOT_FOUND = 'not found'
  static ACCOUNT_NOT_FOUND_AFTER_ATTEMPTS = 'could not be found after multiple attempts'
  static ACCOUNT_NOT_FOUND_ERROR = 'Account not found'
  static ACCOUNT_NUMBER = 'Account number'
  static ACCOUNT_NUMBER_MAPPING_REQUIRED = 'Account number mapping is required for processing invoices'
  static ACCOUNT_PERIOD_LOCK = 'Account Period Lock'
  static ACCOUNT_REACTIVATED_SUCCESSFULLY = 'Account reactivated successfully'
  static ACCOUNT_REACTIVATED_WORK_ORDERS_REGENERATING = 'Account reactivated. Its work orders are regenerating in the background.'
  static ACCOUNT_REACTIVATION_CREATING_WORK_ORDERS = 'Creating work orders'
  static ACCOUNT_REACTIVATION_CREATING_WORK_ORDERS_TOOLTIP =
    'The account is active. Its work orders are being created and will show up as they are done.'
  static ACCOUNT_REACTIVATION_FAILED = 'Failed to reactivate the account. Please try again.'
  static ACCOUNT_REACTIVATION_STARTED = 'Account reactivated'
  static ACCOUNT_REACTIVATION_STARTED_DESCRIPTION =
    "Work orders are regenerating. We'll notify you in the notification center when it's finished."
  static ACCOUNT_REASON_DELETED_SUCCESSFULLY = 'Reason deleted successfully'
  static ACCOUNT_REP = 'Account rep'
  static ACCOUNT_REPRESENTATIVE = 'Account Representative'
  static ACCOUNT_REP_UPDATED_SUCCESSFULLY = 'Account rep updated successfully'
  static ACCOUNT_SETTINGS = 'Account settings'
  static ACCOUNT_SETTINGS_LOAD_ERROR = 'Unable to load account settings. Refresh and try again.'
  static ACCOUNT_SETTINGS_REASONS_TAB = 'Reasons'
  static ACCOUNT_SETTINGS_REQUIRED_FIELDS_TAB = 'Required Fields'
  static ACCOUNT_STATUS = 'Account status'
  static ACCOUNT_STATUS_RULE = 'Account status'
  static ACCOUNT_SUSPENDED_SUCCESSFULLY = 'Account suspended successfully'
  static ACCOUNT_SUSPENSION_PRORATION_SETTINGS_TOOLTIP = 'Changing this setting will only affect Suspension Proration for this account.'
  static ACCOUNT_TAG = 'Account tag'
  static ACCOUNT_TAGS = 'Account Tags'
  static ACCOUNT_UNSUSPENDED_SUCCESSFULLY = 'Account unsuspended successfully'
  static ACCOUNT_VIEW = 'Accounts'
  static ACCOUNT_WORK_ORDERS_STILL_REGENERATING = "Work orders are still regenerating after this account's reactivation"
  static ACH = 'ACH'
  static ACH_FAILED = 'ACH Failed'
  static ACH_MENU = 'ACH'
  static ACH_PAYMENT_FAILED = 'ACH payment failed'
  static ACTION = 'Action'
  static ACTIONS = 'Actions'
  static ACTION_BASED_PRICING = 'Action based pricing'
  static ACTION_BUTTONS = 'Action Buttons'
  static ACTION_BUTTONS_FONT_COLOR = 'Action Buttons Font Color'
  static ACTION_CANNOT_BE_REVERSED = 'This action cannot be reversed.'
  static ACTION_NAME = 'Action Name'
  static ACTION_REQUIRED_IF_WO_DATE_SET = 'An action is required if a work order date is set'
  static ACTION_UNDONE = 'Action undone'
  static ACTION_UPDATED_SUCCESSFULLY = 'Action updated successfully'
  static ACTIVATE = 'Activate'
  static ACTIVATED_AT = 'Activated'
  static ACTIVATE_ALL_LOCATIONS = 'Activate all locations'
  static ACTIVATE_LOCATION = 'Activate location'
  static ACTIVATE_OFFICE_LOGIN = 'Activate Office Login'
  static ACTIVATE_ROAD_LOGIN = 'Activate Road Login'
  static ACTIVATING = 'Activating'
  static ACTIVE = 'Active'
  static ACTIVE_CONTACT = 'Active contact'
  static ACTIVE_FILTERS = 'Active filters'
  static ACTIVE_LOCATIONS = 'Active Locations'
  static ACTIVE_SERVICES = 'Active Services'
  static ACTIVITY = 'Activity'
  static ACTIVITY_HISTORY = 'Activity history'
  static ADD = 'Add'
  static ADDED_BY = 'Added By'
  static ADDITIONAL_DETAILS = 'Additional details...'
  static ADDRESS = 'Address'
  static ADDRESS_LOOKUP = 'Address'
  static ADDRESS_NAME = 'Address name'
  static ADD_ACCOUNT = 'Add Account'
  static ADD_ACCOUNTS = 'Add account(s)'
  static ADD_ACCOUNTS_TO_GROUP = 'Add accounts to group'
  static ADD_ACCOUNTS_TO_GROUP_SUCCESS_MSG = 'Selected accounts successfully added to the group'
  static ADD_ACCOUNT_NOTES = 'Add account notes'
  static ADD_ACCOUNT_TAGS = 'Add account tags'
  static ADD_ACCOUNT_TO_GROUP_SUCCESS_MSG = 'Selected account successfully added to the group'
  static ADD_ACTION = 'Add Action'
  static ADD_AND_ASSIGN = 'Add & Assign'
  static ADD_AND_ASSIGN_WORK_ORDER = 'Add & Assign work order'
  static ADD_AND_CONDITION = 'AND condition'
  static ADD_ANOTHER_SAMPLE_MESSAGE = 'Add another sample message'
  static ADD_ATTACHMENT = 'Add attachment'
  static ADD_A_ROUTE_NAME = 'Add a route name'
  static ADD_A_TAG_LABEL = '+ add a tag'
  static ADD_BILLING_NOTES = 'Add billing notes'
  static ADD_CAMPAIGN = 'Add Campaign'
  static ADD_CAMPAIGN_DIALOG_SUBTITLE =
    'Create a draft campaign for this brand. You can review and submit it to TCR from the campaign list.'
  static ADD_CAMPAIGN_DIALOG_TITLE = 'Add Campaign'
  static ADD_CAMPAIGN_DISABLED_TOOLTIP = 'Verify the brand before adding campaigns'
  static ADD_CAMPAIGN_TOOLTIP = 'Create a new campaign under this brand'
  static ADD_CC_EMAIL = 'Add Cc email address...'
  static ADD_CONTACT_METHOD = 'Add Contact Method'
  static ADD_CONTAINER = 'Add Container'
  static ADD_CONTAINER_SIZE = 'Add Container Size'
  static ADD_CONTAINER_TO_INVENTORY = 'Add container to inventory'
  static ADD_CONTAINER_TYPE = 'Add container type'
  static ADD_DISPOSAL_FEE = 'Add disposal fee'
  static ADD_DISPOSAL_STOP = 'Add disposal stop'
  static ADD_DISPOSAL_TICKET = 'Add disposal ticket'
  static ADD_EVENT = 'Add event'
  static ADD_EXCLUDE_RULE = 'Add exclude rule'
  static ADD_EXCLUSION = 'Add exclusion'
  static ADD_FILTER = 'Add filter'
  static ADD_FROM_INVENTORY = 'Add from inventory'
  static ADD_HOLD = 'Add hold'
  static ADD_INCLUDE_RULE = 'Add include rule'
  static ADD_INVENTORY = 'Add inventory'
  static ADD_INVOICE = 'Add invoice'
  static ADD_INVOICES = 'Add invoice(s)'
  static ADD_INVOICES_TO_GROUP_SUCCESS_MSG = 'Selected invoices successfully added to the group'
  static ADD_INVOICE_TO_GROUP_SUCCESS_MSG = 'Selected invoice successfully added to the group'
  static ADD_LATE_FEE = 'Add late fee'
  static ADD_LOCATION_NOTE = 'Add location note'
  static ADD_MATERIAL = 'Add Material'
  static ADD_METHOD = 'Add Method'
  static ADD_NEW_CONTAINER = 'Add new container'
  static ADD_NEW_CONTAINER_TEXT = 'You can add containers by clicking + above'
  static ADD_NEW_METHOD = 'Click + button above to add a new payment method'
  static ADD_NOTE = 'Add note'
  static ADD_OR_GROUP = 'OR group'
  static ADD_PAYMENT = 'Add payment'
  static ADD_PAYMENTS_TO_GROUP_SUCCESS_MSG = 'Selected payments successfully added to the group'
  static ADD_PAYMENT_METHOD = 'Add payment method'
  static ADD_PERMIT = 'Add Permit'
  static ADD_PHOTOS_OR_VIDEOS = 'Add photos or videos'
  static ADD_PRICING_PERIOD = 'Add Pricing Period'
  static ADD_PURCHASE_ORDER = 'Add purchase order'
  static ADD_RECIPIENTS = 'Add recipients...'
  static ADD_RECURRENCE = 'Add Recurrence'
  static ADD_REMOVE_EVENT = 'Add / Remove Event'
  static ADD_RENTAL_FEE = 'Add rental fee'
  static ADD_SERVICE = 'Add Service'
  static ADD_SERVICES = 'Add Services'
  static ADD_SERVICES_TO_DISPOSAL_FEE = 'Add services to disposal fee'
  static ADD_SERVICES_TO_RENTAL_FEE = 'Add services to rental fee'
  static ADD_SERVICE_GROUP = 'Add Service Group'
  static ADD_SERVICE_NOTE = 'Add service note'
  static ADD_SKILL = 'Add Skill'
  static ADD_TO_ACCOUNT_GROUP = 'Add to account group'
  static ADD_TO_CONTACTS = 'Add to contacts'
  static ADD_TO_CS = 'Add to Configured Service'
  static ADD_TO_GROUP = 'Add to group'
  static ADD_TO_INVOICE_GROUP = 'Add to invoice group'
  static ADD_TO_LOCATION = 'Add to Location'
  static ADD_TO_NEW_WORK_ORDERS = 'Add to future work orders'
  static ADD_TO_PAYMENT_GROUP = 'Add to payment group'
  static ADD_WORK_ORDER_NOTE = 'Add work order note'
  static ADD_ZONES = 'Add zones…'
  static ADJUSTMENTS = 'Adjustments'
  static ADJUSTMENTS_TOTAL = 'Adjustments Total'
  static ADJUST_COMPANY_LOGO = 'Adjust company logo'
  static ADJUST_LOGO = 'Adjust logo'
  static ADJUST_SERVICE = 'Adjust service'
  static ADVANCE = 'Advance'
  static ADVANCED = 'Advanced'
  static ADVANCED_MAP = 'Advanced map'
  static AFFECTED = 'affected'
  static AFFECTED_WORK_ORDERS = 'Affected Work Orders'
  static AFTER = 'After'
  static AGE_GATED = 'Age Gated'
  static AGING = 'Aging'
  static AGING_BUCKET = 'Aging bucket'
  static AGING_GROUP_DESCRIPTION = 'Unpaid posted invoices in this age band.'
  static AI_REPORTS_BEGIN_SUBTITLE = 'Choose a starting point or describe the report you need.'
  static AI_REPORTS_BEGIN_TITLE = 'Where should we begin?'
  static AI_REPORTS_CARD_TITLE = 'Hero Analytics'
  static AI_REPORTS_DISCLAIMER = 'Hero Analytics can make mistakes, please check important info.'
  static AI_REPORTS_DOWNLOAD = 'Download attachment'
  static AI_REPORTS_ERROR = 'An error occurred while connecting to the AI.'
  static AI_REPORTS_HEADER = 'Hero Analytics'
  static AI_REPORTS_INPUT_PLACEHOLDER = 'Describe the report you need...'
  static AI_REPORTS_NEW_REQUEST = 'New request'
  static AI_REPORTS_NO_ANSWER = 'Hero Analytics finished without an answer. Please try asking again.'
  static AI_REPORTS_RECENTS = 'Recents'
  static AI_REPORTS_RENAME = 'Rename'
  static AI_REPORTS_SIDEBAR_TITLE = 'Hero Analytics'
  static AI_REPORTS_STILL_WORKING = 'Still working — complex reports and dashboards can take a few minutes.'
  static AI_REPORTS_SUGGESTION_DRIVER = 'Driver performance this month'
  static AI_REPORTS_SUGGESTION_EXCEPTIONS = 'Exception breakdown by type'
  static AI_REPORTS_SUGGESTION_MATERIAL = 'Tons of material by jurisdiction'
  static AI_REPORTS_SUGGESTION_REVENUE = 'Show me a revenue dashboard'
  static AI_REPORTS_TIMEOUT = 'This is taking much longer than expected. Please try again.'
  static AI_REPORTS_WORKING = 'Hero Analytics is working on it...'
  static ALERT_CHANGES = 'Any changes will be lost.'
  static ALERT_GO_BACK = 'Are you sure you want to go back?'
  static ALL = 'All'
  static ALLOW_TIMER = 'Enable the driver to modify the interruption timer (countdown)'
  static ALL_ACTIONS = 'All actions'
  static ALL_ASSESSED = 'All assessed'
  static ALL_BUSINESS_LINES = 'All business lines'
  static ALL_CAUGHT_UP = 'All caught up for this filter.'
  static ALL_CHANNELS = 'All channels'
  static ALL_CONTAINERS = 'All containers'
  static ALL_CREATORS = 'All creators'
  static ALL_DAYS = 'All days'
  static ALL_DETECTIONS = 'All Detections'
  static ALL_DETECTIONS_DESCRIPTION = 'Every detection — exceptions and discrepancies combined.'
  static ALL_HAULERS = 'All haulers'
  static ALL_LOCATIONS = 'All locations'
  static ALL_LOCATIONS_ACTIVATED_SUCCESS = 'Locations activated successfully'
  static ALL_LOCATIONS_DEACTIVATED_SUCCESS = 'Locations deactivated successfully'
  static ALL_LOCATIONS_SELECTED = 'All locations selected'
  static ALL_MOVES = 'All moves'
  static ALL_NOTIFICATIONS = 'All notifications'
  static ALL_ROUTES = 'All routes'
  static ALL_SET = 'All set'
  static ALL_SOURCES = 'All Sources'
  static ALL_SOURCES_OPTION = 'All sources'
  static ALL_STATUSES = 'All statuses'
  static ALL_TIME = 'All time'
  static ALL_TYPES = 'All types'
  static ALL_WORK_ORDERS_NO_DATE_FILTER = 'All work orders (no date filter)'
  static ALL_YARDS = 'All yards'
  static ALREADY_REVIEWED_NOTIFY_HINT = 'Already reviewed — you can still notify the customer'
  static ALREADY_SET_SUFFIX = 'already set'
  static ALWAYS_APPLIES_TO = 'Always applies to'
  static ALWAYS_APPLIES_TO_HELPER =
    'Services and general, late, rental and disposal fees each control whether that charge type is taxed. Business lines, locations and materials work the other way: switching one off removes the tax from any charge carrying that attribute.'
  static AMOUNT = 'Amount'
  static AMOUNT_MUST_BE_GREATER_THAN_ZERO = 'Amount must be greater than 0'
  static AMOUNT_PLACEHOLDER = '0.00'
  static ANCHOR_WEEK_IS_REQUIRED_FOR_BIWEEKLY = 'Every-other-week needs a start date — it is what sets which week is which'
  static ANCHOR_WEEK_START_DATE = 'Starts week of'
  static AND = 'And'
  static AND_LOWERCASE = 'and'
  static ANNIVERSARY_LABEL = 'Anniversary'
  static ANNIVERSARY_VALUE = 'Anniversary'
  static ANNUAL = 'Annual'
  static ANNUALLY = 'Annually'
  static ANY_DAY = 'Any day'
  static ANY_FEE_ADDED = 'Any fee added'
  static ANY_FEE_ADDED_DESCRIPTION = 'General, Rental, Disposal, or Late fees'
  static ANY_FOLLOWUP_INFO = 'View and/or edit follow ups that are not assigned to or created by that particular user'
  static ANY_TIME = 'Any time'
  static AN_ERROR_OCCURRED_WHILE_SAVING = 'An error occurred while saving'
  static APPLICATION = 'Application'
  static APPLIED = 'Applied'
  static APPLIED_TO_THIS_TAX = 'Applied to this tax'
  static APPLIES_ON = 'Applies on'
  static APPLIES_TO_ALL_CONTAINERS = 'Applies to all containers'
  static APPLY = 'Apply'
  static APPLY_CHARGE_TO_INVOICE = 'Apply to Invoice'
  static APPLY_CREDIT = 'Apply Credit'
  static APPLY_CREDIT_SUCCESS_MSG = 'Credit Applied successfully'
  static APPLY_FILTERS = 'Apply Filters'
  static APPLY_PAYMENT = 'Apply payment'
  static APPLY_TO = 'Apply to'
  static APPLY_TO_MASTER_AND_FUTURE = 'Apply to master & future days'
  static APPLY_TO_THIS_DAY = 'Apply to this day'
  static APPROVED = 'Approved'
  static APPROVED_AT = 'Approved'
  static ARCHIVE = 'Archive'
  static ARCHIVED = 'Archived'
  static ARCHIVED_ACCOUNT_NOTES = 'Archived account notes'
  static ARCHIVED_BILLING_NOTES = 'Archived billing notes'
  static ARCHIVED_CONFIGURED_SERVICE_NOTES = 'Archived configured service notes'
  static ARCHIVED_LOCATION_NOTES = 'Archived location notes'
  static ARCHIVED_WORK_ORDER_NOTES = 'Archived work order notes'
  static ARCHIVE_DISPOSAL_FEE = 'Archive disposal fee'
  static ARCHIVE_DISPOSAL_FEE_CONFIRM_MSG = 'Are you sure you want to archive this disposal fee?'
  static ARCHIVE_LATE_FEE = 'Archive late fee'
  static ARCHIVE_LATE_FEE_CONFIRM_MSG = 'Are you sure you want to archive this late fee?'
  static ARCHIVE_NOTE = 'Archive note'
  static ARCHIVE_NOTE_CONFIRMATION_DESCRIPTION = 'Are you sure you want to archive this note?'
  static ARCHIVE_RENTAL_FEE = 'Archive rental fee'
  static ARCHIVE_RENTAL_FEE_CONFIRM_MSG = 'Are you sure you want to archive this rental fee?'
  static ARCHIVE_SERVICE_NOTE = 'Archive service note'
  static ARCHIVE_SERVICE_NOTE_CONFIRMATION_DESCRIPTION = 'Are you sure you want to archive this service note?'
  static ARCHIVE_TAX = 'Archive tax'
  static ARCHIVE_TAX_DESCRIPTION =
    'This tax will be archived — historical invoices keep their charges, but it will no longer apply to new invoices.'
  static AREA_CODE = 'Area Code'
  static AREA_CODE_HELPER = 'Enter all 3 digits'
  static AREA_CODE_HELPER_OPTIONAL = 'NPA — optional, 3 digits'
  static AREA_CODE_PLACEHOLDER = 'e.g. 602'
  static ARE_YOU_SURE_CONTINUE = 'Are you sure you want to continue?'
  static ARE_YOU_SURE_DELETE_HOLD = 'Are you sure you want to delete this hold?'
  static ARE_YOU_SURE_DELETE_INVOICE = 'Are you sure you want to delete invoice'
  static ARE_YOU_SURE_DELETE_INVOICES = 'Are you sure you want to delete the following invoices?'
  static ARE_YOU_SURE_YOU_WANT_TO_CONTINUE = 'Are you sure you want to continue?'
  static ARE_YOU_SURE_YOU_WANT_TO_DELETE = 'Are you sure you want to delete?'
  static ARREARS = 'Arrears'
  static ARRIVE_AFTER = 'Arrive after'
  static AR_BALANCE = 'AR Balance'
  static AR_REPORT = 'AR_REPORT'
  static AR_REPORT_TYPE_FILTER = 'ACCOUNT_RECEIVABLES'
  static ASSIGN = 'Assign'
  static ASSIGNED = 'Assigned'
  static ASSIGNED_DRIVER = 'Assigned driver'
  static ASSIGNED_DRIVERS = 'Assigned drivers'
  static ASSIGNED_ON = 'Assigned'
  static ASSIGNED_ROUTE = 'Assigned route'
  static ASSIGNED_ROUTE_DESCRIPTION = 'Routed work orders show route color & name initials'
  static ASSIGNED_STOPS = 'Assigned stops'
  static ASSIGNED_TO = 'Assigned To'
  static ASSIGNEE = 'Assignee'
  static ASSIGN_AND_SCHEDULE = 'Assign & schedule'
  static ASSIGN_AND_SCHEDULE_DELIVERY = 'Assign & schedule delivery'
  static ASSIGN_A_CONTAINER = 'Assign a container'
  static ASSIGN_A_CONTAINER_OR_DEACTIVATE = 'Assign a container to this service, or deactivate the service from its actions menu.'
  static ASSIGN_BY_NEAREST_STOP = 'Assign by nearest stop'
  static ASSIGN_CONTAINER = 'Assign container'
  static ASSIGN_CURRENT_DAY = 'Assign current day'
  static ASSIGN_NOW = 'Assign now'
  static ASSIGN_PERMANENT = 'Assign permanent'
  static ASSIGN_STOP = 'Assign stop'
  static ASSIGN_STOPS = 'Assign stops'
  static ASSIGN_STOP_SUCCESS_MSG = 'Stop successfully assigned to %s'
  static ASSIGN_TO = 'Assign to'
  static ASSIGN_TO_ROUTE = 'Assign to route'
  static ASSIGN_TO_ROUTE_BY_NEAREST_STOP = 'Assign to a route by Nearest Stop'
  static ASSIGN_UNASSIGN_STOP = 'Assign/Unassign stop'
  static ASSOCIATED_BUSINESS_LINES = 'Associated business lines'
  static ASSOCIATED_WITH = 'Associated with:'
  static ASSOCIATED_WITH_LOCATIONS = 'Associated with {count} location{plural}'
  static ATTACHED_FILES = 'Attached files'
  static ATTACHMENTS = 'Attachments'
  static ATTACH_INVOICE = 'Attach invoice'
  static ATTENTION = 'Attention (ATTN:)'
  static ATTRIBUTES = 'Attributes'
  static AT_A_SPECIFIC_POSITION = 'At a specific position'
  static AT_LEAST_ONE_CONTAINER_REQUIRED = 'At least one container must be selected'
  static AT_LEAST_ONE_MATERIAL_REQUIRED = 'At least one material must be selected'
  static AT_LEAST_ONE_RECIPIENT_REQUIRED = 'At least one recipient is required'
  static AT_LEAST_ONE_SITE_REQUIRED = 'At least one site must be selected'
  static AUDIT = 'Audit'
  static AUTO = 'Auto'
  static AUTOMATED = 'Automated'
  static AUTOMATION = 'Automation'
  static AUTOPAY = 'Autopay'
  static AUTOPAY_CUTOFF_THRESHOLD = 'Failed payment cutoff'
  static AUTOPAY_CUTOFF_THRESHOLD_DESCRIPTION = 'Autopay is turned off for an account after this many consecutive failed autopay payments.'
  static AUTOPAY_EXPIRY = 'Autopay Expiry'
  static AUTOPAY_PAYMENT_CARD = 'Autopay Payment Card'
  static AUTOPAY_PAYMENT_METHOD = 'Autopay Payment Method'
  static AUTOPAY_PAYMENT_TYPE = 'Autopay Payment Type'
  static AUTO_COMPLETE = 'Auto-Complete'
  static AUTO_COMPLETED_VIA_GEOFENCE = 'Auto-completed via geofence'
  static AUTO_COMPLETE_CANCELLED = 'Auto-complete cancelled'
  static AUTO_COMPLETE_SNOOZED = 'Auto-complete snoozed'
  static AUTO_COMPLETE_STARTED = 'Auto-complete started'
  static AUTO_CONFIRMED = 'Auto-confirmed'
  static AUTO_LINK = 'Auto-Link'
  static AUTO_LINKED_SERVICES = 'Auto-Linked Service'
  static AVG = 'Avg'
  static AVOID = 'Avoid'
  static AVOIDS = 'Avoids'
  static AVOID_TURNS_HELP =
    'Soft: the optimizer takes an avoided turn only when there is no alternative. U-turns are caught at each stop, not mid-route.'
  static AVOID_U_TURNS = 'Avoid U-turns'
  static AVOID_U_TURNS_HELP = 'Catches U-turns at each stop, not mid-route. Best paired with Same-side approach for heavy trucks.'
  static BACK = 'Back'
  static BACK_TO_REGISTRATION = 'Back to SMS Registration'
  static BACK_TO_SERVICES = 'Back to services'
  static BACK_TO_TAXES = 'Back to taxes'
  static BALANCE = 'Balance'
  static BALANCE_DOLLARS = 'Balance ($)'
  static BALANCE_DUE = 'Balance due'
  static BANK_ACCOUNT_TYPE = 'Bank Account Type'
  static BAR_CODE = 'Barcode'
  static BASE_PRICE = 'Base price'
  static BASIC_INFO = 'Basic Information'
  static BASIC_SETTINGS = 'Basic settings'
  static BATCHES = 'Batches'
  static BATCH_COUNT = 'Batch count'
  static BATCH_DATE = 'Batch Date'
  static BATCH_ID = 'Batch ID'
  static BATCH_MUST_CONTAIN_AT_LEAST_ONE_PAYMENT = 'Batch must contain at least one payment'
  static BATCH_NOT_VALID_OR_NO_ID = 'Batch is not valid or does not have an ID.'
  static BATCH_NOT_VALID_OR_NO_PAYMENTS = 'Batch is not valid or does not have any payments.'
  static BATCH_NUMBER = 'Batch Number'
  static BATCH_PRINT = 'Batch print'
  static BEFORE = 'Before'
  static BENEFICIAL_OWNER = 'Beneficial owner'
  static BENEFICIAL_OWNER_ADDRESS = 'Beneficial owner address'
  static BENEFICIAL_OWNER_CONTACTS = 'Beneficial owner contacts'
  static BETA = 'Beta'
  static BETA_MSG = 'This feature is currently under beta. Have feedback? Let us know!'
  static BETA_NEW_CONFIGURED_SERVICES = 'Beta new configured services'
  static BILLED = 'Billed'
  static BILLED_DAYS_REFERENCE_DELETED_INVOICE = 'These days are still marked as billed. Contact support to correct them.'
  static BILLING = 'Billing'
  static BILLING_ADDRESS = 'Billing Address'
  static BILLING_ADDRESS_OVERRIDE = 'Payment address override'
  static BILLING_CONTACT = 'Billing contact'
  static BILLING_CONTACT_EMALIL_WARNING_MSG = 'At least one email needs to be set as a billing contact'
  static BILLING_CYCLE = 'Billing Cycle'
  static BILLING_DETAILS = 'Billing details'
  static BILLING_DETAILS_HIDDEN = "You don't have permission to view billing details"
  static BILLING_EMAIL = 'Billing email'
  static BILLING_END_DATE = 'Billing End Date'
  static BILLING_INFO = 'View the Billing tab'
  static BILLING_INVOICES = 'View all elements of invoices; edit and send these; create / delete these'
  static BILLING_LOCATION_DETAILS = 'Billing location details'
  static BILLING_LOCATION_NAME = 'Billing location name'
  static BILLING_LOCKED = 'Billing locked'
  static BILLING_LOCK_HISTORY = 'Billing lock history'
  static BILLING_LOCK_OR_INVOICED = 'Billing lock or Invoiced'
  static BILLING_NAME = 'Billing name'
  static BILLING_NAME_INFO =
    'If this value is blank, the Service Name will be printed on the invoice. If this value is populated, the Billing Name will be printed on the invoice.'
  static BILLING_NOTE = 'Billing note'
  static BILLING_NOTIFICATIONS = 'Billing notifications'
  static BILLING_PERIOD = 'Billing Period'
  static BILLING_PROFILE = 'Billing profile'
  static BILLING_PROFILES = 'Billing profiles'
  static BILLING_PROFILE_CHANGE_WARNING = 'Changing the billing profile will affect the current invoicing cycle'
  static BILLING_PROFILE_UPDATED_SUCCESSFULLY = 'Billing profile updated successfully'
  static BILLING_START_DATE = 'Billing Start Date'
  static BILLING_SUSPENSION = 'Billing suspension'
  static BILLING_SUSPENSION_DESCRIPTION = 'If turned on, the account will be prorated to the date the account was suspended'
  static BILLING_TIMING = 'Billing Timing'
  static BILLING_TYPE = 'Billing Type'
  static BILL_RENTAL_FEES_ON_INVOICE = 'Bill rental fees on invoice'
  static BILL_THEM = 'Bill them'
  static BIN_CLEANING = 'Bin Cleaning'
  static BLANK_EMAIL_MEANS_PRINTED_COPY = 'Blank → Receives printed copy'
  static BLOCKED = 'Blocked'
  static BOARD = 'Board'
  static BOARD_V2 = 'Advanced board'
  static BOARD_V2_ASSIGN_STOPS_ERROR = 'Could not assign stops. Please try again.'
  static BOARD_V2_ASSIGN_TO_ROUTE = 'Assign to route'
  static BOARD_V2_BULK_ACTIONS = 'Bulk actions'
  static BOARD_V2_BULK_ACTIONS_IDLE = 'Bulk actions'
  static BOARD_V2_BULK_ASSIGN = 'Bulk assign'
  static BOARD_V2_BULK_COMPLETE = 'Bulk complete'
  static BOARD_V2_BULK_MOVE = 'Bulk move'
  static BOARD_V2_BULK_UNASSIGN = 'Bulk unassign'
  static BOARD_V2_CHANGE_DAY = 'Change day'
  static BOARD_V2_CHANGE_DAY_ALREADY_SCHEDULED_ERROR =
    'A selected stop is already scheduled on %s. Check the routes not shown on the board.'
  static BOARD_V2_CHANGE_DAY_CONFIRM = 'Move %s stops'
  static BOARD_V2_CHANGE_DAY_CONFIRM_ONE = 'Move 1 stop'
  static BOARD_V2_CHANGE_DAY_ERROR = 'Could not move stops. Refresh the board and try again.'
  static BOARD_V2_COMPLETE_STOPS_ERROR = 'Could not complete stops. Please try again.'
  static BOARD_V2_COMPLETE_STOPS_SUCCESS = 'Stops marked complete'
  static BOARD_V2_CURRENT_ROUTE = 'Current route'
  static BOARD_V2_CUSTOMIZE_CARDS = 'Customize cards'
  static BOARD_V2_EST_TOOLTIP = 'Estimated time the driver will complete all remaining stops based on average speed and distance'
  static BOARD_V2_EXIT_BULK_MODE = 'Exit bulk mode'
  static BOARD_V2_FILTER_STOPS = 'Filter stops'
  static BOARD_V2_LANE_LOAD_FAILED = "Couldn't load this route's stops"
  static BOARD_V2_METRIC_LIFTS = 'Lifts'
  static BOARD_V2_METRIC_STOPS = 'Stops'
  static BOARD_V2_METRIC_YARDS = 'Yds'
  static BOARD_V2_MOVE_NONE_MOVABLE_ERROR =
    "None of the selected stops can move to %s — their service is already scheduled there, or their status isn't Scheduled, In Process, or Hold."
  static BOARD_V2_MOVE_SKIPPED_DUPLICATE_REASON = '%s already scheduled there'
  static BOARD_V2_MOVE_SKIPPED_INACTIVE_REASON = '%s not Scheduled, In Process, or Hold'
  static BOARD_V2_MOVE_SKIPPED_NO_SLOT_REASON = '%s that cannot be re-dated'
  static BOARD_V2_MOVE_SKIPPED_ROUTABLE_REASON = '%s with no work order to re-date'
  static BOARD_V2_MOVE_SKIPPED_ROUTABLE_STOPS = '%s disposal stops were not moved — drag them one at a time.'
  static BOARD_V2_MOVE_STOPS_CURRENT_DAY_SUCCESS = 'Stops moved to %s for the current day.'
  static BOARD_V2_MOVE_STOPS_ERROR = 'Could not move stops. Please try again.'
  static BOARD_V2_MOVE_STOPS_MASTER_ROUTE_SUCCESS = 'Stops moved to %s and its master route.'
  static BOARD_V2_MOVE_STOP_ERROR = 'Could not move stop. Please try again.'
  static BOARD_V2_MOVE_TARGET_DAY_LOOKUP_ERROR = 'Could not check %s for duplicate stops. Moving them anyway.'
  static BOARD_V2_MOVE_TO_DATE_HINT = 'Stops move to the selected date for that day only — recurring schedules are unchanged.'
  static BOARD_V2_MOVE_TO_DATE_PARTIAL_SUCCESS = 'Stops moved to %s — skipped %s.'
  static BOARD_V2_MOVE_TO_DATE_SUCCESS = 'Stops moved to %s'
  static BOARD_V2_NEXT_DAY = 'Next day'
  static BOARD_V2_NO_STOPS = 'No stops'
  static BOARD_V2_ORDER_ROUTES_BY = 'Order routes by:'
  static BOARD_V2_ORIGINAL_SERVICE_DATE = 'from %s'
  static BOARD_V2_ORIGINAL_SERVICE_DATE_TOOLTIP = 'Originally scheduled for %s'
  static BOARD_V2_PREVIOUS_DAY = 'Previous day'
  static BOARD_V2_PROGRESS_BETA_TOOLTIP =
    'Progress metrics are an estimate — completed/remaining distances and ETA are computed from straight-line distance and driver GPS, not live tracking.'
  static BOARD_V2_PROGRESS_COMPLETED = 'Completed'
  static BOARD_V2_PROGRESS_EST = 'Est'
  static BOARD_V2_PROGRESS_REMAINING = 'Remaining'
  static BOARD_V2_ROUTES_LOAD_FAILED = "Couldn't load this day's routes"
  static BOARD_V2_ROUTE_ACTIONS = 'Route actions'
  static BOARD_V2_SEARCH_INCOMPLETE = 'Still loading, so results may be incomplete.'
  static BOARD_V2_SEARCH_TRUNCATED = 'Over 50 results. Keep typing to narrow them.'
  static BOARD_V2_SEARCH_UNASSIGNED = 'Search unassigned stops'
  static BOARD_V2_SEARCH_WINDOW = 'Showing the stops around your search result while the rest of this route loads.'
  static BOARD_V2_SELECT_ROUTES = 'Select routes to display the board.'
  static BOARD_V2_SHOW_PROGRESS_METRICS = 'Progress metrics'
  static BOARD_V2_SORT_CUSTOM = 'Custom order'
  static BOARD_V2_SORT_FEWEST_STOPS = 'Fewest stops'
  static BOARD_V2_SORT_MOST_STOPS = 'Most stops'
  static BOARD_V2_SORT_NAME_ASC = 'Name (A–Z)'
  static BOARD_V2_SORT_NAME_DESC = 'Name (Z–A)'
  static BOARD_V2_SORT_UNASSIGNED = 'Sort unassigned stops'
  static BOARD_V2_STATUS_COMPLETE = 'Complete'
  static BOARD_V2_STATUS_INCOMPLETE = 'Incomplete'
  static BOARD_V2_STATUS_IN_PROGRESS = 'In Progress'
  static BOARD_V2_STATUS_NOT_STARTED = 'Not Started'
  static BOARD_V2_STOPS_SUFFIX = 'stops'
  static BOARD_V2_STOP_ACTIONS = 'Stop actions'
  static BOARD_V2_TARGET_DATE = 'Target date'
  static BOARD_V2_TOMORROW = 'Tomorrow'
  static BOARD_V2_TOMORROW_DISABLED_TOOLTIP = 'These stops are already on tomorrow'
  static BOARD_V2_UNASSIGNED = 'Unassigned'
  static BOARD_V2_UNASSIGNED_SORT_LOCATION_ASC = 'Location (A–Z)'
  static BOARD_V2_UNASSIGNED_SORT_LOCATION_DESC = 'Location (Z–A)'
  static BOARD_V2_UNASSIGNED_SORT_ORIGINAL_NEWEST = 'Original date (newest first)'
  static BOARD_V2_UNASSIGNED_SORT_ORIGINAL_OLDEST = 'Original date (oldest first)'
  static BOARD_V2_UNASSIGNED_SORT_WORK_ORDER = 'Work order #'
  static BOARD_V2_VIEW_ACCOUNT = 'View Account'
  static BOARD_V2_VIEW_ON_BOARD = 'View on board'
  static BOARD_V2_VIEW_VIDEOS = 'View videos'
  static BOARD_V2_VIEW_WORK_ORDER = 'View Work Order'
  static BODY = 'Body'
  static BOTH = 'Both'
  static BOTH_PASSWORDS_MATCH = 'Both passwords match'
  static BOTH_ROUTES_ON_THE_MAP = 'Both routes on the map'
  static BRANCH = 'Branch'
  static BRANCH_NAME = 'Branch name'
  static BRAND_ID = 'Brand ID'
  static BRAND_REGISTRATION = 'Brand Registration'
  static BRAND_RELATIONSHIP = 'Brand Relationship'
  static BROADCAST_PREFILL_EMPTY = 'No active accounts to message. Every account here is deactivated, so there is nobody to send to.'
  static BROADCAST_PREFILL_FAILED =
    "The list or group for this broadcast couldn't be loaded. Pick recipients below, or go back and try again."
  static BROWSE = 'browse'
  static BROWSER_NOT_SUPPORT_MAPBOX = 'Your browser does not support Mapbox GL | Please try to refresh/restart your browser'
  static BROWSE_AVAILABLE_NUMBERS = 'Browse available numbers'
  static BULK = 'Bulk'
  static BULK_ADD_TAGS_TO_ACCOUNTS_SUCCESS_MSG = 'Selected tags successfully added to the accounts'
  static BULK_ASSIGN = 'Bulk assign'
  static BULK_COMPLETE = 'Bulk complete'
  static BULK_EDIT = 'Bulk edit'
  static BULK_EDIT_APPLIED = 'Bulk edit applied'
  static BULK_EDIT_NOT_APPLIED = 'Bulk edit not applied'
  static BULK_EDIT_PARTIALLY_APPLIED = 'Bulk edit partially applied'
  static BULK_EDIT_TAXES = 'Bulk edit taxes'
  static BULK_INVOICE_CREATION = 'Bulk invoice creation'
  static BULK_MOVE = 'Bulk move'
  static BULK_MOVE_BETWEEN_DAYS = 'Temporary move between days'
  static BULK_MOVE_BETWEEN_DAYS_WEEKLY_ONLY = 'Currently, moving stops between dates is only supported for 1-6x weekly services.'
  static BULK_MOVE_CONFIRMATION = 'Bulk move confirmation'
  static BULK_MOVE_EXCEPTIONS = 'Bulk move exceptions'
  static BULK_MOVE_STOP_DATE_NOT_SUPPORTED = 'Cannot bulk move stop date.'
  static BULK_RESEND_UNPAID_INVOICES = 'Bulk resend unpaid invoices'
  static BULK_UNASSIGN = 'Bulk unassign'
  static BURDEN_RATE = 'Burden Rate'
  static BUSINESS_CONTACT_EMAIL = 'Business Contact Email'
  static BUSINESS_INFO = 'Business Information'
  static BUSINESS_LINE = 'Business line'
  static BUSINESS_LINES = 'Business lines'
  static BUSINESS_NAME = 'Business name'
  static BUSINESS_STREET_ADDRESS = 'Business Street Address'
  static BUSINESS_UNIT = 'Business unit'
  static BUSINESS_UNITS = 'Business units'
  static BUSINESS_UNITS_EMPTY_STATE =
    'Business units let one company run multiple businesses with separate payment processing accounts. Contact '
  static BUSINESS_UNITS_LOAD_ERROR = 'Unable to load business units. Refresh and try again.'
  static BUSINESS_UNIT_NAME = 'Business unit name'
  static BUSINESS_WEBSITE = 'Business Website'
  static BY = 'by'
  static BY_ACTIVITY = 'By activity'
  static BY_ROUTE_TITLE = 'By route'
  static BY_TYPE = 'By type'
  static CALCULATE_SERVICE_PRICE_FROM_CONTAINER_COUNT = 'Calculate service price from container count'
  static CALENDAR_ICONS = 'Calendar icons'
  static CALENDAR_ICONS_DESCRIPTION = 'Each icon represents something on the work order for that day'
  static CALENDAR_LEGEND = 'Calendar legend'
  static CALENDAR_SAVE_MESSAGE = 'Saving changes...'
  static CALLS = 'Calls'
  static CALL_NOTE = 'Call Note'
  static CAMERA = 'Camera'
  static CAMPAIGN_ATTRIBUTES_SECTION = 'Campaign Attributes'
  static CAMPAIGN_DESCRIPTION = 'Campaign Description'
  static CAMPAIGN_DETAILS_SECTION = 'Campaign Details'
  static CAMPAIGN_FEATURES = 'Campaign Features'
  static CAMPAIGN_ID = 'Campaign ID'
  static CAMPAIGN_NAME = 'Campaign Name'
  static CAMPAIGN_REGISTRATION = 'Campaign Registration'
  static CAMPAIGN_STATUS_DCA_APPROVAL_PENDING = 'Awaiting Carrier Acceptance'
  static CAMPAIGN_STATUS_NUMBER_PENDING = 'Ready for Number'
  static CAMPAIGN_VALIDATION_FAILED = 'Campaign validation failed'
  static CANCEL = 'Cancel'
  static CANCELLED = 'Cancelled'
  static CANCELLED_DESCRIPTION =
    'The work order has been permanently removed and will not be serviced. This is a user-initiated action to remove a specific work order.'
  static CANCELLING_IMPORT = 'Cancelling import...'
  static CANCEL_AND_MARK_NOT_READY = 'Cancel & mark not ready'
  static CANCEL_DEACTIVATION = 'Cancel deactivation'
  static CANCEL_EDIT = 'Cancel Edit'
  static CANCEL_IMPORT = 'Cancel import'
  static CANCEL_LEAVES_SERVICE_EMPTY = 'The service is left with no container.'
  static CANCEL_PLACEMENT = 'Cancel delivery'
  static CANCEL_PLACEMENT_TITLE = 'Cancel delivery?'
  static CANNOT_BE_EMPTY = 'Cannot be empty'
  static CANNOT_BE_ZERO = 'Cannot be zero'
  static CANNOT_CHANGE_BILLED_DAYS = 'Days already billed on these invoices cannot be changed.'
  static CANNOT_DELETE_PERIOD_WITH_BILLED_CHARGES = 'Cannot delete a rental period that has billed charges.'
  static CANNOT_DELETE_PERIOD_WITH_FINALIZED_CHARGES = 'Cannot delete a rental period that has posted or paid charges.'
  static CANNOT_DELETE_RENTAL_FEE_WITH_BILLED_CHARGES = 'Cannot remove a rental fee with billed charges.'
  static CANNOT_DELETE_WO_HAS_DISPOSAL_OR_EXCEPTIONS = 'Events with disposal tickets or exceptions cannot be deleted'
  static CANNOT_DELETE_WO_INVOICED = 'Events with an invoiced work order cannot be deleted'
  static CANNOT_DELETE_WO_SERVICED_OR_SKIPPED = 'Events with a Serviced or Skipped work order cannot be deleted'
  static CANNOT_MODIFY_BILLED_PERIOD_DATES = 'Cannot modify dates that affect already billed charges.'
  static CANNOT_MOVE_BETWEEN_DAYS = 'Cannot move between days'
  static CANNOT_MOVE_STOP_TO_DAY = 'Cannot move stop to %s.'
  static CANNOT_SELECT_MULTIPLE_FEES_SAME_MATERIAL = 'You cannot select multiple fees that include the same material'
  static CANT_DEACTIVATE_LOCATION = 'Cannot deactivate, this location has active services'
  static CANT_REMOVE_PAST_SERVICED_INVOICED_EVENTS = 'Cannot remove an event that was serviced or invoiced'
  static CAPACITY_EXCEEDED_WARNING = 'Estimated load exceeds capacity — a disposal stop may be needed.'
  static CAPACITY_SET_IN_ROUTE_DETAILS = 'Capacity + truck are set in Route & Truck details.'
  static CAPTURE = 'Capture'
  static CAPTURE_ADDED_TO_EVIDENCE = 'Capture added to evidence'
  static CAPTURE_FAILED = 'Could not capture this frame'
  static CARDHOLDER_NAME = 'Cardholder Name'
  static CARD_ATTR_BILLING_ADDRESS = 'Billing address'
  static CARD_ATTR_CONTAINERS = 'Container IDs'
  static CARD_ATTR_GROUP_ACTIONS = 'Actions & attachments'
  static CARD_ATTR_GROUP_HEADER = 'Header'
  static CARD_ATTR_GROUP_TOGGLE_HINT = 'Toggle a section header to show or hide that whole row on the card.'
  static CARD_ATTR_IMAGES = 'Images'
  static CARD_ATTR_MATERIALS = 'Materials'
  static CARD_ATTR_OVERFLOW_MENU = 'Actions menu'
  static CARD_ATTR_TIME_STAMP = 'Time stamp'
  static CARD_ATTR_UNASSIGN_ICON = 'Unassign icon'
  static CARD_ATTR_VIDEO = 'Video'
  static CARD_ATTR_WORK_ORDER = 'Work order #'
  static CARD_VIEW = 'Card view'
  static CART = 'Cart'
  static CASH = 'Cash'
  static CATEGORY = 'Category'
  static CC = 'CC'
  static CHANGE = 'Change'
  static CHANGED_STOPS = 'Changed stops'
  static CHANGE_ACCOUNT_REP = 'Change account rep'
  static CHANGE_BACK_TO_DRAFT = 'Revert back to draft'
  static CHANGE_BILLING_PROFILE = 'Change billing profile'
  static CHANGE_BUSINESS_LINES_ALERT =
    'By changing Business Line, the Measure, Materials, Specific Days, Method, Recurrence, Action, and Pricing Zones fields will be reset. Proceed?'
  static CHANGE_COMPANY_LOGO = 'Change company logo'
  static CHANGE_CONTAINER_LOCATION = 'Change container location'
  static CHANGE_DATE = 'Change date'
  static CHANGE_DATE_ON_INVOICED_WORK_ORDERS = 'Change date on invoiced work orders'
  static CHANGE_DATE_ON_INVOICED_WORK_ORDERS_INFO =
    'Edit the service date on on-request work orders that are already on an invoice. Recurring work orders are editable without it; serviced ones stay locked.'
  static CHANGE_DISPOSAL_FEE = 'Change Disposal Fee'
  static CHANGE_FEE = 'Change Fee'
  static CHANGE_GENERAL_FEE = 'Change General Fee'
  static CHANGE_INDIVIDUAL_PERMISSIONS = 'Change Individual Permissions'
  static CHANGE_PASSWORD = 'Change Password'
  static CHANGE_PAYMENT_TERMS = 'Change payment terms'
  static CHANGE_RECURRENCE = 'Change recurrence'
  static CHANGE_ROUTE_AND_SEQUENCE = 'Change route & sequence'
  static CHANGE_ROUTE_SEQUENCE = 'Change route sequence'
  static CHANGE_SERVICE = 'Change Service'
  static CHANGE_TAX = 'Change Tax'
  static CHANGE_TYPE = 'Change type'
  static CHANGE_WORK_ORDER_STATUS = 'Change work order status'
  static CHANGING_RECURRENCE_DOES_NOT_UPDATE_PRICING =
    'Changing the recurrence does not update pricing. Please review pricing before saving.'
  static CHANNEL = 'Channel'
  static CHARACTERS = 'Characters'
  static CHECK = 'Check'
  static CHECK_MASTER_SEQUENCE_TO_REVIEW_CHANGES = 'Check the master sequence to review the changes'
  static CHECK_NUMBER = 'Check number'
  static CHECK_NUMBER_OTHER = 'For "Other" payment types, use this field to capture payment ID information.'
  static CHECK_NUMBER_PLACEHOLDER = 'Check number'
  static CHECK_NUMBER_REQUIRED_FOR_CHECK_PAYMENTS = 'Check number is required for check payments'
  static CHECK_YOUR_EMAIL = 'Check your email'
  static CHOOSE_A_DIFFERENT_IMAGE = 'Choose a different image'
  static CHOOSE_A_NUMBER = 'Choose a Number'
  static CHOOSE_A_NUMBER_DISABLED_TOOLTIP = 'A campaign must be approved before provisioning a number'
  static CHOOSE_A_NUMBER_TOOLTIP = 'Search and provision a phone number'
  static CHOOSE_A_PHONE_NUMBER = 'Choose a Phone Number'
  static CHOOSE_NUMBER_CTA = 'Choose a phone number to start sending SMS from the selected campaign.'
  static CHOOSE_NUMBER_DESCRIPTION = 'Pick a 10DLC number from our inventory so your approved campaign can send SMS.'
  static CHOOSE_PLACEHOLDER = 'Choose…'
  static CHOOSE_SUB_USE_CASES = 'Choose sub use cases\u2026'
  static CHOOSE_VALUES = 'Choose values'
  static CITY = 'City'
  static CITY_STATE_ZIP = 'City, state, zip'
  static CLEAR = 'Clear'
  static CLEARS_THE_VALUES_PICKED_FOR_THIS_CONDITION = 'clears the values picked for this condition'
  static CLEAR_ALL = 'Clear all'
  static CLEAR_END_DATE = 'Clear end date'
  static CLEAR_PICKED_VALUES_TITLE = 'Clear the picked values?'
  static CLEAR_SEARCH = 'Clear search'
  static CLEAR_SELECTION = 'Clear selection'
  static CLEAR_SORT = 'Clear sort'
  static CLEAR_START_DATE = 'Clear start date'
  static CLEAR_VALUES = 'Clear values'
  static CLICK_PLUS_BUTTON_ABOVE_TO_ADD_A_DISPOSAL_FEE = 'Click + button above to add a disposal fee'
  static CLICK_PLUS_BUTTON_ABOVE_TO_ADD_A_RENTAL_FEE = 'Click + button above to add a rental fee'
  static CLICK_PLUS_BUTTON_ABOVE_TO_ADD_DISPOSAL_SITE = 'Click + button above to add a disposal site'
  static CLICK_PLUS_BUTTON_ABOVE_TO_ADD__CONTAINER_TYPE = 'Click + button above to add a container type'
  static CLOSE = 'Close'
  static CLOSE_ARIA_LABEL = 'close'
  static CLUSTER_BREAKDOWN = 'Cluster breakdown'
  static CLUSTER_PERFORMANCE_WARNING =
    "The action you are about to perform may slow down the system, loading the route view may take a few minutes. Additionally, the map's performance may be slower depending on the number of stops."
  static CLUSTER_ZOOM_LEVEL = 'Cluster zoom level'
  static CLUSTER_ZOOM_TOOLTIP =
    'Adjusting the zoom level determines when stops are grouped into clusters. Higher zoom levels keep stops grouped longer (deeper zoom), while lower levels split them into individual stops sooner.'
  static COLLAPSE = 'Collapse'
  static COLLAPSE_ALL = 'Collapse all'
  static COLLAPSE_GROUP = 'Collapse group'
  static COLLECTED_REVENUE = 'Collected revenue'
  static COLLECTION = 'Collection'
  static COLLECTION_METHOD_ROLL_OFF_HELP =
    'Roll-off runs one can per trip — the optimizer orders drop / swap / pickup legs, not a curb side.'
  static COLLECTION_METHOD_SIDE_HELP =
    'Side-load trucks service the right / service-address curb — the optimizer keeps stops on the approach side.'
  static COLOR = 'Color'
  static COLOR_SCHEME = 'Color Scheme'
  static COLUMN = 'Column'
  static COMFORTABLE = 'Comfortable'
  static COMING_SOON = 'Coming soon'
  static COMMERCIAL = 'Commercial'
  static COMMERCIAL_DRIVER_LICENSE = "Commercial Driver's License"
  static COMMON_CONFIRM_TITLE = 'Are you sure you want to close? Any data entered will be lost.'
  static COMPACT = 'Compact'
  static COMPACTOR = 'Compactor'
  static COMPACT_LAYOUT_DESCRIPTION = 'More compact layout — lower paper cost (~$115/1,000 sheets)'
  static COMPANY = 'Company'
  static COMPANY_EMAIL = 'Company email'
  static COMPANY_EMAIL_REQUIRED = 'Company email is required'
  static COMPANY_LOGO = 'Company logo'
  static COMPANY_TYPE = 'Company Type'
  static COMPETITOR = 'Competitor'
  static COMPETITORS = 'Competitors'
  static COMPETITORS_DESCRIPTION = 'Shown when a win or loss is attributed to a competitor.'
  static COMPETITORS_LOAD_ERROR = 'Unable to load competitors. Refresh and try again.'
  static COMPETITOR_DELETED_SUCCESSFULLY = 'Competitor deleted successfully'
  static COMPETITOR_IN_USE_DEACTIVATE_INSTEAD = 'This competitor is used on existing accounts and cannot be deleted. Deactivate it instead?'
  static COMPLETE = 'Complete'
  static COMPLETED = 'Completed'
  static COMPLETED_AT = 'Completed at'
  static COMPLETED_BY_COMPLETION_TIME = 'Completed · by completion time'
  static COMPLETED_DAY_OPTIONS = 'Completed day options'
  static COMPLETED_ROUTES_SERVICED = 'Completed · routes serviced'
  static COMPLETED_VIA_VISION = 'Completed via Vision'
  static COMPLETION_STATUS = 'Completion status'
  static COMPLIANCE_AUTO_REPLY_NOTE =
    'We auto-send carrier-approved opt-in, opt-out, and help replies. Override below only if you need custom copy.'
  static COMPLIANCE_LINKS_SECTION = 'Compliance Links'
  static COMPLIANCE_NOT_PERSISTED_NOTE =
    'Customizations entered here are not yet persisted across page reloads. The carrier-approved defaults will be applied at TCR submission time. (Backend follow-up in progress.)'
  static COMPLIANCE_OVERRIDE_WARNING = 'Custom compliance text may delay or block carrier approval. Leave a field blank to use the default.'
  static COMPLIANCE_PRIVACY_POLICY_MISSING_WARNING =
    "Don't have a privacy policy? Add a public privacy policy page before submitting registration."
  static COMPLIANCE_TCR_REQUIREMENT_INFO =
    'TCR requires publicly accessible pages covering SMS consent, data use, and opt-out instructions.'
  static CONCIERGE = 'Concierge'
  static CONDITION = 'Condition'
  static CONDITIONS_NEED_VALUES = 'conditions need values'
  static CONDITIONS_SUPPORT_UP_TO = 'Conditions support up to'
  static CONDITION_DIMENSION = 'Condition dimension'
  static CONDITION_NEEDS_VALUES = 'condition needs values'
  static CONDITION_OPERATOR = 'Condition operator'
  static CONFIDENCE = 'Confidence'
  static CONFIGURED_SERVICE = 'Configured Service'
  static CONFIGURED_SERVICES = 'Configured services'
  static CONFIGURED_SERVICE_NOTE = 'Configured service note'
  static CONFIGURED_SERVICE_PRICE = 'Configured Service Price'
  static CONFIGURED_SERVICE_PRICE_INFO =
    'Allows editing and saving changes to the price on configured services, as well as editing fees or taxes at the level of the individual customer/service.'
  static CONFIRM = 'Confirm'
  static CONFIRMATION = 'Confirmation'
  static CONFIRMATION_RATE = 'Confirmation rate'
  static CONFIRMED = 'Confirmed'
  static CONFIRMED_BY_HEADER = 'Confirmed by'
  static CONFIRMS_VS_REJECTS_BY_TYPE = 'Confirmations vs Rejections by Type'
  static CONFIRM_ALL_MATCHES = 'Confirm all matches'
  static CONFIRM_BULK_ACCOUNT_NOTE_TITLE = 'Confirm bulk add account note'
  static CONFIRM_BULK_BILLING_NOTE_TITLE = 'Confirm bulk add billing note'
  static CONFIRM_BULK_BILLING_PROFILE_TITLE = 'Confirm change billing profile'
  static CONFIRM_BULK_PRORATION_START = 'You’re about to turn'
  static CONFIRM_BULK_RENTAL_FEE_TITLE = 'Confirm Rental fee invoicing'
  static CONFIRM_BULK_RESEND_TITLE = 'Confirm resend unpaid invoices'
  static CONFIRM_BULK_TAGS_TITLE = 'Confirm add account tags'
  static CONFIRM_DELETE = 'Confirm Delete'
  static CONFIRM_DETECTION = 'Confirm detection'
  static CONFIRM_EXCEPTION = 'Confirm exception'
  static CONFIRM_EXCEPTION_DELETION = 'Confirm exception deletion'
  static CONFIRM_GROUP_ACCOUNT_NOTE =
    "You're about to add an account note to every account in this group. Currently, there is no way to bulk remove notes. Are you sure you want to proceed?"
  static CONFIRM_GROUP_BILLING_NOTE =
    "You're about to add a billing note to every account in this group. Currently, there is no way to bulk remove notes. Are you sure you want to proceed?"
  static CONFIRM_GROUP_BILLING_PROFILE =
    "You're about to change the billing profile for every account in this group, are you sure you want to proceed?"
  static CONFIRM_GROUP_PRORATION_END = 'suspension proration for every account in this group, are you sure you want to proceed?'
  static CONFIRM_GROUP_RENTAL_FEE =
    "You're about to change Rental fee invoicing for every account in this group. Are you sure you want to proceed?"
  static CONFIRM_GROUP_TAGS =
    "You're about to add account tags to all accounts in this group. This will not affect existing tags on accounts. Are you sure you want to proceed?"
  static CONFIRM_HOLD_DELETION = 'Confirm hold deletion'
  static CONFIRM_IMPORT = 'Confirm import'
  static CONFIRM_LIST_ACCOUNT_NOTE =
    "You're about to add an account note to every account in this list. Currently, there is no way to bulk remove notes. Are you sure you want to proceed?"
  static CONFIRM_LIST_BILLING_NOTE =
    "You're about to add a billing note to every account in this list. Currently, there is no way to bulk remove notes. Are you sure you want to proceed?"
  static CONFIRM_LIST_BILLING_PROFILE =
    "You're about to change the billing profile for every account in this list, are you sure you want to proceed?"
  static CONFIRM_LIST_PRORATION_END = 'suspension proration for every account in this list, are you sure you want to proceed?'
  static CONFIRM_LIST_RENTAL_FEE =
    "You're about to change Rental fee invoicing for every account in this list. Are you sure you want to proceed?"
  static CONFIRM_LIST_RESEND = "You're about to resend the unpaid invoices of every account in this list. Are you sure you want to proceed?"
  static CONFIRM_LIST_TAGS =
    "You're about to add account tags to all accounts in this list. This will not affect existing tags on accounts. Are you sure you want to proceed?"
  static CONFIRM_MARK_AS_SENT_BULK_ACTION_DESCRIPTION = 'invoices are being marked as sent. Please check back later.'
  static CONFIRM_MARK_AS_SENT_BULK_ACTION_TITLE = 'Marking as sent'
  static CONFIRM_MARK_AS_SENT_INDIVIDUAL_ACTION_DESCRIPTION = 'The invoice is being marked as sent.'
  static CONFIRM_MARK_AS_SENT_INDIVIDUAL_ACTION_TITLE = 'Marking as sent'
  static CONFIRM_POST_AND_SEND_BULK_ACTION_DESCRIPTION = 'invoices are being posted and sent. Please check back later.'
  static CONFIRM_POST_AND_SEND_BULK_ACTION_TITLE = 'Posting and sending invoices'
  static CONFIRM_POST_AND_SEND_INDIVIDUAL_ACTION_DESCRIPTION = 'The invoice is being posted and sent. This may take a minute.'
  static CONFIRM_POST_AND_SEND_INDIVIDUAL_ACTION_TITLE = 'Posting and sending invoice'
  static CONFIRM_PROCESS_RENTAL_FEE_DATES = 'Confirm Process Rental Fee Dates'
  static CONFIRM_RATE_BY_SOURCE = 'Confirm Rate by Source'
  static CONFIRM_REGENERATION_BULK_ACTION_DESCRIPTION =
    'invoices are being regenerated. This will take a few minutes. Please check back and refresh later.'
  static CONFIRM_REGENERATION_BULK_ACTION_TITLE = 'Regenerating invoices'
  static CONFIRM_REGENERATION_INDIVIDUAL_ACTION_DESCRIPTION =
    'The invoice is being regenerated. This may take a minute. Please check back and refresh later.'
  static CONFIRM_REGENERATION_INDIVIDUAL_ACTION_TITLE = 'Regenerating invoice'
  static CONFIRM_REQUIRED_TO_CONTINUE = 'Required before you can continue to the next step.'
  static CONFIRM_ROUTE_DELETION = 'Confirm route deletion'
  static CONFIRM_SAMPLE_MESSAGES =
    'I confirm these sample messages accurately represent actual SMS I will send to customers \u2014 they are not placeholder or generic text.'
  static CONFIRM_SELECTED = 'Confirm selected'
  static CONFIRM_SEND_INVOICES_BULK_ACTION_DESCRIPTION = 'invoices are being sent. Please check back later.'
  static CONFIRM_SEND_INVOICES_BULK_ACTION_TITLE = 'Sending invoices'
  static CONFIRM_SEND_INVOICES_INDIVIDUAL_ACTION_DESCRIPTION = 'The invoice is being sent. This may take a minute.'
  static CONFIRM_SEND_INVOICES_INDIVIDUAL_ACTION_TITLE = 'Sending invoice'
  static CONFIRM_SEND_UNPAID_INVOICES_BULK_ACTION_DESCRIPTION = 'unpaid invoices are being sent. Please check back later.'
  static CONFIRM_SEND_UNPAID_INVOICES_BULK_ACTION_TITLE = 'Sending unpaid invoices'
  static CONFIRM_SEND_UNPAID_INVOICES_INDIVIDUAL_ACTION_DESCRIPTION = 'The unpaid invoice is being sent. This may take a minute.'
  static CONFIRM_SEND_UNPAID_INVOICES_INDIVIDUAL_ACTION_TITLE = 'Sending unpaid invoice'
  static CONFIRM_UPDATE_RENTAL_FEE_PRICE_DESCRIPTION =
    "You've selected to apply the new pricing to all customers that have this rental fee. Do you want to continue?"
  static CONFIRM_UPDATE_RENTAL_FEE_PRICE_TITLE = 'Update rental fee pricing'
  static CONTACT = 'Contact'
  static CONTACTS = 'Contacts'
  static CONTACT_ACTIVATE_SUCCESS = 'Contact activated successfully'
  static CONTACT_ADDED_SUCCESS = 'Contact added successfully'
  static CONTACT_DEACTIVATE_SUCCESS = 'Contact deactivated successfully'
  static CONTACT_DETAILS = 'Contact Details'
  static CONTACT_EMAIL = 'Contact Email'
  static CONTACT_EMAILS = 'Contact emails'
  static CONTACT_FIELDS = 'Contact fields'
  static CONTACT_FIRST_NAME = 'Contact first name'
  static CONTACT_LAST_NAME = 'Contact last name'
  static CONTACT_METHOD = 'Contact Method'
  static CONTACT_METHODS = 'Contact Methods'
  static CONTACT_NAME = 'Contact Name'
  static CONTACT_PHONE = 'Contact Phone'
  static CONTACT_PHONE_NUMBER = 'Contact phone number'
  static CONTACT_SUPPORT_IF_PERSISTS = 'If the problem persists, contact support.'
  static CONTACT_UPDATED_SUCCESS = 'Contact updated successfully'
  static CONTAINER = 'Container'
  static CONTAINERS = 'Containers'
  static CONTAINERS_ADDED_SUCCESSFULLY = 'Containers added successfully'
  static CONTAINERS_ADDED_TO_CONFIGURED_SERVICE_SUCCESSFULLY = 'Containers added to configured service successfully'
  static CONTAINERS_ASSIGNED_TO_WORK_ORDER_SUCCESSFULLY = 'Containers assigned to work order successfully'
  static CONTAINERS_COME_OFF_SERVICE = 'containers come off this service'
  static CONTAINERS_CREATED_SUCCESSFULLY = 'Containers created successfully'
  static CONTAINERS_DELETED_SUCCESSFULLY = 'Containers deleted successfully'
  static CONTAINERS_HAVE_DIFFERENT_STATUSES = 'Containers have different statuses'
  static CONTAINERS_LOAD_FAILED = 'Unable to load containers'
  static CONTAINERS_ON_SITE = 'containers on site.'
  static CONTAINERS_REMOVED = 'Containers removed'
  static CONTAINERS_RESOLVED = 'Containers resolved'
  static CONTAINERS_UNRESOLVED = 'containers unresolved'
  static CONTAINERS_UPDATED_SUCCESSFULLY = 'Containers updated successfully'
  static CONTAINERS_WILL_NEED_RESOLVING = 'will need resolving after the run; nothing is removed automatically.'
  static CONTAINER_ADDED_SUCCESSFULLY = 'Container added successfully'
  static CONTAINER_ASSIGNED_SUCCESSFULLY = 'Container assigned successfully'
  static CONTAINER_COLOR = 'Container color'
  static CONTAINER_COLORS = 'Container colors'
  static CONTAINER_COLOR_NAME_EXISTS = 'A container color with that name already exists'
  static CONTAINER_COMES_OFF_SERVICE = 'container comes off this service'
  static CONTAINER_CREATED_SUCCESSFULLY = 'Container created successfully'
  static CONTAINER_DELETED_SUCCESSFULLY = 'Container deleted successfully'
  static CONTAINER_DELIVERY_TRUCK = 'Container Delivery'
  static CONTAINER_DESCRIPTION = 'Container description'
  static CONTAINER_DETAIL = 'Container Detail'
  static CONTAINER_DETAILS = 'Container details'
  static CONTAINER_ID = 'Container ID'
  static CONTAINER_IMPORT_UNRESOLVED_VALUE = 'This value could not be recognized for this field, so it will not be imported'
  static CONTAINER_LOCATION = 'Container location'
  static CONTAINER_NAME = 'Container name'
  static CONTAINER_NAME_SIZE_TYPE_SERIAL = 'Container — name · size · type · serial'
  static CONTAINER_NO_MEASURE_DESCRIPTION = 'This container has no size/measure set. You can add one now, or save without it.'
  static CONTAINER_NO_MEASURE_TITLE = 'No size/measure selected'
  static CONTAINER_OFFSET = 'Container offset (m)'
  static CONTAINER_OFFSET_TOOLTIP = "Rings a stop's containers out around its pin so they don't stack on the stop marker."
  static CONTAINER_ON_SITE = 'container on site.'
  static CONTAINER_OWNERSHIP = 'Container ownership'
  static CONTAINER_RECORD_UPDATED = 'Container record updated'
  static CONTAINER_RECORD_UPDATE_FAILED = 'Confirmed, but the container record could not be updated'
  static CONTAINER_REMOVED_FROM_WO = 'Container removed from this work order'
  static CONTAINER_RESTORED_TO_WO = 'Container restored to this work order'
  static CONTAINER_STATUS = 'Container status'
  static CONTAINER_TYPE = 'Container type'
  static CONTAINER_TYPES = 'Container types'
  static CONTAINER_TYPE_CREATED_SUCCESSFULLY = 'Container type created successfully'
  static CONTAINER_TYPE_DELETED_SUCCESSFULLY = 'Container type deleted successfully'
  static CONTAINER_TYPE_FRONT_LOAD = 'Front-load'
  static CONTAINER_TYPE_REAR_LOAD = 'Rear-load'
  static CONTAINER_TYPE_UPDATED_SUCCESSFULLY = 'Container type updated successfully'
  static CONTAINER_UNASSIGNED_SUCCESSFULLY = 'Container unassigned from service'
  static CONTAINER_UNRESOLVED = 'container unresolved'
  static CONTAINER_UPDATED_SUCCESSFULLY = 'Container updated successfully'
  static CONTAINS = 'contains'
  static CONTAMINATION = 'Contamination'
  static CONTINUE = 'Continue'
  static CONTINUE_TO_SERVICE_AND_BILLING = 'Continue to Service & Billing'
  static CONTRACT_EXPIRATION = 'Contract expiration'
  static CONTROL_PANEL_TITLE = 'Control panel'
  static CONVERT_TO_PLACEHOLDER = 'Convert to pending delivery'
  static COPIED_TO_CLIPBOARD = 'Copied to clipboard'
  static COPY = 'Copy'
  static COPY_CONTAINER_FIELD_OVERWRITE_WARNING = 'This overwrites the existing value on each container and cannot be undone.'
  static COPY_CONTAINER_NAME_TO_SERIAL_NUMBER = 'Copy container name to serial number'
  static COPY_COORDINATES = 'Copy coordinates'
  static COPY_CUSTOMER_NAME_TO_CONTACT_NAME = 'Copy customer name to contact name'
  static COPY_SERIAL_NUMBER_TO_CONTAINER_NAME = 'Copy serial number to container name'
  static COPY_TO_EMAIL = 'Copy to Email'
  static COPY_TO_SMS = 'Copy to SMS'
  static COPY_UNIQUE_INVITE_URL = 'Copy unique invite URL'
  static COPY_UNIQUE_PORTAL_URL = 'Copy unique portal URL'
  static COST = 'Cost'
  static COST_PLUS = 'Cost Plus'
  static COULD_NOT_BE_UPDATED = 'could not be updated'
  static COULD_NOT_LOAD_ACTIVITY_FOR = 'Could not load activity for'
  static COULD_NOT_OPTIMIZE = 'Could not optimize'
  static COUNTRY = 'Country'
  static COURTESY = 'Courtesy'
  static CREATE = 'Create'
  static CREATED = 'Created'
  static CREATED_AT_HEADER = 'Created at'
  static CREATED_BY_EMAIL = 'Created by email'
  static CREATED_BY_HEADER = 'Created by'
  static CREATED_DATE = 'Created date'
  static CREATED_ON = 'Created on'
  static CREATES_A_NEW_UNIT_IN_INVENTORY = 'Creates a new unit in inventory.'
  static CREATE_ACCOUNT = 'Create account'
  static CREATE_AND_SENT = 'Create & send'
  static CREATE_A_NEW_CUSTOMER = 'Create a new customer'
  static CREATE_BRANCH = 'Create branch'
  static CREATE_CAMPAIGN_DRAFT = 'Create Draft'
  static CREATE_CAMPAIGN_FAILURE_MSG = 'Failed to create campaign draft'
  static CREATE_CAMPAIGN_SUCCESS_MSG = 'Campaign draft created'
  static CREATE_CONFIGURE = 'Create Configure'
  static CREATE_CONTACT = 'Create Contact'
  static CREATE_CONTAINER = 'Create container'
  static CREATE_DISPOSAL_FEE = 'Create Disposal Fee'
  static CREATE_DRAFT = 'Create draft'
  static CREATE_DRAFT_INVOICES = 'Create draft invoices'
  static CREATE_FEE = 'Create Fee'
  static CREATE_FIRST_TAX = 'Create your first tax to get started.'
  static CREATE_GROUP = 'Create group'
  static CREATE_INVOICE = 'Create invoice'
  static CREATE_INVOICES = 'Create Invoices'
  static CREATE_INVOICE_TABLE_REQUIRED_MSG = 'Please select a Customer Billing Profile and Billing Period to see data'
  static CREATE_LATE_FEE_DIALOG = 'Create late fee'
  static CREATE_LATE_FEE_INVOICE = 'Create late fee invoice'
  static CREATE_MANUAL_INVOICE = 'Create manual invoices'
  static CREATE_NEW = 'Create new'
  static CREATE_NEW_BATCH = 'Create new batch'
  static CREATE_NEW_GROUP = 'Create new group'
  static CREATE_NOTE = 'Create note'
  static CREATE_N_CONFIGURE = 'Create & Configure'
  static CREATE_PASSWORD_TITLE = 'Create password'
  static CREATE_PAYMENT_TERMS = 'Create payment terms'
  static CREATE_RECURRING_INVOICES = 'Create recurring invoices'
  static CREATE_RENTAL_FEE_DIALOG = 'Create rental fee'
  static CREATE_REPORT = 'Create Report'
  static CREATE_SERVICES = 'Create Services'
  static CREATE_STATEMENT = 'Create statement'
  static CREATE_STOP = 'Create stop'
  static CREATE_TAX = 'Create tax'
  static CREATE_USER_INFO = 'Create a user or modify user information & assign users to roles'
  static CREATING = 'Creating...'
  static CREATING_DRAFT = 'Creating…'
  static CREATING_DRAFT_FOR = 'Creating draft for'
  static CREATING_PAYMENTS_FROM_CSV_DATA = 'Creating payments from CSV data...'
  static CREDIT = 'Credit'
  static CREDIT_CARD = 'Credit Card'
  static CREDIT_CARD_MENU = 'Credit card'
  static CREDIT_LIMIT = 'Credit limit'
  static CREDIT_LIMIT_HISTORY = 'Credit limit history'
  static CREDIT_LIMIT_SUSPENSION = 'Credit limit exceeded'
  static CREDIT_MEMO = 'credit memo'
  static CSV_HEADER_MAPPING_INFO = 'Use the dropdown headers to map CSV columns to Payment Batch fields.'
  static CSV_HEADER_MAPPING_TITLE = 'Column Mapping & Data Preview'
  static CURRENT = 'Current'
  static CURRENT_ASSIGNMENT = 'Current assignment'
  static CURRENT_DAY = 'Current day'
  static CURRENT_LOCATION = 'Current location'
  static CURRENT_MONTH = 'Current Month'
  static CURRENT_NOT_ON_FILE = 'Not on file'
  static CURRENT_PWD_INCORRECT = 'The current password you entered is incorrect. Please try again.'
  static CURRENT_ROUTE = 'Current route'
  static CURRENT_ROUTE_ON_THE_MAP = 'Current route on the map'
  static CURRENT_SEQUENCE = 'Current sequence'
  static CURRENT_VS_PROPOSED = 'Current vs Proposed'
  static CUSTOM = 'Custom'
  static CUSTOMER = 'Customer'
  static CUSTOMERS = 'Customers'
  static CUSTOMERS_LOWER = 'customers'
  static CUSTOMERS_SHORT = "Customer's"
  static CUSTOMER_ADDRESS = 'Customer Address'
  static CUSTOMER_BILLING_PROFILE = 'Customer Billing Profile'
  static CUSTOMER_BILLING_PROFILE_DELETED_SUCCESS = 'Customer billing profile deleted successfully'
  static CUSTOMER_CITY = 'Customer City'
  static CUSTOMER_COPY = 'CUSTOMER COPY'
  static CUSTOMER_COUNT = 'Customer Count'
  static CUSTOMER_EVENTS = 'Customer events'
  static CUSTOMER_INFORMATION = 'Customer Information'
  static CUSTOMER_LISTS_LOAD_FAILED = "Customer lists couldn't be loaded. Refresh to try again."
  static CUSTOMER_LIST_COUNT_LOAD_FAILED = "This list's active accounts couldn't be counted. Close and try again."
  static CUSTOMER_LIST_CREATED = 'List created'
  static CUSTOMER_LIST_DATE_PASSED = "This list's route date has passed. Change the date to send."
  static CUSTOMER_LIST_DEACTIVATED = 'List deleted'
  static CUSTOMER_LIST_DELETED = 'This list was deleted'
  static CUSTOMER_LIST_DUPLICATE_NAME = 'A list with this name already exists'
  static CUSTOMER_LIST_LOAD_FAILED = "This list couldn't be loaded. Refresh to try again."
  static CUSTOMER_LIST_MEMBERS_LOAD_FAILED = "This list's accounts couldn't be loaded. Refresh to try again."
  static CUSTOMER_LIST_RULES_SAVED = 'Rules saved'
  static CUSTOMER_LIST_SUMMARY_LOAD_FAILED = "This list's numbers couldn't be loaded. Refresh to try again."
  static CUSTOMER_LIST_UPDATED = 'List updated'
  static CUSTOMER_MANAGER = 'Customer Manager'
  static CUSTOMER_MANAGER_INFO = 'View phone, email, name of contacts; edit these; create / delete these'
  static CUSTOMER_NAME = 'Customer Name'
  static CUSTOMER_NOTIFICATION = 'Customer Notification'
  static CUSTOMER_OWNED = 'Customer owned'
  static CUSTOMER_PORTAL = 'Customer Portal'
  static CUSTOMER_PURCHASE_ORDER = 'Customer purchase order'
  static CUSTOMER_SIGNATURE = 'Customer Signature:'
  static CUSTOMER_STATE = 'Customer State'
  static CUSTOMER_ZIP = 'Customer Zip'
  static CUSTOMER_ZONE = 'Customer Zone'
  static CUSTOMIZE_COMPLIANCE_MESSAGES = 'Customize compliance messages (optional)'
  static CUSTOM_DURATION = 'Custom duration'
  static CUSTOM_EMAIL = 'Custom Email'
  static CUSTOM_EMAIL_ERROR = 'An error occurred while sending the email. Please try again later.'
  static CUSTOM_GRACE_PERIOD = 'Custom grace period'
  static CUSTOM_START_DATE = 'Custom start date'
  static CYCLE = 'Cycle'
  static DAILY = 'Daily'
  static DAILY_SCHEDULE_SAVED_SUCCESSFULLY = 'Daily schedule saved successfully'
  static DAILY_SEQUENCE_VERSION_RESTORED_SUCCESSFULLY = 'Daily sequence version restored successfully'
  static DAMAGE = 'Damage'
  static DAMAGE_TYPE = 'Damage type'
  static DASHBOARD = 'Dashboard'
  static DASHBOARD_INFO = 'View Dashboard'
  static DASHBOARD_INTRO = 'Where exceptions come from, what types they are, and how often we confirm them.'
  static DATASET = 'Data Set'
  static DATA_CAPTURE = 'Data Capture'
  static DATA_GROUPING = 'Data grouping'
  static DATE = 'Date'
  static DATE_AND_TIME = 'Date and Time'
  static DATE_FILTER = 'Date filter'
  static DATE_PASSED = 'Date passed'
  static DATE_RANGE = 'Date range'
  static DAY = 'Day'
  static DAYS = 'Days'
  static DAYS_AFTER_LATE_FEE = 'Days after Late Fee'
  static DAYS_CANCEL_SELECTION = 'If you choose to cancel, you will lose all your progress and changes'
  static DAYS_IDLE = 'Days idle'
  static DAYS_LATE = 'Days late'
  static DAYS_LATE_THRESHOLD = 'Days late threshold'
  static DAYS_LOWERCASE = 'days'
  static DAYS_OF_WEEK = 'Days of week'
  static DAYS_ON_SITE = 'Days on-site'
  static DAY_BASED_PRORATION = 'Day-Based Proration'
  static DAY_FIELD_VALIDATION_ERROR = 'Day must be between 1 and 31'
  static DAY_LOWERCASE = 'day'
  static DAY_OF_MONTH = 'Day of month'
  static DAY_OF_THE_MONTH = 'Day of the month'
  static DAY_OF_THE_WEEK = 'Day of the week'
  static DAY_OF_WEEK = 'Day of Week'
  static DBA_OR_BRAND_NAME = 'DBA or Brand Name'
  static DEACTIVATE = 'Deactivate'
  static DEACTIVATED = 'Deactivated'
  static DEACTIVATED_ACCOUNT = 'Deactivated account'
  static DEACTIVATED_SITE = 'This site is deactivated'
  static DEACTIVATED_STOPS = 'Deactivated stops'
  static DEACTIVATES_ON = 'Deactivates'
  static DEACTIVATE_ACCOUNT_CAPTURE_LEAD = "You're about to deactivate "
  static DEACTIVATE_ACCOUNT_CAPTURE_TAIL =
    '. All services and locations will be deactivated and the loss reason recorded for reporting. You can reactivate the account later.'
  static DEACTIVATE_ACCOUNT_DIALOG = 'Deactivate account'
  static DEACTIVATE_ACCOUNT_DIALOG_DESCRIPTION =
    "You're about to deactivate this account. All services and locations in this account will be deactivated. This runs in the background, so you can leave this page — we'll notify you in the notification center when it's finished. Do you want to continue?"
  static DEACTIVATE_ACCOUNT_DIALOG_DESCRIPTION_WITHOUT_NOTIFICATION =
    "You're about to deactivate this account. All services and locations in this account will be deactivated. Do you want to continue?"
  static DEACTIVATE_ACCOUNT_SETTLE_CONTAINERS = 'Decide what happens to the containers on site before the account is deactivated.'
  static DEACTIVATE_ACCOUNT_TAIL = '. All services and locations will be deactivated. You can reactivate the account later.'
  static DEACTIVATE_ALL_LOCATIONS = 'Deactivate all locations'
  static DEACTIVATE_INSTEAD = 'Deactivate instead'
  static DEACTIVATE_LIST = 'Delete list'
  static DEACTIVATE_LIST_CONFIRM = 'Delete this list? It stops showing in groups and can no longer be sent to.'
  static DEACTIVATE_LOCATION = 'Deactivate location'
  static DEACTIVATE_ON_END_DATE = 'Deactivate on End Date'
  static DEACTIVATE_ON_END_DATE_LABEL = 'Deactivate on end date'
  static DEACTIVATE_SERVICE = 'Deactivate service'
  static DEACTIVATION = 'Deactivation'
  static DEACTIVATION_CANCELLED = 'Deactivation cancelled'
  static DEACTIVATION_RUNS_IN_BACKGROUND =
    "This runs in the background, so you can leave this page. We'll notify you in the notification center when it's finished."
  static DEACTIVATION_SCHEDULED = 'Deactivation scheduled'
  static DECLINED = 'Declined'
  static DECREMENT_QUANTITY = 'Decrement quantity'
  static DEFAULT = 'Default'
  static DEFAULT_ORDER = 'Default order'
  static DEFAULT_SITE = 'Default site'
  static DEFAULT_TRUCK = 'Default Truck'
  static DEFAULT_YARD = 'Default yard'
  static DELAY = 'Delay'
  static DELETE = 'Delete'
  static DELETED = 'Deleted'
  static DELETED_BY_HEADER = 'Deleted by'
  static DELETE_ACCOUNT_REASON = 'Delete reason?'
  static DELETE_BRANCH = 'Delete branch'
  static DELETE_BRAND_BLOCKED_TOOLTIP = 'Delete pending campaigns first'
  static DELETE_BRAND_CONFIRM_BUTTON = 'Delete brand'
  static DELETE_BRAND_CONFIRM_DESCRIPTION_NO_TCR = 'This removes the brand from HaulerHero. You can re-register at any time.'
  static DELETE_BRAND_CONFIRM_DESCRIPTION_WITH_TCR =
    "This removes the brand from TCR and clears it from HaulerHero. You'll need to re-register if you want to send SMS again."
  static DELETE_BRAND_CONFIRM_TITLE = 'Delete brand registration?'
  static DELETE_BRAND_FAILURE_MSG = 'Failed to delete brand registration'
  static DELETE_BRAND_SUCCESS_MSG = 'Brand registration deleted'
  static DELETE_BRAND_TOOLTIP = 'Delete this brand registration'
  static DELETE_CAMPAIGN = 'Delete'
  static DELETE_CAMPAIGN_CONFIRM_BUTTON = 'Delete campaign'
  static DELETE_CAMPAIGN_CONFIRM_DESCRIPTION_NO_TCR = 'This removes the campaign from HaulerHero. You can resubmit at any time.'
  static DELETE_CAMPAIGN_CONFIRM_DESCRIPTION_WITH_TCR =
    "This removes the campaign from TCR and clears it from HaulerHero. You'll need to resubmit if you want to send SMS again."
  static DELETE_CAMPAIGN_CONFIRM_TITLE = 'Delete campaign registration?'
  static DELETE_CAMPAIGN_DISABLED_TOOLTIP = 'A campaign in this state cannot be deleted'
  static DELETE_CAMPAIGN_FAILURE_MSG = 'Failed to delete campaign registration'
  static DELETE_CAMPAIGN_SUCCESS_MSG = 'Campaign registration deleted'
  static DELETE_CAMPAIGN_TOOLTIP = 'Delete this campaign registration'
  static DELETE_COMPETITOR = 'Delete competitor?'
  static DELETE_CONFIRMATION = 'Delete confirmation'
  static DELETE_CONTACT = 'Delete contact'
  static DELETE_CONTACT_ASSOCIATION_FAILURE =
    'Contact is associated with a service location. Please remove the association by editing the contact and try again.'
  static DELETE_CONTACT_CALL_FOLLOWUP_FAILURE =
    "Contact is associated with a call follow-up. Please chat with support through the blue chat bubble and we'll resolve this for you."
  static DELETE_CONTACT_FAILURE = 'Delete failure'
  static DELETE_CONTACT_PRIMARY_CONTACT_FAILURE =
    'This contact is still set as the primary contact on another account. Open that account, assign a different primary contact, then try again.'
  static DELETE_CONTACT_SUCCESS_MSG = 'Contact deleted successfully'
  static DELETE_CONTAINER = 'Delete container'
  static DELETE_CONTAINER_ON_SERVICE_WARNING = 'This container is linked to an active service. Deleting it removes it from that service.'
  static DELETE_CONTAINER_TYPE = 'Delete container type'
  static DELETE_DISPOSAL_FEE = 'Delete disposal fee'
  static DELETE_DISPOSAL_FEE_CONFIRM_MSG = 'Deletion of this disposal fee cannot be reversed. Do you want to continue?'
  static DELETE_DISPOSAL_STOP_CONFIRM_MSG = 'This removes the stop from this day only. It cannot be undone.'
  static DELETE_DISPOSAL_STOP_TITLE = 'Delete this disposal stop?'
  static DELETE_DRAFT = 'Delete draft'
  static DELETE_DRAFT_SERVICE = 'Delete draft service'
  static DELETE_EVENT = 'Delete event'
  static DELETE_EXCEPTION = 'Delete exception'
  static DELETE_EXCEPTION_CONFIRM_MSG =
    'Deleting the exception will permanently delete all related photos and data. Are you sure you want to continue?'
  static DELETE_GROUP = 'Delete group'
  static DELETE_INVOICES_SUCCESS_MSG = 'Selected invoices successfully deleted'
  static DELETE_INVOICE_DISABLED_MSG = 'Cannot delete selected invoices. Please deselect invoices that are unpaid, paid, or voided'
  static DELETE_INVOICE_SUCCESS_MSG = 'Selected invoice successfully deleted'
  static DELETE_NOTE = 'Delete note'
  static DELETE_NOTE_CONFIRMATION_DESCRIPTION = 'Are you sure you want to delete this note?'
  static DELETE_RECURRING_DISPOSAL_CONFIRM_MSG =
    'This stops the disposal recurring on this day, on master and on every day it has not run yet. It cannot be undone.'
  static DELETE_RECURRING_DISPOSAL_TITLE = 'Stop this disposal recurring?'
  static DELETE_RECURRING_WORK_ORDER_CONFIRM_MSG =
    'The stop is removed from the route and will not be regenerated. Attached fees, tickets, notes, and photos are kept.'
  static DELETE_RENTAL_FEE = 'Delete rental fee'
  static DELETE_RENTAL_FEE_CONFIRM_MSG = 'Deletion of this rental fee cannot be reversed. Do you want to continue?'
  static DELETE_RENTAL_PERIOD = 'Delete rental period'
  static DELETE_RENTAL_PERIOD_CONFIRM_MSG = 'Are you sure you want to delete this rental period? This action cannot be undone.'
  static DELETE_RULE = 'Delete rule'
  static DELETE_RULE_TITLE = 'Delete rule?'
  static DELETE_SELECT_DRAFT_ONLY = 'Select draft invoices to delete'
  static DELETE_SERVICE_NOTE = 'Delete service note'
  static DELETE_SERVICE_NOTE_CONFIRMATION_DESCRIPTION = 'Are you sure you want to delete this service note?'
  static DELETE_STOP = 'Delete stop'
  static DELETE_THE_RECORD = 'Delete record'
  static DELETE_UNPAID_INVOICE = 'Delete unpaid invoice'
  static DELETE_WORK_ORDER_CONFIRM_MSG = 'Any attached fees, tickets, notes, or photos will be permanently deleted'
  static DELETE_WORK_ORDER_TITLE = 'Delete work order?'
  static DELETING = 'Deleting...'
  static DELETING_ROUTE = 'Deleting route'
  static DELETING_WORK_ORDER = 'Deleting work order...'
  static DELIVERED = 'Delivered'
  static DELIVERY = 'Delivery'
  static DELIVERY_METHOD = 'Delivery method'
  static DEPART = 'Depart'
  static DEPART_LOWERCASE = 'depart'
  static DESCRIPTION = 'Description'
  static DESCRIPTION_TOO_LONG = 'Keep the description under 1000 characters'
  static DESELECT_ALL = 'Deselect all'
  static DESTINATION = 'Destination'
  static DESTINATION_ADDRESS = 'Destination address'
  static DESTINATION_DATE = 'Destination date'
  static DESTRUCTIVE = 'Heads up'
  static DETAILS = 'Details'
  static DETAILS_AND_PRICING = 'Details & pricing'
  static DETECTED_AT = 'Detected at'
  static DETECTED_VALUE = 'Detected value'
  static DETECTION = 'Detection'
  static DETECTION_TYPE = 'Detection type'
  static DIFFERENT_BILLING_DATES = 'Different Billing Dates'
  static DIFFERENT_BILLING_DATES_LABEL = 'Different billing dates'
  static DIFFERENT_BILLING_NAME_LABEL = 'Different billing name'
  static DIGOUT = 'Digout'
  static DIRECTION = 'Direction'
  static DIRECT_LENDING = 'Direct Lending'
  static DISABLED = 'Disabled'
  static DISABLED_CONTACTS = 'Disabled contacts'
  static DISABLE_CHANGE_ROUTE_SEQUENCE_MSG = 'Unable to change route & sequence for Serviced and Skipped stops'
  static DISABLE_UNASSIGN_STOP_MSG = 'Unable to unassign Serviced and Skipped stops'
  static DISCARD = 'Discard'
  static DISCARD_CHANGES = 'Discard changes'
  static DISCARD_CHANGES_TITLE = 'Discard changes?'
  static DISCARD_PREVIEW_CONFIRM = 'Discard preview'
  static DISCARD_PREVIEW_STAY = 'Stay'
  static DISCARD_PREVIEW_TO_CONTINUE_DESCRIPTION = 'You have a resequence preview staged. Switching tabs will discard it. Continue?'
  static DISCARD_PREVIEW_TO_CONTINUE_TITLE = 'Discard resequence preview?'
  static DISCARD_TAX_APPLICATION_DESCRIPTION = "You have unsaved changes to this tax's application settings. Discarding now will lose them."
  static DISCARD_TAX_DESCRIPTION = 'You have unsaved changes to this tax. Closing now will lose them.'
  static DISCARD_UNSAVED_CHANGES_MSG = 'You have unsaved changes. Discard them?'
  static DISCONNECT_USER = 'Disconnect user'
  static DISCOUNT = 'Discount'
  static DISCREPANCIES = 'Discrepancies'
  static DISCREPANCIES_DESCRIPTION = 'Container attributes that differ from what is on file.'
  static DISCREPANCY_ENTER_CORRECTION = 'Vision flagged this field without reporting a value — enter the correction'
  static DISCREPANCY_NO_TEXT_EDITOR = 'Correcting this field needs its own picker; not editable here yet'
  static DISCREPANCY_REJECTED = 'Discrepancy rejected'
  static DISCREPANCY_SELECT_CORRECTION = 'Vision flagged this field without reporting a value — select the correction'
  static DISMISS = 'Dismiss'
  static DISPLAY = 'Display'
  static DISPLAY_NAME = 'Display Name'
  static DISPOSAL = 'Disposal'
  static DISPOSAL_ADDS_ONE_OFF_STOP_TO = 'Adds a one-off disposal stop to {route}. It stays on this day and will not recur.'
  static DISPOSAL_ADDS_RECURRING_STOP_TO = 'Adds a recurring disposal stop to {route}, on the schedule set below.'
  static DISPOSAL_FEE = 'Disposal Fee'
  static DISPOSAL_FEES = 'Disposal fees'
  static DISPOSAL_FEE_ARCHIVED_SUCCESSFULLY = 'Disposal fee archived successfully'
  static DISPOSAL_FEE_ARCHIVE_ASSOCIATION_MSG =
    'This disposal fee is associated with some accounts, services, invoices, or configured services and cannot be archived'
  static DISPOSAL_FEE_CREATED_SUCCESSFULLY = 'Disposal fee created successfully'
  static DISPOSAL_FEE_DELETED_SUCCESSFULLY = 'Disposal fee deleted successfully'
  static DISPOSAL_FEE_DELETE_ASSOCIATION_MSG =
    'This disposal fee is associated with some accounts, services, invoices, or configured services and cannot be deleted'
  static DISPOSAL_FEE_FOLLOWS_SITE_RATE = 'Fee follows qty × site rate'
  static DISPOSAL_FEE_NAME = 'Disposal Fee Name'
  static DISPOSAL_FEE_RESTORED_SUCCESSFULLY = 'Disposal fee restored successfully'
  static DISPOSAL_FEE_UPDATED_SUCCESSFULLY = 'Disposal fee updated successfully'
  static DISPOSAL_MATERIALS_HEADER = 'Disposal materials'
  static DISPOSAL_RECURS_WEEKLY_BY_DEFAULT = 'Recurs weekly on this day'
  static DISPOSAL_SITE = 'Disposal Site'
  static DISPOSAL_SITES_MANAGED_IN_SETTINGS = 'Disposal sites are managed in Settings, under Disposal sites'
  static DISPOSAL_SITES_NEED_SETTINGS_ACCESS =
    'Disposal sites could not be loaded. Listing them needs settings access — ask an admin to grant it.'
  static DISPOSAL_SITE_DEFAULT_SETTING_SUCCESS = 'Disposal site default setting updated successfully'
  static DISPOSAL_SITE_HEADER = 'Disposal site'
  static DISPOSAL_SITE_HOURS = 'Disposal Site Hours'
  static DISPOSAL_SITE_IS_REQUIRED = 'Pick a disposal site'
  static DISPOSAL_SITE_MAPPING = 'Disposal site mapping'
  static DISPOSAL_SITE_MAPPING_UPDATED_SUCCESSFULLY = 'Disposal site mapping updated successfully'
  static DISPOSAL_SITE_MATERIALS = 'Disposal Site Materials'
  static DISPOSAL_STOP = 'Disposal stop'
  static DISPOSAL_STOPS_HAVE_NO_WORK_ORDER_TO_REDATE = 'Disposal stops have no work order to re-date.'
  static DISPOSAL_STOP_ADDED = 'Disposal stop added'
  static DISPOSAL_STOP_ADDED_AT_TOP_INSTEAD =
    'Disposal stop added, but it could not be moved into position. It is at the top of the route — drag it into place.'
  static DISPOSAL_STOP_ADDED_WITHOUT_TICKET = 'Disposal stop added, but its ticket could not be logged. Log it from the stop.'
  static DISPOSAL_STOP_CANNOT_BE_UNASSIGNED_BY_DRAG = 'A disposal stop cannot be unassigned by dragging. Delete it instead.'
  static DISPOSAL_STOP_CREATED_BUT_NOT_ROUTED =
    'The disposal stop was created but could not be added to the route. Check the route before adding it again.'
  static DISPOSAL_STOP_DELETED = 'Disposal stop deleted'
  static DISPOSAL_STOP_RECORD_NOT_FOUND = 'The record behind this stop could not be found, so nothing was deleted. Refresh and try again.'
  static DISPOSAL_TICKET = 'Disposal ticket'
  static DISPOSAL_TICKETS_EMPTY_STATE_MSG = 'No disposal tickets for this work order yet'
  static DISPOSAL_TICKETS_REVIEW_EMPTY_STATE_MSG =
    'This section displays disposal tickets from scale integrations. Interested in scale integration? Contact your Success Manager.'
  static DISPOSAL_TICKET_DESCRIPTION = 'Any disposal tickets added to work orders'
  static DISPOSAL_TICKET_NUMBER_HEADER = 'Disposal ticket #'
  static DISPOSAL_TICKET_NUMBER_IS_REQUIRED = 'A ticket number is required to log a ticket'
  static DISPOSAL_TICKET_TOTAL_HEADER = 'Disposal ticket total'
  static DISPOSAL_UNIT_OF_MEASURE = 'Disposal Unit Of Measure'
  static DISTANCE = 'Distance'
  static DISTANCE_SAVED = 'Distance saved'
  static DOLLAR_AMOUNT = 'Dollar amount'
  static DONE = 'Done'
  static DOWNLOAD = 'Download'
  static DOWNLOAD_ALL_INVOICES = 'Download all invoices'
  static DOWNLOAD_ALL_RECEIPTS = 'Download all receipts'
  static DOWNLOAD_BULK_PRINT_DATA = 'Download bulk print data'
  static DOWNLOAD_CSV_TOOLTIP = 'Download CSV'
  static DOWNLOAD_STATEMENT = 'Download statement'
  static DOWNLOAD_TEMPLATE = 'Download template'
  static DOWNLOAD_TIMEOUT = 'Download Timeout'
  static DRAFT = 'Draft'
  static DRAFT_CREATED = 'Draft created'
  static DRAFT_FEATURE_UNDER_BETA = 'The draft feature is currently under beta. Have feedback? Let us know!'
  static DRAFT_INVOICE_NUMBER = 'Draft invoice'
  static DRAFT_INVOICE_REGENERATED_SUCCESSFULLY = 'Draft invoice regenerated successfully.'
  static DRAFT_INVOICE_WILL_REGENERATE = 'Will auto regenerate on save'
  static DRAFT_NAME = 'Draft name'
  static DRAFT_ROUTES_UPDATED_SUCCESSFULLY = 'Draft routes updated successfully'
  static DRAFT_ROUTE_CREATED_SUCCESSFULLY = 'Draft route created successfully'
  static DRAFT_ROUTE_UPDATED_SUCCESSFULLY = 'Draft route updated successfully'
  static DRAG_CSV_FILE_HERE_OR = 'Drag your CSV file here or'
  static DRAG_PIN_MESSAGE = 'Drag the pin to reposition as needed'
  static DRIVER = 'Driver'
  static DRIVER_AT_STOP = "Driver's at stop"
  static DRIVER_COPY = 'DRIVER COPY'
  static DRIVER_EVENT = 'Driver event'
  static DRIVER_PATH = 'Driver path'
  static DRIVER_PATH_INFO = 'Driver path information'
  static DRIVER_PHOTO = 'Driver Photo'
  static DRIVER_REPORTED = 'Driver Reported'
  static DRIVER_RESULTS_QUESTION = 'The driver already marked this stop'
  static DRIVER_VISIBILITY_HELP =
    'With no drivers assigned, every driver can see this route. Assign one or more and only they can see it — handy for helpers or split shifts.'
  static DRIVE_TIME = 'Drive time'
  static DROP = 'Drop'
  static DROP_AN_IMAGE_OR_CLICK = 'Drop an image here, or click to choose'
  static DROP_TO_UPLOAD = 'Drop to upload'
  static DUE_DATE = 'Due Date'
  static DUMP_N_RELOCATE = 'Dump & Relocate'
  static DUMP_N_RETURN = 'Dump & Return'
  static DUPLICATE_LEDGER_ACCOUNT = 'Duplicate account name and number'
  static DURATION = 'Duration'
  static DYNAMIC = 'Dynamic'
  static DYNAMIC_LIST_HINT = 'By rules. Re-checks them every time it opens, so it stays current on its own.'
  static EACH_DAY_OF_THE_MONTH_MUST_BE_UNIQUE = 'Each day of the month must be unique'
  static EACH_DAY_OF_THE_WEEK_MUST_BE_UNIQUE = 'Each day of the week must be unique'
  static EACH_OCCURRENCE_MUST_BE_UNIQUE = 'Each occurrence must be unique'
  static EDIT = 'Edit'
  static EDIT_ACCOUNT = 'Edit account'
  static EDIT_ACCOUNT_DETAILS = 'Edit account details'
  static EDIT_ACCOUNT_GROUP = 'Edit account group'
  static EDIT_ACTION = 'Edit action'
  static EDIT_BENEFICIAL_OWNER_ADDRESS = 'Edit beneficial owner address'
  static EDIT_BILLING_LOCATION = 'Edit billing location'
  static EDIT_CONTAINER = 'Edit container'
  static EDIT_CONTAINER_TYPE = 'Edit container type'
  static EDIT_DISPOSAL_FEE = 'Edit Disposal Fee'
  static EDIT_EVENT = 'Edit event'
  static EDIT_FILTERS = 'Edit filters'
  static EDIT_GROUP_NAME = 'Edit group name'
  static EDIT_INVOICE = 'Edit Invoice'
  static EDIT_INVOICE_DETAILS = 'Edit invoice details'
  static EDIT_INVOICE_GROUP = 'Edit invoice group'
  static EDIT_LATE_FEE_DIALOG = 'Edit late fee'
  static EDIT_LIST = 'Edit list'
  static EDIT_LOCATION = 'Edit location'
  static EDIT_MASTER_SEQUENCE = 'Edit master sequence'
  static EDIT_NOTE = 'Edit note'
  static EDIT_PAYMENT_GROUP = 'Edit payment group'
  static EDIT_PERIOD_DATES_HINT = 'Change this period’s start or end date.'
  static EDIT_PURCHASE_ORDER = 'Edit purchase order'
  static EDIT_RECURRENCE_INSTRUCTION_BEFORE_PUBLISH = 'Set the recurrence on the Service & Billing or Map Schedule tab before publishing.'
  static EDIT_REGISTRATION = 'Edit Registration'
  static EDIT_REGISTRATION_DISABLED_TOOLTIP = 'Editing a submitted registration is not yet supported'
  static EDIT_RENTAL_FEE_DIALOG = 'Edit rental fee'
  static EDIT_ROUTE = 'Edit route'
  static EDIT_ROUTE_DETAILS = 'Edit route details'
  static EDIT_RULE = 'Edit rule'
  static EDIT_SERVICE = 'Edit service'
  static EDIT_SERVICE_DETAILS = 'Edit service details'
  static EDIT_SERVICE_EVENT_FREQUENCY = 'Edit service event frequency'
  static EDIT_TAX = 'Edit tax'
  static EIN = 'EIN'
  static EIN_LABEL = 'EIN (Employer Identification Number)'
  static EMAIL = 'Email'
  static EMAILS_DID_NOT_MATCH = 'Emails didn’t match'
  static EMAIL_ACTIVITY = 'E-mail activity'
  static EMAIL_ALL_PAYMENT_RECEIPTS = 'Email all payment receipts'
  static EMAIL_AND_SMS = 'Email & SMS'
  static EMAIL_BODY = 'Email body'
  static EMAIL_BODY_REQUIRED = 'Email body is required'
  static EMAIL_INVOICES = 'E-mail invoices'
  static EMAIL_NOTIFY_COMING_SOON = 'Email notifications are coming soon — switch to SMS to send now'
  static EMAIL_SELECT_POSTED_OR_PAID = 'Select posted or paid invoices to email'
  static EMAIL_SENDING_UNAVAILABLE = "Email sending isn't available yet"
  static EMAIL_SEND_TYPE = 'Email send type'
  static EMAIL_STATUS_BOUNCED = 'Bounced'
  static EMAIL_STATUS_BOUNCED_DESC = 'The email could not be delivered.'
  static EMAIL_STATUS_CLICKED = 'Clicked'
  static EMAIL_STATUS_CLICKED_DESC = 'The recipient clicked a link in the email.'
  static EMAIL_STATUS_DEFERRED = 'Deferred'
  static EMAIL_STATUS_DEFERRED_DESC = "Delivery was temporarily delayed by the recipient's server. The system will retry."
  static EMAIL_STATUS_DELIVERED = 'Delivered'
  static EMAIL_STATUS_DELIVERED_DESC = "The email reached the recipient's mailbox, but has not been opened."
  static EMAIL_STATUS_DROPPED = 'Dropped'
  static EMAIL_STATUS_DROPPED_DESC = "Delivery wasn't attempted, usually due to prior bounces, spam reports, or unsubscribes."
  static EMAIL_STATUS_OPENED = 'Opened'
  static EMAIL_STATUS_OPENED_DESC = 'The recipient opened the email.'
  static EMAIL_STATUS_PROCESSED = 'Processed'
  static EMAIL_STATUS_PROCESSED_DESC = 'The email was received by the sending server and is being prepared for delivery.'
  static EMAIL_STATUS_SPAM_REPORT = 'Spam Report'
  static EMAIL_STATUS_SPAM_REPORT_DESC = 'The recipient marked the email as spam.'
  static EMAIL_STATUS_UNSUBSCRIBED = 'Unsubscribed'
  static EMAIL_STATUS_UNSUBSCRIBED_DESC = 'The recipient opted out of future emails.'
  static EMAIL_UNPAID_INVOICES = 'E-mail unpaid invoices'
  static EMAIL_UNPAID_SELECT_UNPAID = 'Select unpaid invoices to email'
  static EMBEDDED_LINKS = 'Embedded Links'
  static EMBEDDED_PHONE = 'Embedded Phone'
  static EMPLOYEES = 'Employees'
  static EMPTY_ACCOUNT_GROUP = 'This account group is empty'
  static EMPTY_FILE = 'File is empty'
  static EMPTY_INVOICE_GROUP = 'This invoice group is empty'
  static EMPTY_LATE_FEE = 'There are no accounts linked to this late fee'
  static EMPTY_PAYMENT_GROUP = 'This payment group is empty'
  static ENABLED = 'Enabled'
  static ENABLE_SERIALIZATION = 'Enable serialization'
  static END = 'End'
  static ENDED_SERVICES_STOPS = 'Ended services stops'
  static ENDING_YARD = 'Ending yard'
  static END_DATE = 'End date'
  static END_DATE_CANNOT_BE_BEFORE_START_DATE = 'End date cannot be before start date'
  static END_OF_ROUTE = 'End of route'
  static END_SERVICE_ON_DATE_NOTE = 'The service runs until this date, then deactivates itself. Work orders after it are removed.'
  static END_SERVICE_ON_END_DATE = 'On an end date'
  static END_SERVICE_TIMING = 'When'
  static END_SERVICE_TODAY_NOTE = 'The service ends today. Work orders after today are removed.'
  static END_START_DATE = 'End/Start date'
  static END_THE_SERVICE = 'End the service'
  static ENTER_EMAIL_SUBJECT = 'Enter email subject line'
  static ENTER_EMAIL_SUBJECT_LINE = 'Enter email subject line'
  static ENTER_SERVICE_ADDRESS_THEN_DRAG_PIN = 'Enter the service address, then drag the pin to fine-tune the exact location.'
  static ENTER_SERVICE_SCHEDULE_DETAILS = 'Please enter service schedule details in order to publish'
  static ENTER_SUBJECT = 'Enter subject...'
  static ENTER_TICKET_NUMBER_PLACEHOLDER = 'Enter ticket number'
  static ENTER_VALID_EMAIL = 'Please enter a valid email address'
  static ENTER_VALUE_PLACEHOLDER = 'Enter Value'
  static ENTITY_TYPE = 'Entity Type'
  static EQUALS = 'equals'
  static ERROR = 'Error'
  static ERRORS = 'Errors'
  static ERROR_FINALIZING_IMPORT = 'Error finalizing import:'
  static ERROR_LOADING_SERVICE_DETAILS = 'Error loading service details'
  static ERROR_PARSING_DATE_FOR_FILTERING = 'Error parsing date for filtering:'
  static ERROR_PROCESSING_CSV = 'Error processing CSV:'
  static ERROR_READING_SEQUENCE_FILE =
    'The sequence import accepts XLSX files only. Please try a route export and you’ll have a properly formatted file to import.'
  static ERROR_UPDATING_RECURRENCE = 'Error updating recurrence. Please try again.'
  static ESTIMATED_ABBR = 'est.'
  static ESTIMATED_SURCHARGE = 'Estimated surcharge'
  static ES_SUFFIX = 'es'
  static ETA = 'ETA'
  static EVENT = 'Event'
  static EVENTS = 'Events'
  static EVENTS_PREVIEW = 'Events preview'
  static EVENT_BASED_PRORATION = 'Event-Based Proration'
  static EVENT_DATE = 'Event date'
  static EVENT_INSTANCE_REQUIRED = 'Event instance is required'
  static EVENT_OCCURRENCE = 'Event occurrence'
  static EVIDENCE = 'Evidence'
  static EXCEPTION = 'Exception'
  static EXCEPTIONS = 'Exceptions'
  static EXCEPTIONS_DASHBOARD = 'Dashboard'
  static EXCEPTIONS_DESCRIPTION = 'Any exceptions added to work orders'
  static EXCEPTION_CREATED_SUCCESS = 'Exception created successfully'
  static EXCEPTION_CREATE_COMING_SOON = 'Creating exceptions from the web is coming soon'
  static EXCEPTION_DELETED_SUCCESS = 'Exception deleted successfully'
  static EXCEPTION_DETAIL = 'Exception detail'
  static EXCEPTION_MEDIA_UPLOAD_FAILED = 'The exception was saved but its media failed to upload'
  static EXCEPTION_REJECTED = 'Exception rejected'
  static EXCEPTION_TARGET = 'Exception for'
  static EXCEPTION_TYPE = 'Exception type'
  static EXCEPTION_UPDATED_SUCCESS = 'Exception updated successfully'
  static EXCLUDE = 'Exclude'
  static EXCLUDE_ANYTHING_WITH = 'Exclude anything with'
  static EXCLUDE_RULES_HINT = 'Accounts matching any exclusion are left out.'
  static EXISTING_RENTAL_PERIODS = 'Existing rental periods'
  static EXIT_EDIT_MODE = 'Exit edit mode'
  static EXPAND = 'Expand'
  static EXPAND_ALL = 'Expand all'
  static EXPAND_GROUP = 'Expand group'
  static EXPAND_LOCATION = 'Expand Location'
  static EXPECTED = 'Expected'
  static EXPORT = 'Export'
  static EXPORTED_AT = 'exported'
  static EXPORTING = 'Exporting…'
  static EXPORT_PAGE_CSV = 'Export this page (CSV)'
  static EXPORT_PAGE_PDF = 'Export this page (PDF)'
  static EXPORT_ROUTE = 'Export route'
  static EXPORT_SELECTED_CSV = 'Export selected (CSV)'
  static EXPORT_SELECTED_PDF = 'Export selected (PDF)'
  static EXPORT_TO_CSV = 'Export to CSV'
  static EXTENSION = 'Extension'
  static EXTERNAL_PAYMENT_NUMBER = 'External payment number'
  static EXTRA_ITEM = 'Extra Item'
  static EXT_PRICE = 'EXT PRICE'
  static FAILED = 'Failed'
  static FAILED_AFTER_RETRIES = 'Failed after retries'
  static FAILED_DELIVERIES = 'Failed deliveries'
  static FAILED_DOWNLOAD = 'Failed download'
  static FAILED_PAYMENTS = 'Failed payments'
  static FAILED_TO_CREATE_PAYMENT_BATCH = 'Failed to create payment batch. Please try again.'
  static FAILED_TO_DELETE_ANY_PAYMENT_BATCHES = 'Failed to delete any payment batches'
  static FAILED_TO_DELETE_WORK_ORDER = 'Failed to delete work order'
  static FAILED_TO_DOWNLOAD = 'Failed to download'
  static FAILED_TO_DOWNLOAD_INVOICES = 'Failed to download the following invoices:'
  static FAILED_TO_DOWNLOAD_PAYMENT_RECEIPTS = 'Failed to download the following payment receipts:'
  static FAILED_TO_LOAD_EMAIL_DETAILS = 'Failed to load email details'
  static FAILED_TO_LOAD_PREVIEW = 'Failed to load preview'
  static FAILED_TO_LOAD_ROUTES = 'Failed to load routes'
  static FAILED_TO_LOAD_SERVICES = 'Failed to load services'
  static FAILED_TO_LOAD_VIDEO = 'Failed to load video'
  static FAILED_TO_LOAD_WORK_ORDERS = 'Failed to load work orders'
  static FAILED_TO_PARSE_BATCH_JSON = 'Failed to parse batch JSON:'
  static FAILED_TO_PARSE_CSV_FILE = 'Failed to parse CSV file. Please check the file format and try again.'
  static FAILED_TO_PUBLISH_SERVICE = 'Failed to publish service'
  static FAILED_TO_SAVE_SERVICE = 'Failed to create draft'
  static FAILED_TO_SEND = 'Failed to send'
  static FAILED_TO_UPDATE_RECURRENCE = 'Failed to update recurrence'
  static FAILED_TO_UPDATE_SERVICE_DATE = 'Failed to update service date'
  static FEBRUARY_CLAMP_INFO = 'For February, the due date will automatically default to the last day of the month.'
  static FEE = 'Fee'
  static FEES = 'Fees'
  static FEES_ADJUSTED = 'Invoice fees have been adjusted'
  static FEES_LOWERCASE = 'fees'
  static FEES_PER_PERIOD = '$ Fees per Period'
  static FEES__AND_TAXES = 'Fees & taxes'
  static FEET_ABBR = 'ft'
  static FEE_AND_TAXES = 'Fees & Taxes'
  static FEE_DUPLICATED_MSG = 'This fee already exists and will not be duplicated'
  static FEE_LOWERCASE = 'fee'
  static FEE_RATE = 'Fee rate'
  static FEE_STRUCTURE = 'Fee structure'
  static FEE_TOTAL = 'Fee total'
  static FEWEST_ACCOUNTS = 'Fewest accounts'
  static FIELDS_DECIDED = 'Fields decided'
  static FILE_TOO_LARGE = 'File "{fileName}" is too large. Maximum size is {maxSize}MB.'
  static FILL = 'Fill'
  static FILTER = 'Filter'
  static FILTERS = 'Filters'
  static FILTER_BY_DETECTION_PLACEHOLDER = 'Filter by WO, Account #, Container, Customer...'
  static FILTER_OPTIONS = 'Filter options'
  static FILTER_TAGS_PLACEHOLDER = 'Select or type tags'
  static FILTER_VALUE_PLACEHOLDER = 'Filter value'
  static FINAL = 'Final'
  static FINALIZING_IMPORT = 'Finalizing import...'
  static FINISH = 'Finish'
  static FINISH_EVERY_CONDITION_FIRST = 'Finish every condition first'
  static FIRST = 'First'
  static FIRST_MONTHS = 'First months'
  static FIRST_NAME = 'First Name'
  static FIRST_WORK_ORDER_DATE = 'First work order date'
  static FIT = 'Fit'
  static FLAGGED = 'Flagged'
  static FOLLOWUPS_INFO = 'View, modify, create or delete follow ups'
  static FOLLOWUP_CONFIRM_TITLE = 'Are you sure you want to close the Follow Up? Any data entered will be lost.'
  static FOLLOW_UP = 'Follow Up'
  static FORM_VALIDATION_ERROR = 'Please complete all required fields'
  static FOR_MORE_INFORMATION = 'for more information.'
  static FOURTH = 'Fourth'
  static FREE_EMAIL_PROVIDER_ADVISORY =
    'A business email is recommended. Carriers and TCR may reject registrations that use a free provider (e.g. gmail.com).'
  static FREQUENCY = 'Frequency'
  static FREQUENCY_REQUIRED = 'Frequency is required'
  static FRIDAY = 'Friday'
  static FROM = 'From'
  static FROM_DATE = 'From date'
  static FULL = 'Full'
  static FULL_ADDRESS = 'Full address'
  static FULL_REFUND = 'Full Refund'
  static FUTURE_WORK_ORDERS_CANCELLED = 'future work orders cancelled'
  static GALLON = 'Gallon'
  static GENERAL = 'General'
  static GENERAL_FEES = 'General fees'
  static GENERAL_FEES_HEADER = 'General fees'
  static GENERAL_FEES_UPDATED_SUCCESSFULLY = 'General fees updated successfully'
  static GENERAL_LEDGER = 'General Ledger'
  static GENERAL_LEDGER_ACCOUNT = 'General ledger account'
  static GENERAL_NOTE_DESCRIPTION = 'Printed on every postcard in the batch'
  static GENERAL_NOTE_OPTIONAL = 'General note (optional)'
  static GENERAL_SETTING = 'General Setting'
  static GENERATE_BULK_PRINT_DATA = 'Generate bulk print data'
  static GENERATE_EMAIL_AND_POST = 'Generate, email and post'
  static GENERATE_MONTHLY_STATEMENT = 'Generate monthly statement'
  static GENERATE_PDF = 'Generate PDF'
  static GENERATE_POSTCARD_PDF = 'Generate postcard PDF'
  static GENERATE_PRESSURE_SEAL_PDF = 'Generate pressure seal PDF'
  static GENERATING_BULK_PRINT_DATA = 'Generating bulk print data. This will take a few minutes.'
  static GENERATING_EVENTS_PREVIEW = 'Generating events for the next 90 days'
  static GENERATING_POSTCARD_PREVIEW = 'Generating preview...'
  static GENERATION_STATUS = 'Generation status'
  static GEOFENCE_AUTOCOMPLETE = 'Geofence autocomplete'
  static GEOFENCE_ENTERED = 'Geofence entered'
  static GEOFENCE_EXITED = 'Geofence exited'
  static GET = 'Get'
  static GIVEN_OR_SOLD_TO_CUSTOMER = 'Given or sold to customer'
  static GL = 'GL'
  static GLOBAL_SEARCH = 'Global Search'
  static GLOBAL_SEARCH_INFO = 'View all entries in the system through Global Search'
  static GL_ACCOUNT = 'GL account'
  static GL_ACCOUNT_TOOLTIP = 'GL account — where this tax posts in the general ledger.'
  static GOT_IT = 'Got it'
  static GO_BACK_AND_ADD_EMAIL = 'Go back and add email'
  static GO_TO_ACCOUNT = 'Go to account'
  static GO_TO_SERVICE_PAGE = 'Go to service page'
  static GRACE_PERIOD = 'Grace period'
  static GRACE_PERIOD_LENGTH = 'Grace period length'
  static GRACE_PERIOD_RESET_HISTORY = 'Grace period reset history'
  static GRAPPLE = 'Grapple'
  static GREATER_THAN_1 = 'Greater than one'
  static GREATER_THAN_100 = 'Greater than 100'
  static GREATER_THAN_1000 = 'Greater than 1000'
  static GREATER_THAN_250 = 'Greater than 250'
  static GREATER_THAN_50 = 'Greater than 50'
  static GREATER_THAN_500 = 'Greater than 500'
  static GROUP = 'Group'
  static GROUPS = 'Groups'
  static GROUPS_AND_LISTS = 'Groups & lists'
  static GROUP_MANAGEMENT = 'Group management'
  static GROUP_NAME = 'Group name'
  static GROUP_PRORATION_UPDATED = 'Proration updated for selected group'
  static HAS_LOCK_BAR = 'Has Lock Bar'
  static HAS_VIDEO_ARTIFACT = 'Has Video artifact'
  static HAS_WHEELS = 'Has Wheels'
  static HAULER = 'Hauler'
  static HAULER_HERO_SYSTEM = 'Hauler Hero System'
  static HAULER_OWNED = 'Hauler owned'
  static HEIGHT = 'Height'
  static HELP_AND_INFO = 'Help & info'
  static HELP_KEYWORDS = 'Help keywords'
  static HELP_KEYWORDS_HINT = 'Comma-separated. Optional.'
  static HELP_RESPONSE_MESSAGE = 'Help response message'
  static HERO_VISION_CONFIRMATION = 'Hero Vision confirmation'
  static HIDE = 'Hide'
  static HIDE_ALREADY_SET_PREFIX = 'Hide the'
  static HIDE_CALENDAR = 'Hide Calendar'
  static HIDE_COMPLIANCE_MESSAGES = 'Hide compliance messages'
  static HIDE_DETAILS = 'Hide details'
  static HIDE_EMPTY_ROUTES = 'Hide empty routes'
  static HIDE_EXAMPLE_MESSAGES = 'Hide example messages for reference'
  static HIDE_FOR_ALL_WORK_ORDERS = 'Hide for all work orders'
  static HIDE_LEGEND = 'Hide legend'
  static HIDE_ON_MOBILE = 'Hide on mobile'
  static HIDE_REVIEW_MENU = 'Hide review menu'
  static HIDE_ZERO_STOPS_ROUTES = 'Hide 0 stops routes'
  static HIGHWAYS = 'Highways'
  static HISTORICAL_DATE = 'Historical date'
  static HISTORY = 'History'
  static HISTORY_CURRENT_PILL = 'Current'
  static HISTORY_CURRENT_UPCOMING = 'Current + upcoming'
  static HISTORY_JUMP_TO_CURRENT = 'Jump to current'
  static HISTORY_NEXT_WEEK = 'Next week'
  static HISTORY_PAST = 'Past'
  static HISTORY_PAST_COMPLETED = 'Past · completed'
  static HISTORY_PREVIOUS_WEEK = 'Previous week'
  static HISTORY_READ_ONLY_HINT = 'Viewing a past week — read-only history'
  static HOIST = 'Hoist'
  static HOLD = 'Hold'
  static HOLDS = 'Holds'
  static HOLDS_LOCATION_FOR_REPLACEMENT = 'Holds this location for the replacement'
  static HOLD_DESCRIPTION =
    'The work order is paused due to a vacation hold on the account. Service is temporarily stopped and will resume when the hold period ends. Work orders remain frozen in service (shown in purple).'
  static HOOK = 'Hook'
  static HOSTED_BY_HAULERHERO = 'Hosted by HaulerHero'
  static HOSTED_POLICY = 'Hosted Policy'
  static HOSTED_POLICY_AUTO_ASSIGNED = 'Assigned automatically on submission'
  static HOSTED_POLICY_DESCRIPTION = 'Both Terms and Privacy URLs will point to the hosted policy maintained for your tenant.'
  static HOSTED_PRIVACY_POLICY_PLACEHOLDER = 'Assigned automatically when you submit'
  static HOSTED_PRIVACY_POLICY_TOGGLE_HELPER =
    "We'll publish a compliant SMS privacy policy on your behalf and submit that URL to TCR for both Privacy Policy and Terms & Conditions."
  static HOSTED_PRIVACY_POLICY_TOGGLE_LABEL = 'Use HaulerHero-hosted privacy policy'
  static HOSTED_URL_INIT_FAILURE =
    'Could not determine the hosted privacy policy URL. Contact support, or disable the hosted policy and provide your own URLs.'
  static HOURLY = 'Hourly'
  static HOVER_A_COLUMN_TO_ISOLATE_IT = 'hover a column to isolate it'
  static HOVER_A_STOP_TO_FIND_IT = 'hover a stop to find it'
  static HOW_ACCOUNTS_GET_IN = 'How accounts get in'
  static HOW_DO_YOU_WANT_NUMBER = 'How do you want to get your number?'
  static HOW_DO_YOU_WANT_NUMBER_DESCRIPTION = 'Claim a brand-new 10DLC number from our inventory, or port one you already use today.'
  static ICON = 'Icon'
  static ID = 'ID'
  static IDENTIFICATION = 'Identification'
  static IDENTITY_STATUS = 'Identity Status'
  static IDLE = 'Idle'
  static IMMEDIATE = 'Immediate'
  static IMMEDIATELY = 'Immediately'
  static IMPORT = 'Import'
  static IMPORTING = 'Importing...'
  static IMPORT_BRAND = 'Import Brand'
  static IMPORT_BRAND_DESCRIPTION =
    'Already registered a brand directly with TCR? Enter its brand id to bring it into HaulerHero and skip the registration wizard.'
  static IMPORT_BRAND_FIELD_LABEL = 'TCR Brand ID'
  static IMPORT_BRAND_SUCCESS = 'Brand imported'
  static IMPORT_BRAND_TITLE = 'Import an existing TCR brand'
  static IMPORT_CANCELLED = 'Import cancelled'
  static IMPORT_COMPLETED_SUCCESSFULLY = 'Import completed successfully'
  static IMPORT_COMPLETED_SUCCESSFULLY_CREATED = 'Import completed successfully! Created'
  static IMPORT_COMPLETED_TOTAL = 'Import completed! Total:'
  static IMPORT_CONTAINERS = 'Import containers'
  static IMPORT_FINALIZED_SUCCESSFULLY = 'Import finalized successfully!'
  static IMPORT_SEQUENCE = 'Import sequence'
  static IMPORT_WAS_CANCELLED = 'Import was cancelled'
  static IMPORT_WAS_CANCELLED_BY_USER = 'Import was cancelled by user'
  static IMPORT_WAS_CANCELLED_ERROR = 'Import was cancelled'
  static INBOX = 'Inbox'
  static INCLUDE = 'Include'
  static INCLUDED = 'Included'
  static INCLUDED_TONNAGE = 'Included tonnage'
  static INCLUDED_WEIGHT = 'Included weight'
  static INCLUDE_ANYTHING_WITH = 'Include anything with'
  static INCLUDE_LATE_FEES = 'Include late fees'
  static INCLUDE_POSTAGE_AREA = 'Include postage area'
  static INCLUDE_POSTAGE_AREA_DESCRIPTION = 'Disable if using a postage machine'
  static INCLUDE_RULES_HINT = 'Accounts matching any group. Conditions within a group must all match.'
  static INCLUDE_THUMBNAILS = 'Include thumbnails'
  static INCLUDE_ZERO_DOLLAR_INVOICES = 'Include $0.00 invoices'
  static INCLUDE_ZERO_DOLLAR_INVOICES_DESCRIPTION = 'Skip zero-balance accounts'
  static INCOMPLETE = 'Incomplete'
  static INCOMPLETE_BY_COMPLETION_TIME = 'Incomplete · by completion time'
  static INCOMPLETE_RENTAL_PERIODS = 'Incomplete rental periods'
  static INCOMPLETE_ROUTES_SERVICED = 'Incomplete · routes serviced'
  static INCREMENT_QUANTITY = 'Increment quantity'
  static INDEFINITE = 'Indefinite'
  static INDIVIDUAL_PRORATION_UPDATED_SUCCESS = 'Suspension proration updated successfully'
  static INHERIT_CHANGES_FROM_BILLING_PROFILE = 'Inherit changes from billing profile'
  static INHERIT_PAYMENT_TERMS_FROM_BILLING_PROFILE = 'Inherit payment terms from billing profile'
  static INSERT_MERGE_VARIABLE = 'Insert merge variable'
  static INSPECTIONS = 'Inspections'
  static INSPECTIONS_DESCRIPTION = 'Pre and post-trip reports drivers file before a truck leaves the yard.'
  static INSPECTIONS_PERMISSION_INFO =
    'CRM access to Review › Inspections. None hides it, View shows the reports without approving or signing, and Full can add mechanic comments and photos to a defective inspection item, mark it repaired, and approve the vehicle back into service.'
  static INSPECTION_ACCEPTABLE = 'Acceptable'
  static INSPECTION_ACTIVITY_APPROVED = 'Returned to service by {name}'
  static INSPECTION_ACTIVITY_APPROVED_UNNAMED = 'Returned to service'
  static INSPECTION_ACTIVITY_COMMENT = '{name} on {item}: “{note}”'
  static INSPECTION_ACTIVITY_COUNTERSIGNED = 'Countersigned by {name}'
  static INSPECTION_ACTIVITY_COUNTERSIGNED_ON_TABLET = 'Countersigned on the tablet'
  static INSPECTION_ACTIVITY_MARKED_ACCEPTABLE = '{name} marked {item} Acceptable'
  static INSPECTION_ACTIVITY_MARKED_OUT_OF_SERVICE = '{name} marked {item} Out of Service'
  static INSPECTION_ACTIVITY_OUT_OF_SERVICE = 'Marked Out of Service'
  static INSPECTION_ACTIVITY_PERFORMED = '{trip} inspection performed'
  static INSPECTION_ACTIVITY_PERFORMED_BY = '{trip} inspection performed by {name}'
  static INSPECTION_ACTIVITY_PHOTO_COMMENT = '{name} added photos on {item}'
  static INSPECTION_ACTIVITY_SIGNOFF = 'Mechanic signoff'
  static INSPECTION_ACTIVITY_SOMEONE = 'Someone'
  static INSPECTION_ADD_COMMENT = 'Add a comment'
  static INSPECTION_ADD_PHOTO = 'Add photo'
  static INSPECTION_APPROVAL = 'approval'
  static INSPECTION_AUTHOR_CANNOT_APPROVE = 'You filed this inspection, so someone else has to confirm it back into service.'
  static INSPECTION_BODY_AND_ZONES = 'Body & zones'
  static INSPECTION_CHECKLIST_DEFECT_COUNT = '{count} drivable on the checklist'
  static INSPECTION_CHOOSE_SIGNATURE_IMAGE = 'Choose signature image'
  static INSPECTION_COLLAPSE_REPORT = 'Collapse report'
  static INSPECTION_COLUMN_DEFECTS = 'Defects'
  static INSPECTION_COLUMN_PERFORMED = 'Performed'
  static INSPECTION_COLUMN_TRIP = 'Trip'
  static INSPECTION_COMMENT_PLACEHOLDER = 'What was done, or why not'
  static INSPECTION_CONFIRMATION_NOTE = 'Confirmation note'
  static INSPECTION_CONFIRMATION_PLACEHOLDER = 'What you checked'
  static INSPECTION_CONFIRM_BACK_INTO_SERVICE = 'Confirm back into service'
  static INSPECTION_CONFIRM_REPAIRS_INFO = '{truck} is Out of Service. Confirming puts it back on the road.'
  static INSPECTION_CONFIRM_REPAIRS_TITLE = 'Confirm repairs to return {truck} to service'
  static INSPECTION_CONVERSATION = 'Repair conversation'
  static INSPECTION_COUNTERSIGN = 'countersign'
  static INSPECTION_DAMAGE = 'Damage'
  static INSPECTION_DAMAGE_COUNT = '{count} body damage'
  static INSPECTION_DECISION_ACCEPTABLE_INFO = 'Acceptable: the truck keeps running with this defect.'
  static INSPECTION_DECISION_CHANGED_FROM = 'Changed from {decision}'
  static INSPECTION_DECISION_HELD = 'Truck held until repaired'
  static INSPECTION_DECISION_LOCKED = 'Marked repaired. Remove the repaired mark to change the decision.'
  static INSPECTION_DECISION_OUT_OF_SERVICE_INFO = 'Out of Service: the truck is held until this is repaired and confirmed.'
  static INSPECTION_DECISION_PENDING = 'Pending review'
  static INSPECTION_DECISION_RUNS = 'Truck keeps running'
  static INSPECTION_DECISION_SAVED = 'Decision signed'
  static INSPECTION_DECISION_SIGN = 'Sign decision'
  static INSPECTION_DECISION_SIGN_ACCEPTABLE = 'Marking {item} Acceptable lets the truck keep running with this defect.'
  static INSPECTION_DECISION_SIGN_OUT_OF_SERVICE = 'Marking {item} Out of Service holds the truck until it is repaired and confirmed.'
  static INSPECTION_DECISION_SIGN_TITLE = 'Sign the supervisor decision'
  static INSPECTION_DEFECTIVE = 'Defective'
  static INSPECTION_DEFECTS_COUNT = '{count} defects'
  static INSPECTION_DEFECT_ADDED_BY = 'Added in the CRM by {name}'
  static INSPECTION_DEFECT_CONDITION = 'Condition — {zone}'
  static INSPECTION_DEFECT_COUNT = '{count} defect'
  static INSPECTION_DEFECT_NOTE = 'Note'
  static INSPECTION_DEFECT_NOTE_PLACEHOLDER = 'Add a note (optional)'
  static INSPECTION_DEFECT_PALETTE_HINT = 'Drag a damage type onto the truck, or pick one and click where it is.'
  static INSPECTION_DEFECT_SAVED = 'Damage saved'
  static INSPECTION_DETAIL_LOAD_ERROR = 'This inspection could not be loaded.'
  static INSPECTION_DRIVER_REPORT = 'Driver report'
  static INSPECTION_EMPTY_DESCRIPTION = 'Try clearing the search or changing the status and trip filters.'
  static INSPECTION_EMPTY_TITLE = 'No inspections match your filters'
  static INSPECTION_ENGINE_HOURS = 'Engine hours'
  static INSPECTION_EXPAND_REPORT = 'Expand report'
  static INSPECTION_GENERIC_TRIP = 'Vehicle'
  static INSPECTION_GOOD = 'Good'
  static INSPECTION_KPI_AWAITING_REPAIR = 'Awaiting repair'
  static INSPECTION_KPI_AWAITING_REVIEW = 'Awaiting review'
  static INSPECTION_KPI_OUT_OF_SERVICE = 'Out of Service'
  static INSPECTION_LIST_LOAD_ERROR = 'Inspections could not be loaded.'
  static INSPECTION_MARKED_REPAIRED = 'Marked repaired'
  static INSPECTION_MARKED_REPAIRED_BY = 'Marked repaired by {name}'
  static INSPECTION_MARK_REPAIRED = 'Mark repaired'
  static INSPECTION_NEEDS_REVIEW = 'Needs review'
  static INSPECTION_NOT_INSPECTED = 'Not inspected'
  static INSPECTION_NO_COMMENTS_YET = 'No comments yet.'
  static INSPECTION_NO_DRIVER_REPORT = 'The driver left no comment or photo.'
  static INSPECTION_NO_TIRE_ISSUES = 'No tire issues recorded on this inspection.'
  static INSPECTION_NO_TRUCK_DEFECTS = 'No body damage marked on this inspection.'
  static INSPECTION_ODOMETER = 'Odometer'
  static INSPECTION_OOS_DEFECT_COUNT = '{count} out of service'
  static INSPECTION_OOS_ITEMS_COUNT = '{count} checklist items Out of Service'
  static INSPECTION_OOS_ITEM_COUNT = '{count} checklist item Out of Service'
  static INSPECTION_OOS_REPAIRED_COUNT = '{count} marked repaired'
  static INSPECTION_OOS_SUFFIX = 'OOS'
  static INSPECTION_OUT_OF_SERVICE = 'Out of Service'
  static INSPECTION_PENDING_REVIEWS_COUNT = '{count} defects waiting on a supervisor decision'
  static INSPECTION_PENDING_REVIEW_COUNT = '{count} defect waiting on a supervisor decision'
  static INSPECTION_PHOTOS_COUNT = '{count} photos'
  static INSPECTION_PHOTOS_LABEL = 'Photos'
  static INSPECTION_PHOTOS_SUFFIX = 'photos'
  static INSPECTION_PHOTO_COUNT = '{count} photo'
  static INSPECTION_PHOTO_SUFFIX = 'photo'
  static INSPECTION_PHOTO_TOO_LARGE = 'This photo is too large to upload, even resized. Try a smaller one.'
  static INSPECTION_PLACE_DAMAGE = 'Place {damage} on the {zone} drawing'
  static INSPECTION_PROCESS_REPAIRS = 'Process repairs'
  static INSPECTION_PROCESS_REPAIRS_INFO = 'Confirms {truck} back into service and records you as the signer.'
  static INSPECTION_RECORDED_BY = 'Recorded in the CRM by {name}'
  static INSPECTION_REMOVE_PHOTO = 'Remove photo'
  static INSPECTION_REMOVE_REPAIRED_MARK = 'Remove repaired mark'
  static INSPECTION_REPAIRED = 'Repaired'
  static INSPECTION_REPAIRED_ON_TABLET = 'Marked repaired on the tablet'
  static INSPECTION_REPAIRS = 'Inspection Repairs'
  static INSPECTION_REPAIRS_INFO =
    'Add mechanic comments and photos to a defective inspection item, mark it repaired, and approve the vehicle back into service. Without it a driver can file an inspection but cannot comment on or clear one — including their own.'
  static INSPECTION_REPAIR_AWAITS_DECISION = 'Waiting for the supervisor decision'
  static INSPECTION_REPAIR_NOTE_SAVED = 'Repair note saved'
  static INSPECTION_REPAIR_REQUIRED = 'Repair required'
  static INSPECTION_REPAIR_REQUIRED_INFO = 'An Out of Service item has not been marked repaired. The truck cannot roll.'
  static INSPECTION_REPLACE_SIGNATURE_IMAGE = 'Replace image'
  static INSPECTION_REPORTED = 'Reported'
  static INSPECTION_REQUIRED = 'required'
  static INSPECTION_REQUIRES_PERMISSION = 'Requires the Inspections permission at Full'
  static INSPECTION_RETURNED_TO_SERVICE = 'Vehicle returned to service'
  static INSPECTION_SAVE_COMMENT = 'Save comment'
  static INSPECTION_SAVE_DEFECT = 'Save damage'
  static INSPECTION_SAVE_TIRE_ISSUE = 'Save issue'
  static INSPECTION_SEARCH_PLACEHOLDER = 'Search truck, route or driver'
  static INSPECTION_SEND_BACK = 'Send back'
  static INSPECTION_SEND_BACK_NEEDS_REASON = 'Send back — add a reason'
  static INSPECTION_SENT_BACK = 'Repair sent back — truck stays Out of Service'
  static INSPECTION_SIGNATURE_DRAW = 'Draw'
  static INSPECTION_SIGNATURE_NEEDS_NAME = 'Type your full name to adopt a signature.'
  static INSPECTION_SIGNED_ON_TABLET = 'Signed on the tablet'
  static INSPECTION_SIGNER_INITIALS = 'Initials'
  static INSPECTION_SIGNER_NAME = 'Full name'
  static INSPECTION_SIGN_AS = 'By confirming, you sign as {name} on {date}.'
  static INSPECTION_SUPERVISOR_DECISION = 'Supervisor decision'
  static INSPECTION_TAB_CHECKLIST = 'Checklist'
  static INSPECTION_TAB_SIGNATURES = 'Signatures'
  static INSPECTION_TAB_TRUCK_OVERVIEW = 'Truck overview'
  static INSPECTION_TIRES = 'Tires'
  static INSPECTION_TIRE_ISSUE = 'Tire issue'
  static INSPECTION_TIRE_ISSUES_COUNT = '{count} tire issues'
  static INSPECTION_TIRE_ISSUE_COUNT = '{count} tire issue'
  static INSPECTION_TIRE_ISSUE_PROMPT = 'Click a tire to add an issue to it.'
  static INSPECTION_TIRE_ISSUE_SAVED = 'Tire issue saved'
  static INSPECTION_TIRE_ISSUE_TITLE = 'Tire {number} — pick an issue'
  static INSPECTION_TIRE_POSITION = 'Tire {number}'
  static INSPECTION_TRIP_FILTER = 'Trip type'
  static INSPECTION_TRUCK_DIAGRAM = '{zone} truck diagram'
  static INSPECTION_UNNAMED_TRUCK = 'Unnamed truck'
  static INSPECTION_VIEW_DETAIL = 'View detail'
  static INSTALL = 'Install'
  static INTENT_STATUSES_APPLY_TO_WHOLE_WO = 'Canceled and Hold apply to the whole work order'
  static INTERNAL_DESCRIPTION = 'Internal description'
  static INTERVAL = 'Interval'
  static INVALID_CVV = 'Invalid CVV'
  static INVALID_DATE = 'Invalid Date'
  static INVALID_EMAIL_ADDRESSES = 'One or more email addresses are invalid'
  static INVALID_LAT_LONG = 'The address entered does not have a valid latitude/longitude'
  static INVENTORY = 'Inventory'
  static INVITE = 'Invite'
  static INVITE_CUSTOMER_PORTAL_USER = 'Invite customer portal user'
  static INVITE_SENT_SUCCESS_MESSAGE = 'Invite sent successfully'
  static INVOICE = 'Invoice'
  static INVOICED = 'Invoiced'
  static INVOICES = 'Invoices'
  static INVOICES_DUE_ON_DAY = 'Invoices will be due on the'
  static INVOICES_DUE_ON_DAY_SUFFIX = 'day of each billing period.'
  static INVOICES_NUMBER = '# Invoices'
  static INVOICES_SEND_FAILED_MULTIPLE =
    'The following invoices failed to send because the PDF file could not be found. Please regenerate these invoices and try again.'
  static INVOICE_BALANCE = 'Invoice balance'
  static INVOICE_CREATION = 'Invoice creation'
  static INVOICE_DATE = 'Invoice date'
  static INVOICE_DETAILS = 'Invoice details'
  static INVOICE_DISPLAY = 'Invoice display'
  static INVOICE_DISPLAY_NAME = 'Invoice display name'
  static INVOICE_FEES_ADJUSTMENTS = 'Invoice Fees & Adjustments'
  static INVOICE_FETCH_FAILED_AFTER_RETRIES = 'Invoice fetch failed after retries'
  static INVOICE_GROUPING = 'Invoice Grouping'
  static INVOICE_GROUPING_LABEL = 'Invoice grouping'
  static INVOICE_GROUPS = 'Invoice groups'
  static INVOICE_GROUP_CREATED_SUCCESS_MSG = 'Invoice group created successfully'
  static INVOICE_GROUP_NAME = 'Invoice group name'
  static INVOICE_GROUP_UPDATED_SUCCESS_MSG = 'Invoice group updated successfully'
  static INVOICE_INCOMPLETE_RENTAL_PERIODS_DESCRIPTION = 'Invoice incomplete rental periods on recurring billing cycles'
  static INVOICE_IS_GENERATING = 'Invoice is generating.'
  static INVOICE_NO_LONGER_EXISTS = 'Invoice no longer exists'
  static INVOICE_NUMBER = 'Invoice #'
  static INVOICE_PREVIEW_AMOUNT = 'AMOUNT'
  static INVOICE_PREVIEW_DESCRIPTION = 'DESCRIPTION'
  static INVOICE_PREVIEW_LOAD_ERROR = "We couldn't load the invoice preview. Please try again later."
  static INVOICE_RENTAL_FEES_WHEN_SUSPENDED = 'Invoice rental fees when services are suspended'
  static INVOICE_REPORT = 'INVOICE_REPORT'
  static INVOICE_REPORT_TYPE_FILTER = 'INVOICES'
  static INVOICE_SEND_FAILED_SINGLE = 'failed to send because the PDF file could not be found. Please regenerate the invoice and try again.'
  static INVOICE_SENT = 'Invoice sent'
  static INVOICE_SENT_DESCRIPTION = 'When an invoice is sent'
  static INVOICE_STATUS = 'Invoice status'
  static INVOICE_STATUS_UPDATED_SUCCESSFULLY = 'Invoice status updated successfully'
  static INVOICE_TYPE = 'Invoice type'
  static IN_PROCESS = 'In Process'
  static IN_PROGRESS = 'In progress'
  static IN_PROGRESS_DESCRIPTION =
    'A driver has begun working on this stop. They may be en route, on-site, or actively performing the service. Only one stop per route should be in this state at a time.'
  static IS = 'is'
  static ISSUE_LOGGED = 'Issue logged'
  static IS_WITHIN = 'is within'
  static ITEM = 'Item'
  static ITEMS = 'items'
  static ITEM_APPEAR_INFO = 'Set up which items appear on the details card in the Road app.'
  static IT_IS_THE_CUSTOMERS = "It's the customer's"
  static JOB_ACTIVITY = 'Job activity'
  static KEEPS_BILLING_EXPECTS_NO_DELIVERY = 'Billing continues'
  static KEEP_DRIVER_RESULTS = 'Keep it'
  static KEEP_DRIVER_RESULTS_HELP = 'Cancels the order and keeps the service event'
  static KEEP_EDITING = 'Keep editing'
  static KEEP_PLACEMENT = 'Keep delivery'
  static KEEP_SERVICE_REPLACE_CONTAINER = 'Pending delivery'
  static KEEP_SERVICE_REPLACE_CONTAINERS = 'Pending delivery'
  static KEEP_THEM = 'Keep them'
  static KEPT_UPPER = 'KEPT'
  static KIND = 'Kind'
  static LABEL = 'Label'
  static LARGE_ROUTE = 'Large route'
  static LAST = 'Last'
  static LAST_30_DAYS = 'Last 30 Days'
  static LAST_7_DAYS = 'Last 7 Days'
  static LAST_90_DAYS = 'Last 90 Days'
  static LAST_ACTIVITY_DATE = 'Last Activity Date'
  static LAST_MONTH = 'Last Month'
  static LAST_NAME = 'Last Name'
  static LAST_PAYMENT_AMOUNT = 'Last Payment Amount'
  static LAST_PAYMENT_DATE = 'Last Payment Date'
  static LAST_SENT = 'Last sent'
  static LAST_UPCOMING_WEEK = 'Last & Upcoming Week'
  static LAST_UPDATED = 'Last Updated'
  static LAST_WEEK = 'Last Week'
  static LAST_WORK_ORDER = 'Last Work Order'
  static LAST_WORK_ORDER_DATE = 'Last Work Order Date'
  static LATE = 'Late'
  static LATE_FEES = 'Late Fees'
  static LATE_FEES_FINANCING = 'Late fees / Financing'
  static LATE_FEE_ARCHIVED_SUCCESSFULLY = 'Late fee archived successfully'
  static LATE_FEE_CREATED_SUCCESSFULLY = 'Late fee created successfully'
  static LATE_FEE_RESTORED_SUCCESSFULLY = 'Late fee restored successfully'
  static LATE_FEE_REVIEW = 'Late fee review'
  static LATE_FEE_UPDATED_SUCCESSFULLY = 'Late fee updated successfully'
  static LATE_INVOICES = 'Late invoices'
  static LATE_PAYMENT_AND_CREDIT_LIMIT = 'Late payment & Credit limit exceeded'
  static LATE_PAYMENT_SUSPENSION = 'Late payment'
  static LATITUDE = 'Latitude'
  static LAT_SHORT = 'Lat'
  static LAYOUT = 'Layout'
  static LEAVE_A_NOTE = 'Leave a note'
  static LEAVE_ON_SITE = 'Leave on site'
  static LEAVE_WITHOUT_CREATING_ACCOUNT = "Your changes haven't been saved. Leave without creating this account?"
  static LEFT_IN_ORIGINAL_POSITION = 'left in original position'
  static LEFT_ON_SITE = 'Left on site'
  static LEFT_ON_SITE_TOAST = 'Container left on site'
  static LEFT_TURNS = 'Left turns'
  static LEGACY_POSTED = 'Legacy Posted'
  static LEGACY_POSTED_DATE = 'Legacy Posted Date'
  static LEGACY_TAXES = 'Legacy Taxes'
  static LEGACY_TAX_ZONE = 'Legacy tax zone'
  static LEGAL_COMPANY_NAME = 'Legal Company Name'
  static LEGEND = 'Legend'
  static LENGTH = 'Length'
  static LESS_INFO = 'Less info'
  static LETTER = 'Letter'
  static LINK = 'Link'
  static LINKED = 'Linked'
  static LINKED_DISPOSAL_FEE = 'Linked Disposal Fee'
  static LINKED_GENERAL_FEE = 'Linked General Fee'
  static LINKED_SERVICE = 'Linked Service'
  static LINKED_SERVICES = 'Linked Services'
  static LINKED_TAX = 'Linked Tax'
  static LINK_ACCOUNTS_TO_LATE_FEE_SUCCESS_MSG = 'Selected accounts successfully linked to late fee'
  static LINK_ACCOUNT_TO_LATE_FEE_SUCCESS_MSG = 'Selected account successfully linked to late fee'
  static LINK_WITHOUT_DELIVERY = 'Link without delivery'
  static LIQUID_WASTE = 'Liquid Waste'
  static LIST = 'List'
  static LIST_BULK_APPLIES_TO = 'This applies to %s active accounts on this list.'
  static LIST_BULK_APPLIES_TO_ONE = 'This applies to 1 active account on this list.'
  static LIST_BULK_COUNTING = 'Counting the active accounts on this list…'
  static LIST_BULK_NO_ACTIVE_ACCOUNTS = 'This list has no active accounts, so there is nothing to apply this to.'
  static LIST_NAME = 'List name'
  static LIST_PRORATION_UPDATED = 'Proration updated for selected list'
  static LIST_VIEWS = 'List views'
  static LIST_VIEW_CHANGE_SEQUENCE = 'Change Sequence'
  static LIST_VIEW_COLUMNS = 'Columns'
  static LIST_VIEW_CONTAINERS = 'Containers'
  static LIST_VIEW_DATAGRID_VIEW = 'Datagrid view'
  static LIST_VIEW_DENSITY = 'Density'
  static LIST_VIEW_DENSITY_TOOLTIP = 'Density allows you to adjust how compact stop rows appear'
  static LIST_VIEW_LIFTS = 'Lifts'
  static LIST_VIEW_LIST_VIEW = 'List view'
  static LIST_VIEW_MEDIA = 'Media'
  static LIST_VIEW_MORE = 'More'
  static LIST_VIEW_PROGRESS_CANCELLED = 'cancelled'
  static LIST_VIEW_PROGRESS_HOLD = 'hold'
  static LIST_VIEW_PROGRESS_IN_PROGRESS = 'in progress'
  static LIST_VIEW_PROGRESS_SCHEDULED = 'scheduled'
  static LIST_VIEW_PROGRESS_SERVICED = 'serviced'
  static LIST_VIEW_PROGRESS_SKIPPED = 'skipped'
  static LIST_VIEW_SAVE_FOR_CURRENT_DAY = 'Save for Current Day'
  static LIST_VIEW_SAVE_SEQUENCE = 'Save Sequence'
  static LIST_VIEW_SAVE_SEQUENCE_PROMPT = 'Select when you want to save this new sequence.'
  static LIST_VIEW_SAVE_TO_MASTER_ROUTE = 'Save to Master Route'
  static LIST_VIEW_SEARCH_MATCH = '1 match'
  static LIST_VIEW_SEARCH_MATCHES = '%s matches'
  static LIST_VIEW_SEQUENCE_SAVED_CURRENT_DAY = 'Sequence saved for current day.'
  static LIST_VIEW_SEQUENCE_SAVED_MASTER_ROUTE = 'Sequence saved for master route.'
  static LIST_VIEW_SEQUENCE_SAVE_ERROR = 'Could not save sequence. Please try again.'
  static LIST_VIEW_STOPS = 'Stops'
  static LIST_VIEW_STOPS_DONE = '%s of %s stops done'
  static LIST_VIEW_TABLE_VIEW = 'Table view'
  static LIST_VIEW_YARDS = 'Yards'
  static LITTER = 'Litter'
  static LIVE_LOAD = 'Live Load'
  static LNG_SHORT = 'Lng'
  static LOADING = 'Loading...'
  static LOADING_ACCOUNTS = 'Loading accounts...'
  static LOADING_ADDRESSES = 'Loading addresses...'
  static LOADING_EMAIL_DETAILS = 'Loading email details...'
  static LOADING_GROUP_DATA = 'Fetching group details...'
  static LOADING_INVOICES = 'Loading invoices...'
  static LOADING_LIST_ACCOUNTS = 'Fetching list accounts...'
  static LOAD_MORE = 'Load more'
  static LOAD_NEWER = 'Load newer'
  static LOAD_OLDER = 'Load older'
  static LOCATION = 'Location'
  static LOCATIONS = 'Locations'
  static LOCATIONS_FOR_REPLACEMENTS = 'locations for the replacements'
  static LOCATIONS_LOWERCASE = 'locations'
  static LOCATION_ACTIVATED_MSG = 'Location activated successfully'
  static LOCATION_ACTIVATED_SUCCESS = 'Location activated successfully'
  static LOCATION_ADDRESS = 'Location address'
  static LOCATION_ADDRESS_HEADER = 'Location address'
  static LOCATION_CONTACTS = 'Location contacts'
  static LOCATION_DEACTIVATED_MSG = 'Location deactivated successfully'
  static LOCATION_DEACTIVATED_PLURAL = 'locations deactivated'
  static LOCATION_DEACTIVATED_SINGLE = 'location deactivated'
  static LOCATION_DEACTIVATED_SUCCESS = 'Location deactivated successfully'
  static LOCATION_HOLDS = 'Location holds'
  static LOCATION_LOWERCASE = 'location'
  static LOCATION_MAP_NOT_AVAILABLE = 'Location Map not available for this work order.'
  static LOCATION_NAME = 'Location name'
  static LOCATION_NAME_HEADER = 'Location name'
  static LOCATION_NOTE = 'Location note'
  static LOCATION_NOTES = 'Location notes'
  static LOCATION_NO_ADDRESS_WARNING = 'This location has no address. Please add an address before creating a service.'
  static LOCATION_TAG = 'Location tag'
  static LOCATION_TAGS = 'Location Tags'
  static LOCATION_TYPE = 'Location type'
  static LOCK = 'Lock'
  static LOCKED = 'Locked'
  static LOCK_BAR = 'Lock Bar'
  static LOCK_BILLING = 'Lock Billing'
  static LOCK_BILLING_DATE = 'Lock Billing date'
  static LOCK_DATE_INFO =
    'This permission allows users to set a lock date for the accounting period, preventing modifications to invoices and payments dated on or before the lock date. Users cannot create, modify, or reverse invoices or payments within the locked period. However, payments can still be applied to existing invoices from this period.'
  static LOGGED_BY = 'Logged By'
  static LOGOUT = 'Log Out'
  static LOG_A_TICKET = 'Log a ticket'
  static LOG_ISSUE = 'Log issue'
  static LOG_ISSUE_NOTE_PLACEHOLDER = 'Add an optional note (context, evidence, …)'
  static LOG_ISSUE_REASON_HELPER = 'Pick a reason to log this issue.'
  static LONGITUDE = 'Longitude'
  static LOOKING_UP_CUSTOMER_ACCOUNTS = 'Looking up customer accounts...'
  static LOSS_REASON = 'Loss reason'
  static LOSS_REASONS = 'Loss reasons'
  static LOSS_REASONS_DESCRIPTION = 'Why an account was deactivated, captured when deactivating an account.'
  static LOSS_REASONS_LOAD_ERROR = 'Unable to load loss reasons. Refresh and try again.'
  static LOST_TO_COMPETITION = 'Lost to competition'
  static MAIN_NAVIGATION_BAR = 'Main (Navigation Bar)'
  static MANUAL = 'Manual'
  static MANUALLY_COMPLETED = 'Manually completed'
  static MANUFACTURER = 'Manufacturer'
  static MAP = 'Map'
  static MAP_AND_LIST = 'Map + list'
  static MAP_AND_ROUTING = 'Map & routing'
  static MAP_CSV_HEADERS = 'Map CSV headers'
  static MAP_LAYERS = 'Map layers'
  static MAP_NO_SERVICE_ADDRESS = 'No service address on this detection.'
  static MAP_OVERLAYS = 'Map Overlays'
  static MAP_SCHEDULE = 'Map Schedule'
  static MAP_SELECTION_HINT = 'Hold Shift & drag to select, Ctrl+Shift & drag to deselect'
  static MAP_SELECTION_TITLE = 'Map selection'
  static MAP_SELECT_TITLE = 'Pin Selection'
  static MAP_STYLE = 'Map Style'
  static MAP_TYPE = 'Map type'
  static MAP_UNAVAILABLE = 'Map unavailable'
  static MARKED_AS_CUSTOMER_OWNED = 'Marked as customer owned'
  static MARKED_AS_SOLD = 'Marked as sold to the customer'
  static MARKED_FOR_DELETION = 'Marked for deletion'
  static MARKED_NOT_READY_FOR_INVOICE = 'Marked not ready for invoice'
  static MARKED_READY_FOR_INVOICE = 'Marked ready for invoice'
  static MARKER_OFFSET = 'Offset'
  static MARKER_OFFSET_HINT = 'Fan overlapping stops apart'
  static MARK_ALL_AS_READ = 'Mark all as read'
  static MARK_AS_CUSTOMER_OWNED = 'Mark as customer owned'
  static MARK_AS_PAID = 'Mark as paid'
  static MARK_AS_PAID_DISABLED_MSG = 'Only $0 unpaid invoices can be marked as paid'
  static MARK_AS_PAID_SUCCESS = 'Selected invoices successfully marked as paid'
  static MARK_AS_READ = 'Mark as read'
  static MARK_AS_REVERTED = 'Mark As Reversed'
  static MARK_AS_SENT = 'Mark as sent'
  static MARK_AS_SENT_SUCCESS = 'Selected invoices successfully marked as sent'
  static MARK_AS_SOLD = 'Mark as sold'
  static MARK_AS_UNREAD = 'Mark as unread'
  static MASTER = 'Master'
  static MASTER_ROUTE_TEMPLATE_FILENAME = 'master_route_template'
  static MASTER_SEQUENCE = 'Master sequence'
  static MASTER_SEQUENCE_BOARD_ERROR = 'We hit a problem displaying the board. Reloading usually fixes it.'
  static MASTER_SEQUENCE_PUBLISHED_SUCCESSFULLY = 'Master sequence published successfully'
  static MASTER_SEQUENCE_VERSION_RESTORED_SUCCESSFULLY = 'Master sequence version restored successfully'
  static MATCH = 'Match'
  static MATCHING = 'matching'
  static MATCHING_COUNT = 'matching'
  static MATERIAL = 'Material'
  static MATERIALS = 'Materials'
  static MAX = 'Max'
  static MAX_PO_AMOUNT = 'Max PO amount'
  static MEASURE = 'Measure'
  static MEMBERSHIP = 'Membership'
  static MEMBERS_ADDED = 'Accounts added'
  static MEMBERS_REMOVED = 'Accounts removed'
  static MESSAGE = 'Message'
  static MESSAGES = 'Messages'
  static MESSAGES_SENT = 'Messages sent'
  static MESSAGE_CONTENT = 'Message Content'
  static MESSAGE_FLOW = 'Message Flow'
  static MESSAGE_FLOW_HINT =
    'Describe exactly how customers opt in to receive SMS \u2014 service agreement, web form, verbal at signup, etc.'
  static MESSAGE_HISTORY = 'Message History'
  static MESSAGE_NOT_FOUND = 'This message doesn’t exist or is no longer available'
  static MESSAGE_PREVIEW = 'Message Preview'
  static MESSAGE_STATS_LOAD_FAILED = "Message counts couldn't be loaded. Refresh to try again."
  static MESSAGING = 'Messaging'
  static MESSAGING_CLICKWRAP_CTA_DEFAULT = 'Accept Terms and Continue'
  static MESSAGING_CLICKWRAP_CTA_SUBMITTING = 'Recording acceptance…'
  static MESSAGING_CLICKWRAP_ERROR_FORBIDDEN = 'You do not have permission to accept Messaging terms for this tenant.'
  static MESSAGING_CLICKWRAP_ERROR_GENERIC = 'Could not record your selection. Please try again.'
  static MESSAGING_CLICKWRAP_FOOTER_DISCLOSURE =
    'Third-party pass-through fees (carrier, registry, vetting) are billed at cost and may change without amendment.'
  static MESSAGING_CLICKWRAP_HAULER_MUST_ACCEPT =
    'Only the hauler can accept these terms. Ask someone at the company to sign in with their own account and accept them.'
  static MESSAGING_CLICKWRAP_NOT_NOW = 'Not now'
  static MESSAGING_CLICKWRAP_SCROLL_HINT = 'Scroll to the bottom of the terms to enable acceptance.'
  static MESSAGING_CLICKWRAP_SUBTITLE =
    'Review the Messaging Add-On terms below, then accept to continue. No fees will be charged until a Messaging line is set up.'
  static MESSAGING_CLICKWRAP_TERMS_LOAD_FAILURE = 'Failed to load the Messaging Add-On terms. Please try again.'
  static MESSAGING_CLICKWRAP_TERMS_UPDATED =
    'The Messaging Add-On terms have been updated since you last accepted them. Review and accept the current terms to keep using messaging.'
  static MESSAGING_CLICKWRAP_TITLE = 'Messaging Add-On'
  static MESSAGING_DASHBOARD_DESCRIPTION = 'Messages your team has sent and how they were delivered to each recipient.'
  static MESSAGING_INFO = 'View, send, and manage messages and senders'
  static MESSAGING_LEGAL_GATE_TOOLTIP = 'Messaging Add-On terms must be accepted before this action can be performed.'
  static MESSAGING_LEGAL_STATUS_LOAD_FAILURE = "Couldn't verify your Messaging Add-On terms acceptance. Try again."
  static MESSAGING_TERMS = 'Messaging Terms'
  static MESSAGING_TERMS_ACCEPTED_BY = 'Accepted by'
  static MESSAGING_TERMS_ACCEPTED_ON = 'Accepted on'
  static MESSAGING_TERMS_EMPTY = 'The Messaging Add-On terms have not been accepted yet. Accept them from SMS Registration to get started.'
  static MESSAGING_TERMS_LOAD_FAILURE = 'Failed to load the accepted Messaging terms. Please try again.'
  static MESSAGING_TERMS_PRICING_VERSION = 'Pricing version'
  static MESSAGING_TERMS_SUBTITLE = 'A read-only copy of the Messaging Add-On terms exactly as they were accepted.'
  static MESSAGING_TERMS_VERSION = 'Terms version'
  static METHOD = 'Method'
  static METHODS = 'Methods'
  static METHOD_NAME = 'Method Name'
  static METHOD_NICKNAME = 'Method Nickname'
  static MILES = 'miles'
  static MILES_ABBR = 'mi'
  static MIN = 'Min'
  static MINIMUM_BILLING_PERIOD = 'Minimum Billing Period'
  static MINIMUM_FEE = 'Min. Fee'
  static MINIMUM_FEE_COMPLETE = 'Minimum Fee'
  static MINIMUM_ONE_DAY = '(minimum 1 day)'
  static MIN_CHARGE = 'Min. charge'
  static MIN_CHARGE_TOOLTIP =
    'Enable this to enforce a minimum charge for this fee (defaults to Included Tonnage × Rate). Override the default by entering a custom value. Disable to charge the fee with no minimum.'
  static MISSING_ACCOUNT_NUMBER = 'Missing account number'
  static MIXED = 'Mixed'
  static MI_ABBR = 'mi'
  static MOBILE = 'Mobile'
  static MOBILE_VISIBILITY = 'Mobile visibility'
  static MODIFIED = 'Modified'
  static MODIFIED_BY = 'Modified by'
  static MODIFY_PERMISSIONS_IN_ROLES = "View, modify or create a role and its permissions, and modify an individual user's permissions"
  static MONDAY = 'Monday'
  static MONTH = 'Month'
  static MONTHLY = 'Monthly'
  static MONTHLY_MESSAGING_FEE = 'Monthly messaging fee:'
  static MONTHS = 'Months'
  static MORE = 'more'
  static MORE_ACTIONS = 'More actions'
  static MORE_DETAILS = 'More details'
  static MORE_INFO = 'More info'
  static MORE_ROUTES_ELLIPSIS = 'more routes...'
  static MOST_ACCOUNTS = 'Most accounts'
  static MOVE = 'Move'
  static MOVED_LOWERCASE = 'moved'
  static MOVED_STOP = 'Moved stop'
  static MOVES = 'Moves'
  static MOVES_LOWERCASE = 'moves'
  static MOVE_BETWEEN_DAYS = 'Move between days'
  static MOVE_BETWEEN_ROUTES = 'Move between routes'
  static MOVE_CONTAINER = 'Move container'
  static MOVE_DATE = 'Move date'
  static MOVE_PAYMENT_TO_ACCOUNT_CREDIT = 'Move payment to account credit'
  static MOVE_ROUTE_TO = 'Move route to'
  static MOVE_STATUS = 'Move status'
  static MOVE_STOPS = 'Move stops'
  static MOVE_STOP_CURRENT_DAY_SUCCESS_MSG = 'Stop successfully moved to %s for current day.'
  static MOVE_STOP_MASTER_ROUTE_SUCCESS_MSG = 'Stop successfully moved to %s for master Route'
  static MOVE_TOAST_DISMISS = 'Dismiss'
  static MOVE_TO_ACCOUNT_CREDIT_SUCCESS = 'Payment moved to account credit successfully'
  static MOVE_TRANSACTIONS = 'Move transactions'
  static MOVE_TYPE = 'Move type'
  static MOVING_PAYMENTS = 'Moving payments'
  static MSGS_SENT = 'Msgs sent'
  static MULTIPLE_LOCATION_ACTIVATED_MSG = 'Location(s) activated successfully'
  static MUST_BE_A_VALID_EMAIL_ADDRESS = 'Must be a valid email address'
  static MUST_BE_A_VALID_PHONE_NUMBER = 'Must be a valid phone number'
  static MY_DASHBOARD = 'My Dashboard'
  static MY_SAVED_VIEWS = 'My Saved Views'
  static NAME = 'Name'
  static NAME_ON_ACCOUNT = 'Name on Account'
  static NAVIGATION_FONT_COLOR = 'Navigation Font Color'
  static NEAREST_STOP_TITLE = 'Nearest stop'
  static NEAREST_STOP_TOOLTIP = 'Nearest stop is taken in a straight path from the coordinates of the location to be scheduled.'
  static NET = 'Net'
  static NET_WEIGHT = 'Net weight'
  static NEW = 'New'
  static NEWEST = 'Newest'
  static NEWEST_FIRST = 'Newest first'
  static NEW_ACCOUNT = 'New account'
  static NEW_ACCOUNT_GROUP = 'New account group'
  static NEW_ACCOUNT_NOTE = 'New account note'
  static NEW_ACH = 'New ACH'
  static NEW_BATCH = 'New batch'
  static NEW_BILLING_NOTE = 'New billing note'
  static NEW_BRANCH = 'New branch'
  static NEW_CARD = 'New card'
  static NEW_CONFIGURED_SERVICE_NOTE = 'New configured service note'
  static NEW_CONTAINER = 'New container'
  static NEW_CUSTOMER = 'New Customer'
  static NEW_DATE = 'New Date'
  static NEW_DISPOSAL_FEE = 'New Disposal Fee'
  static NEW_DRAFT = 'Create draft'
  static NEW_DRAFT_ROUTE = 'New draft route'
  static NEW_EVENTS_ROUTE_WARNING = 'New work orders need to be routed'
  static NEW_EXCEPTION = 'New exception'
  static NEW_FEE = 'New Fee'
  static NEW_GROUP = 'New group'
  static NEW_INVOICE_GROUP = 'New invoice group'
  static NEW_LIST_SUBTITLE = 'Choose how accounts get in, name it, then review.'
  static NEW_LOCATION_NOTE = 'New location note'
  static NEW_MESSAGE = 'New message'
  static NEW_NOTE = 'New note'
  static NEW_PAYMENT = 'New Payment'
  static NEW_PAYMENT_GROUP = 'New payment group'
  static NEW_RATE = 'New rate'
  static NEW_REPORT = 'New Report'
  static NEW_ROUTE = 'New route'
  static NEW_SERVICE = 'New Service'
  static NEW_SERVICE_GROUP = 'New Service Group'
  static NEW_TAX = 'New tax'
  static NEW_USERNAME = 'New username'
  static NEW_WORK_ORDER_NOTE = 'New work order note'
  static NEW_WO_GENERATE_EVERY_SATURDAY = 'New work orders generate every Saturday'
  static NEXT = 'NEXT'
  static NEXT_6_MONTHS = 'Next 6 Months'
  static NEXT_EXCEPTION = 'Next exception'
  static NEXT_MONTH = 'Next Month'
  static NEXT_PHOTO = 'Next photo'
  static NEXT_QUARTER = 'Next Quarter'
  static NEXT_STEP = 'Next Step'
  static NEXT_WORK_ORDER = 'Next Work Order'
  static NEXT_WORK_ORDER_DATE = 'Next Work Order Date'
  static NO = 'No'
  static NONE = 'None'
  static NONE_APPLIED = 'None applied'
  static NONE_YET_ADD_ONE_ABOVE = 'None yet — add one above.'
  static NOTE = 'Note'
  static NOTES = 'Notes'
  static NOTES_OPTIONAL = 'Notes (optional)'
  static NOTE_UNARCHIVED_SUCCESSFULLY = 'Note unarchived successfully'
  static NOTHING_TO_RETRIEVE = 'Nothing to remove on this service.'
  static NOTIFICATION = 'Notification'
  static NOTIFICATIONS = 'Notifications'
  static NOTIFICATIONS_EMPTY_AREA_DESCRIPTION = 'Notifications from this area will show up here.'
  static NOTIFICATIONS_EMPTY_FILTERED_DESCRIPTION = 'Try a different search, or clear the filters.'
  static NOTIFICATIONS_EMPTY_FILTERED_TITLE = 'No notifications match these filters'
  static NOTIFICATIONS_EMPTY_IN_AREA = 'No notifications in'
  static NOTIFICATIONS_EMPTY_STATE_DESCRIPTION = 'New notifications will show up here.'
  static NOTIFICATIONS_EMPTY_STATE_MSG = "That's all your notifications"
  static NOTIFICATIONS_EMPTY_STATE_TITLE = "You're all caught up"
  static NOTIFICATIONS_EMPTY_YET_DESCRIPTION = 'Job outcomes and customer events show up here as they happen.'
  static NOTIFICATIONS_EMPTY_YET_TITLE = 'No notifications yet'
  static NOTIFICATIONS_INFO = 'View your notification inbox and mark notifications read'
  static NOTIFICATION_CENTER_DESCRIPTION = 'Background jobs keep running even if you leave this page — outcomes are recorded here.'
  static NOTIFICATION_ITEMS_TRUNCATED = 'This run recorded more items than were kept.'
  static NOTIFICATION_PREFERENCES = 'Notification preferences'
  static NOTIFICATION_PREFERENCES_DESCRIPTION =
    'Choose which notifications reach you in the bell and this center. New categories are on by default.'
  static NOTIFY_CUSTOMER = 'Notify customer'
  static NOTIFY_TEMPLATE_COMING_SOON = 'Coming soon: this default message will be editable in messaging settings.'
  static NOT_ALLOWED_OFFICE_LOGIN_MSG =
    'Uh-oh! This user does not have rights to access the web app. Please contact the administrator for further details.'
  static NOT_APPLIED = 'Not applied'
  static NOT_CONFIGURED = 'Not configured'
  static NOT_COST_PLUS = 'Not Cost Plus'
  static NOT_ON_A_SERVICE = 'Not on a service'
  static NOT_ON_MASTER = 'Not on master'
  static NOT_ON_MASTER_HINT = "Not on the master sequence — this stop won't carry over when you promote this day"
  static NOT_OPTIMIZED = 'Not optimized'
  static NOT_OPTIMIZED_LOWERCASE = 'not optimized'
  static NOT_OUT = 'Not out'
  static NOT_READY_FOR_INVOICE_LABEL = 'Not ready'
  static NOT_READY_FOR_INVOICE_TEXT = 'Not ready for invoice'
  static NOT_SENT_BY = 'Not Sent by'
  static NOT_SERIALIZED = 'Not serialized'
  static NOT_SET = 'Not set'
  static NOT_STARTED = 'Not Started'
  static NOT_SUB_ITEM = 'Not Sub-Item'
  static NOT_UPDATING = 'Not updating'
  static NOT_VISIBLE_ON_MOBILE = 'Not visible on mobile'
  static NOT_YET_ASSIGNED = 'Not yet assigned'
  static NO_ACCESS = 'No Access'
  static NO_ACCOUNTS_FOUND = 'No accounts found.'
  static NO_ACCOUNTS_TO_MESSAGE = 'No accounts to message'
  static NO_ACCOUNT_GROUPS = 'Click + button above to add an account group'
  static NO_ACCOUNT_NOTES = 'No account notes have been created yet'
  static NO_ACTION_BASED_PRICING_AVAILABLE = 'No action based pricing available'
  static NO_ACTIVE_HOLDS = 'There are no active holds on this account'
  static NO_ACTIVE_LATE_FEES_TO_LINK = 'There are no active late fees to link'
  static NO_ACTIVITY_FOUND = 'No activity found'
  static NO_ADDITIONAL_DETAILS = 'No additional details'
  static NO_ADDRESSES_FOUND = 'No addresses found.'
  static NO_ARCHIVED_NOTES_FOUND = 'No archived notes found'
  static NO_ARCHIVED_NOTE_AVAILABLE = 'No archived note available'
  static NO_BATCH_DATA_FOR_POSTCARD = 'No batch data available. Please generate bulk print data first.'
  static NO_BENEFICIAL_OWNER_CONTACTS = 'Click + button above to add a beneficial owner contact'
  static NO_BILLING_DETAILS = 'No Billing Details for this customer yet'
  static NO_BILLING_EMAIL_ADD_CONTACT_LEAD = 'This account has no billing email. Add a billing contact in the '
  static NO_BILLING_EMAIL_ADD_CONTACT_TAIL = ' section so the customer receives invoices.'
  static NO_BILLING_EMAIL_PRINTED_COPY_LEAD = 'Without a billing email, invoices are mailed. Turn on '
  static NO_BILLING_EMAIL_PRINTED_COPY_TAIL = ' for this account?'
  static NO_BILLING_EMAIL_TITLE = 'No billing email'
  static NO_BILLING_INVOICES_FOUND = 'No Invoices Found'
  static NO_BILLING_LOCK_HISTORY = 'No billing lock history yet'
  static NO_BILLING_NOTES = 'No billing notes have been created yet'
  static NO_CALLS = 'Click + button above to add a call'
  static NO_CAMPAIGNS_YET = 'No campaigns yet.'
  static NO_CAMPAIGNS_YET_DESCRIPTION = 'Once your brand is verified, campaigns submitted for this brand will appear here.'
  static NO_CHANGES_MADE = 'No changes have been made'
  static NO_CHANGES_TO_UPDATE = 'There are no changes to update'
  static NO_CONFIGURED_SERVICES = 'Click + button above to add a service'
  static NO_CONTACTS = 'Click + button above to add a contact'
  static NO_CONTACTS_FOUND = 'No contacts found'
  static NO_CONTACTS_WITH_EMAIL = 'No contacts with email'
  static NO_CONTAINER = 'No container'
  static NO_CONTAINERS = 'No containers found'
  static NO_CONTAINERS_AVAILABLE_IN_INVENTORY = 'No containers available in inventory'
  static NO_CONTAINER_ON_THIS_SERVICE = 'No container'
  static NO_CONTAINER_ROWS_ARE_REMOVED = 'no-container rows are removed'
  static NO_CONTAINER_ROW_IS_REMOVED = 'no-container row is removed'
  static NO_CONTAINER_VALUES_TO_COPY = 'None of the selected containers have a value to copy.'
  static NO_CS_FEE = 'No Fee for this service yet'
  static NO_CS_NOTES = 'No configured service notes have been created yet'
  static NO_CS_PRICING_SERVICE = 'No Pricing Service for this search'
  static NO_CUSTOMERS = 'No customers found'
  static NO_DATA = 'No Data found'
  static NO_DATA_FOUND_IN_CSV_FILE = 'No data found in the CSV file.'
  static NO_DATE = 'No Date'
  static NO_DEACTIVATED_CONFIGURED_SERVICES = 'No deactivated configured services for this customer yet'
  static NO_DEACTIVATED_LOCATIONS = 'No Deactivated Locations for this customer yet'
  static NO_DELIVERY_FAILURES_TO_REVIEW = 'No delivery failures to review'
  static NO_DELIVERY_SCHEDULED = 'No delivery scheduled'
  static NO_DETECTIONS = 'No detections to display'
  static NO_DISPOSAL_TICKETS_FOUND = 'No disposal tickets found'
  static NO_DISPOSAL_TICKET_FOUND = 'No disposal ticket found'
  static NO_DRAFT_INVOICE_IN_INVOICE_GROUP = 'This invoice group has no draft invoices'
  static NO_EMAIL_ACTIVITY_FOUND = 'No email activity available'
  static NO_EMAIL_EVENTS = 'No e-mail events yet'
  static NO_EMAIL_NOTIFICATIONS_SUSPENSION_DESC =
    'You will not receive an email notification when an account is automatically suspended. If you’d like to be notified about suspended accounts, our team can help set up a report that sends automatic alerts.'
  static NO_EMAIL_NOTIFICATIONS_TITLE = 'No email notifications.'
  static NO_EVENTS_ON_DATE = 'No events scheduled for this date.'
  static NO_EVENTS_ON_REQUEST_SERVICE = 'There are no events set up for this on-request service yet'
  static NO_EXCEPTIONS_DETECTED = 'No exceptions detected'
  static NO_EXCEPTIONS_ON_STOP = 'No driver-reported exceptions on this stop'
  static NO_EXCLUDED_RULES = 'No excluded rules'
  static NO_FAILED_MESSAGES = 'No failed messages'
  static NO_FEES_FOUND = 'No fees found.'
  static NO_FOLLOW_UP = 'Click + button above to add a follow-up'
  static NO_GENERAL_FEES_ON_THIS_SERVICE_YET = 'No general fees on this service yet'
  static NO_GRACE_PERIOD_RESET_HISTORY = 'No grace period reset history'
  static NO_INCLUDED_RULES = 'No included rules'
  static NO_INFO_ON_FILE = 'No email on file'
  static NO_INVOICES = 'No invoices for this customer yet'
  static NO_INVOICES_FOR_THIS_CUSTOMER = 'No invoices for this customer'
  static NO_INVOICE_ACTIVITY_FOUND = 'No invoice activity available'
  static NO_INVOICE_DATA = 'No invoice data yet'
  static NO_INVOICE_GROUPS = 'Click + button above to add an invoice group'
  static NO_LATE_FEES_LINKED_TO_ACCOUNT = 'No late fees linked to this account'
  static NO_LIST_MEMBERS = 'No accounts on this list yet'
  static NO_LOCATIONS = 'No Locations for this customer yet'
  static NO_LOCATIONS_FOUND = 'No locations found'
  static NO_LOCATION_CONTACTS = 'No Location contacts'
  static NO_LOCATION_DATA = 'No location data available'
  static NO_LOCATION_MSG = 'No location on this work order yet'
  static NO_LOCATION_NOTES = 'No location notes have been created yet'
  static NO_LOCATION_NOTES_YET = 'No notes on this location yet'
  static NO_LOSS_REASONS_SET_UP = 'No loss reasons are set up yet. Add them under Settings › Account settings.'
  static NO_MATCHES = 'No matches'
  static NO_MATCHING_RULES = 'No matching rules'
  static NO_MATERIAL = 'No material'
  static NO_MEDIA_AVAILABLE = 'No media available'
  static NO_MEDIA_CAPTURE_PENDING = 'Video and photo capture are pending for this service.'
  static NO_MESSAGES_SENT_YET = 'No messages sent yet'
  static NO_MESSAGE_CONTENT_YET = 'No message content yet'
  static NO_MOVES_FOUND = 'No moves available'
  static NO_NOTES = 'No notes'
  static NO_NOTES_ON_STOP = 'No notes on this stop'
  static NO_NOTES_V2 = 'Click + button above to add a note'
  static NO_NOTES_YET = 'No notes yet'
  static NO_NUMBERS_AVAILABLE = 'No numbers available. Try entering an area code.'
  static NO_NUMBERS_FOR_AREA_CODE_PREFIX = 'No numbers available for area code'
  static NO_NUMBERS_FOR_AREA_CODE_SUFFIX = 'Try a different area code or search without one.'
  static NO_OPTIMIZED_ROUTE_AVAILABLE = 'No optimized route available'
  static NO_OPTIONS = 'No options'
  static NO_OPTIONS_FOUND = 'No options found'
  static NO_PAYMENTS = 'No payments for this customer yet'
  static NO_PAYMENT_ACTIVITY_FOUND = 'No payment activity available'
  static NO_PAYMENT_BATCHES_FOUND = 'No payment batches found'
  static NO_PAYMENT_DATA = 'No payment data yet'
  static NO_PAYMENT_GROUPS = 'Click + button above to add a payment group'
  static NO_PERMISSION_EDIT_PRICES = "You don't have permission to edit prices"
  static NO_PERMISSION_TO_SET_CUSTOM_PRICE = 'You do not have permission to set a custom price'
  static NO_PHONE_NUMBER_ASSIGNED = 'No phone number assigned yet.'
  static NO_PHONE_ON_FILE = 'No phone on file'
  static NO_PHOTOS_ON_STOP = 'No photos attached to this stop'
  static NO_PRICED_SERVICES_LINKED_TO_DISPOSAL_FEE = 'No priced services linked to this disposal fee'
  static NO_PRICED_SERVICES_LINKED_TO_RENTAL_FEE = 'No priced services linked to this rental fee'
  static NO_PRICED_SERVICE_SELECTED = 'Please select a priced service from the list'
  static NO_PRICING_FEES_FOUND = 'No Fees Found'
  static NO_PRICING_SERVICES_FOUND = 'No Services Found'
  static NO_PRICING_TAXES_FOUND = 'No Taxes Found'
  static NO_PURCHASE_ORDER_ON_STOP = 'No purchase order on this stop'
  static NO_RATE_CHANGES_YET = 'No rate changes yet — schedule one on the left to get started.'
  static NO_RECIPIENT_MESSAGES = 'No messages were sent for this broadcast'
  static NO_RECORD = 'No Record'
  static NO_RECORDS = 'There are no records'
  static NO_RENTAL_FEES = 'No rental fees'
  static NO_RENTAL_FEES_LINKED_TO_PRICED_SERVICE = 'No rental fees linked to this priced service'
  static NO_RENTAL_PERIOD_ACTIVITY = 'No rental period activity'
  static NO_REPLACEMENT_IS_COMING = 'No replacement is coming'
  static NO_REPORTS_FOUND = 'No Reports Found'
  static NO_RESET_HISTORY_FOR_DATE = 'No reset history found for this date'
  static NO_RESULTS = 'There are no results'
  static NO_RESULTS_FOUND = 'No results found'
  static NO_ROAD_RESTRICTIONS = 'No road restrictions'
  static NO_ROWS_SELECTED = 'No rows selected'
  static NO_SCHEDULED_MESSAGES_YET = 'No scheduled messages yet'
  static NO_SENT_MESSAGES = 'No sent messages'
  static NO_SERVICES_FOUND = 'No services found.'
  static NO_SERVICES_FOUND_FOR_LOCATION = 'No services found for this location'
  static NO_SERVICE_NOTES_YET = 'No notes on this service yet'
  static NO_STATEMENTS = 'No statements for this customer yet'
  static NO_STOPS_FOUND = 'No stops found'
  static NO_SUBJECT = 'No subject'
  static NO_SUSPENSION_HISTORY = 'This account has no suspension history.'
  static NO_TAGS = 'No Tags'
  static NO_TAXES_FOUND = 'No taxes found'
  static NO_TAXES_ON_THIS_SERVICE_YET = 'No taxes on this service yet'
  static NO_TAX_ZONE = 'No Tax for this Tax Zone yet'
  static NO_TAX_ZONE_SELECTED = 'Please select the Tax Zone'
  static NO_TRUCK_ASSIGNED = 'No truck assigned'
  static NO_UNPAID_INVOICE_IN_INVOICE_GROUP = 'This invoice group has no unpaid invoices'
  static NO_VALID_PAYMENT_DATA_EXTRACTED = 'No valid payment data could be extracted from the CSV file.'
  static NO_VIDEO = 'No video'
  static NO_VIDEO_ON_STOP = 'No video on this stop'
  static NO_WON_REASONS_SET_UP = 'No won reasons are set up yet. Add them under Settings › Account settings.'
  static NO_WORK_ORDERS = 'No work orders for this customer yet'
  static NO_WORK_ORDERS_FOR_WEEK = 'No work orders for this week'
  static NO_WORK_ORDERS_FOUND = 'No work orders found'
  static NO_WORK_ORDERS_WEEK = 'No work orders found for this week.'
  static NO_WORK_ORDER_ACTIVITY_FOUND = 'No work order activity found'
  static NO_WORK_ORDER_DATA = 'No work order data'
  static NO_WORK_ORDER_NOTES = 'No work order notes have been created yet'
  static NO_WORK_ORDER_NOT_LINKED = 'Work order details have not been linked yet.'
  static NO_WO_EXCEPTIONS = 'No Exceptions for this work order yet'
  static NO_WO_FEES = 'No fees have been added to this work order'
  static NO_WO_INVOICE = 'No Invoice Details for this work order yet'
  static NO_WO_NOTES_YET = 'No notes on this work order yet'
  static NO_WO_SERVICE_DETAILS = 'No Service Details for this work order yet'
  static NO_ZONES_AVAILABLE = 'No zones available'
  static NO__BULK_PRINT_DATA_AVAILABLE = 'No data available. Please generate bulk print data to proceed.'
  static NUMBER = 'Number'
  static NUMBERS_AVAILABLE = 'available — select one to provision'
  static NUMBER_ACTIVATING_HINT = 'Awaiting carrier confirmation.'
  static NUMBER_ACTIVATION_PENDING = 'Phone number assignment is in progress.'
  static NUMBER_CLAIMED = 'Number claimed'
  static NUMBER_CLAIMED_ACTIVATION_NOTE = 'It will activate automatically as soon as your campaign is approved by TCR.'
  static NUMBER_CLAIMED_DESCRIPTION = 'The number below is reserved for your account.'
  static NUMBER_COLUMN = 'Number'
  static NUMBER_OF_ACCOUNTS = 'Number of accounts'
  static NUMBER_OF_CONTAINERS = 'Number of containers'
  static NUMBER_OF_EXTRAS = 'Number of Extras'
  static NUMBER_OF_ROUTES = 'Number of routes'
  static NUMBER_PENDING_CAMPAIGN = 'A phone number can be assigned once a campaign is approved.'
  static NUMBER_PENDING_DCA_APPROVAL =
    'Your campaign is approved by TCR and is awaiting carrier acceptance. A phone number can be assigned once carrier acceptance completes.'
  static NUMBER_POOL = 'Number Pool'
  static NUMBER_PROVISIONING_CAMPAIGN_LABEL = 'Campaign'
  static OF = 'of'
  static OFF = 'Off'
  static OFFICE = 'Office'
  static OFFSET_LEVEL = 'Offset level (m)'
  static OFFSET_LEVEL_TOOLTIP = 'Controls the offset spacing for individual stop markers that overlap with each other.'
  static OK = 'OK'
  static OKAY = 'Okay'
  static OLDEST = 'Oldest'
  static OLDEST_FIRST = 'Oldest first'
  static ON = 'On'
  static ONCE = 'Once'
  static ONE_OFF = 'One off'
  static ONE_TIME_REGISTRATION_FEE = 'One-time registration fee:'
  static ONGOING = 'Ongoing'
  static ONLY_25_ROUTES_DISPLAYED = 'Routes with more than 25 stops cannot be optimized'
  static ONLY_CONTAINER_ON_SERVICE = 'This is the only container on this service.'
  static ONLY_CSV_FILES_SUPPORTED = 'Only CSV files are supported'
  static ONLY_SHOW_SOURCE_SEQUENCE_CHANGES_TOOLTIP = 'Only show the source sequence changes and hide shifted stops'
  static ONLY_WEEKLY_SERVICES_SUPPORTED = 'Only 1-6x weekly services are supported at this time.'
  static ON_RECCURING_DEACTIVATE_FUTURE_DATE_MSG = 'Service cannot be deactivated until the service end date.'
  static ON_RECCURING_DEACTIVATE_NO_END_DATE_MSG = 'You must specify a service end date before you can deactivate the service.'
  static ON_RECCURING_SET_END_DATE_MSG =
    'Setting an end date for this service will stop the generation of new work orders and delete existing work orders after the service end date. Do you want to continue?'
  static ON_REQUEST = 'On Request'
  static ON_REQUEST_CHIP_TOOLTIP = 'One-off adds that don’t recur on master'
  static ON_REQUEST_CHIP_TOOLTIP_JUMP = 'One-off adds that don’t recur on master — click to jump to the first'
  static ON_REQUEST_DEACTIVATE = 'You must remove all future service events before you can deactivate the service.'
  static ON_REQUEST_SERVICE = 'On-request service'
  static ON_REQUEST_SERVICE_DESCRIPTION = 'Any on-request service'
  static ON_REQ_SHORT = 'on-req'
  static ON_THESE_DATES = 'On these dates'
  static ON_THESE_DAYS = 'On these days'
  static OPEN = 'Open'
  static OPENS_SERVICE_DETAILS = 'opens service details'
  static OPEN_FULL_LIST = 'Open full list'
  static OPEN_FULL_NOTIFICATIONS_PAGE = 'Open full notifications page'
  static OPEN_IN_EXCEPTIONS = 'Open in Exceptions'
  static OPEN_WORK_ORDER_NEW_TAB = 'Open work order in a new tab'
  static OPTED_OUT = 'Opted Out'
  static OPTIMIZATION_BACKGROUND_HINT = "Running in the background — keep working; you'll be notified when it's ready."
  static OPTIMIZATION_DOES_NOT_AFFECT_FUTURE_STOPS = 'This does not affect future stops of this service'
  static OPTIMIZATION_IN_PROGRESS = 'Optimization in progress…'
  static OPTIMIZATION_LARGE_LEAVE_PAGE = "Large route — feel free to leave the page, we'll keep working"
  static OPTIMIZATION_LARGE_ROUTE_HINT = "Large route — runs in the background, and you'll get a notification when it's ready."
  static OPTIMIZATION_LARGE_ROUTE_SUFFIX = "— runs in the background; you'll get a notification when it's ready."
  static OPTIMIZATION_MAY_TAKE_A_MOMENT = 'May take a few moments'
  static OPTIMIZATION_REORDERS_MASTER = 'Reorders the master column on run.'
  static OPTIMIZATION_REORDERS_MASTER_AND_FUTURE = 'Applies to master and every future day.'
  static OPTIMIZATION_REORDERS_THIS_DAY = 'Applies to this day only.'
  static OPTIMIZATION_RERUN_HINT = 'Reordering applies on run — Discard reverts.'
  static OPTIMIZATION_RESULTS = 'Optimization results'
  static OPTIMIZATION_RUN_NOT_REVIEWABLE = 'This optimization did not finish, so there is nothing to review. Optimize the route again.'
  static OPTIMIZATION_RUN_UNAVAILABLE = 'This optimization run is no longer available. Optimize the route again.'
  static OPTIMIZATION_SAVE_FAILED = 'optimization save failed'
  static OPTIMIZATION_STALE_STOPS = 'This run no longer matches the route — its stops changed since it was optimized:'
  static OPTIMIZATION_STOPS_NOT_ON_MASTER = 'stops are not on the master sequence and will keep their current position'
  static OPTIMIZE = 'Optimize'
  static OPTIMIZED = 'Optimized'
  static OPTIMIZED_ROUTE = 'Optimized route'
  static OPTIMIZED_SEQUENCE = 'Optimized sequence'
  static OPTIMIZED_SEQUENCE_MISSING_STOPS = 'Optimized sequence is missing stops; not saving.'
  static OPTIMIZE_FOR = 'Optimize for'
  static OPTIMIZE_FOR_HELP = 'Time = fastest completion. Distance = lowest miles driven.'
  static OPTIMIZE_IN_BACKGROUND = 'Optimize in background'
  static OPTIMIZE_MASTER_AND_FUTURE = 'Optimize master & future days'
  static OPTIMIZE_MASTER_TOOLTIP = 'Optimize master sequence — applies to every future day'
  static OPTIMIZE_ROUTE = 'Optimize route'
  static OPTIMIZE_ROUTE_TOOLTIP = 'Optimize route — open settings & run'
  static OPTIMIZE_THIS_DAY = 'Optimize this day'
  static OPTIMIZING = 'Optimizing…'
  static OPTIMIZING_IN_BACKGROUND = 'Optimizing in background…'
  static OPTIMIZING_MASTER_SEQUENCE = 'Optimizing master sequence'
  static OPTIMIZING_ROUTE = 'Optimizing route'
  static OPTIN_CONFIRMATION_MESSAGE = 'Opt-in confirmation message'
  static OPTIN_KEYWORDS = 'Opt-in keywords'
  static OPTIN_KEYWORDS_HINT = 'Comma-separated. Optional.'
  static OPTIONAL = 'Optional'
  static OPTIONAL_NOTES = 'Optional notes...'
  static OPTION_NOT_APPLICABLE_TO_ANNIVERSARY_TIMING = 'Option not applicable to Anniversary Timing'
  static OPTOUT_CONFIRMATION_MESSAGE = 'Opt-out confirmation message'
  static OPTOUT_KEYWORDS = 'Opt-out keywords'
  static OPTOUT_KEYWORDS_HINT = 'Comma-separated. Must include STOP.'
  static OPT_IN_ALL_DISCLOSURES_MET = 'All required disclosures are covered.'
  static OPT_IN_BRAND_HIGHLIGHT_LEGEND = 'is your DBA / business name, filled in automatically'
  static OPT_IN_BUILDER_APPLY = 'Use this description'
  static OPT_IN_BUILDER_HELP =
    'Answer a couple of questions and we\u2019ll draft a compliant description for you, using your business name and every required disclosure. You can edit the result below before submitting.'
  static OPT_IN_BUILDER_PREVIEW_LABEL = 'Preview'
  static OPT_IN_BUILDER_TITLE = 'Build your opt-in description'
  static OPT_IN_BUILDER_TOO_LONG =
    'This description is too long to submit. Shorten your business name or the list of alert topics, then try again.'
  static OPT_IN_BUILDER_TOPICS_LABEL = 'What do you text customers about?'
  static OPT_IN_BUILDER_TOPICS_PLACEHOLDER = 'e.g. service delays, schedule changes, pickup reminders, billing alerts'
  static OPT_IN_BUILDER_WHEN_LABEL = 'When do your staff capture the customer\u2019s verbal consent?'
  static OPT_IN_DIVERGED_TITLE =
    'Your description has diverged from our template, so we can no longer confirm these requirements. To re-enable them, click Use this description. We\u2019ll review your final wording before submission.'
  static OPT_IN_EXISTING_CUSTOMERS_BODY =
    'Customers who already consented to messaging do not need to opt in again. Never text numbers that were purchased or sourced anywhere other than directly from the customer - doing so risks spam complaints that hurt deliverability for everyone.'
  static OPT_IN_EXISTING_CUSTOMERS_TITLE = 'Existing customers'
  static OPT_IN_FLOW_HINT = 'Describe exactly how customers provide consent, including the script your staff reads.'
  static OPT_IN_FLOW_LABEL = 'Opt-In Flow Description'
  static OPT_IN_INTRO_BODY =
    'Carriers require proof of how your customers consent to receive texts. We use a verbal opt-in: your staff reads a short script that includes the required disclosures, the customer agrees, and you record that consent on their account. No web form is needed.'
  static OPT_IN_INTRO_TITLE = 'Verbal opt-in at signup'
  static OPT_IN_NEW_CUSTOMERS_BODY =
    'When you set up service or take a service call, your staff reads the opt-in script below and records the customer\u2019s verbal consent on their account.'
  static OPT_IN_NEW_CUSTOMERS_TITLE = 'New customers'
  static OPT_IN_NO_MARKETING_NOTE =
    'This script covers service and account alerts only. Marketing or promotional texts are not supported and require a separate double opt-in.'
  static OPT_IN_REQUIREMENTS_HELP =
    'Requirements turn green as your description covers them. Carriers reject descriptions that are missing any disclosure.'
  static OPT_IN_REQUIREMENTS_TITLE = 'Your opt-in description must include all of these'
  static OPT_IN_SECTION = 'Opt-In Flow'
  static OPT_IN_STEP_TITLE = 'How Customers Opt In'
  static OPT_OUT_RATE = 'Opt-Out Rate'
  static OR = 'OR'
  static ORDER = 'Order'
  static ORDERED = 'ordered'
  static ORDER_PLACEHOLDER = 'Order'
  static ORIGINAL = 'Original'
  static ORIGINAL_ORDER = 'Original order'
  static ORIGINAL_ROUTE = 'Original route'
  static ORIGIN_ADDRESS = 'Origin address'
  static OR_DRAG_AN_IMAGE_HERE = 'or drag an image here'
  static OR_LOWERCASE = 'or'
  static OTHER = 'Other'
  static OTHER_ATTACHMENTS = 'Other attachments'
  static OUTCOME = 'Outcome'
  static OUTSTANDING = 'Outstanding'
  static OVERAGE = 'Overage'
  static OVERAGE_FEE = 'Overage Fee'
  static OVERAGE_THRESHOLD = 'Overage Threshold'
  static OVERAGE_WEIGHT = 'Overage weight'
  static OVERLOADED = 'Overloaded'
  static OVERRIDES = 'Overrides'
  static OVERRIDES_HELPER =
    'Rules override the switches in both directions. All conditions within one rule must match the same charge; separate rules match independently. Any matching exclude rule wins over every include rule, and rule order never matters.'
  static OVERVIEW = 'Overview'
  static PAGE_VIEW = 'Page view'
  static PAID = 'Paid'
  static PAINT_DATE = 'Paint date'
  static PAPER = 'Paper'
  static PARAMETERS = 'Parameters'
  static PARCEL_NUMBER = 'Parcel #'
  static PARTIAL = 'Partial'
  static PARTIAL_REFUND_PAYMENT = 'Partial Refund'
  static PASSWORD = 'Password'
  static PASSWORD_CHANGED_SUCCESSFULLY = 'Password changed successfully'
  static PASSWORD_LENGTH_MSG = 'Minimum 6 characters'
  static PAST_DUE = 'Past due'
  static PAUSE = 'Pause'
  static PAY = 'Pay'
  static PAYMENT = 'Payment'
  static PAYMENTS = 'Payments'
  static PAYMENTS_FROM = 'payments from'
  static PAYMENTS_FROM_CSV_DATA = 'payments from CSV data.'
  static PAYMENTS_MADE = 'Payments made'
  static PAYMENTS_MADE_DESCRIPTION = 'If a payment is made on an invoice'
  static PAYMENTS_PROCESSED = 'payments processed'
  static PAYMENTS_TEXT = 'payments'
  static PAYMENT_ACH_FAILED_MSG = 'Payment is failing'
  static PAYMENT_ADDRESS = 'Payment address'
  static PAYMENT_ALREADY_ACH_FAILED_MSG = 'This payment has already been marked as ACH failed'
  static PAYMENT_ALREADY_REVERT_TRANSFER_MSG = 'This payment has already been reverted or transferred'
  static PAYMENT_BATCHES = 'Payment batches'
  static PAYMENT_BATCHES_PLURAL = 'payment batches'
  static PAYMENT_BATCH_CONFIRMATION = 'Payment Batch Confirmation'
  static PAYMENT_BATCH_CREATED_SUCCESSFULLY_WITH = 'Payment batch created successfully with'
  static PAYMENT_BATCH_MISSING_REQUIRED_FIELDS =
    'Payment batch is missing required fields and cannot be posted. Please fill in all required fields and try again.'
  static PAYMENT_BATCH_POSTED_SUCCESSFULLY = 'Payment batch posted successfully.'
  static PAYMENT_BATCH_POSTED_SUCCESSFULLY_REDIRECT = 'Redirecting to Payment batches page...'
  static PAYMENT_BATCH_PROCESSING = 'Payment batch is processing ...'
  static PAYMENT_BATCH_SINGULAR = 'payment batch'
  static PAYMENT_BATCH_TEMPLATE_FILENAME = 'payment_batch_template.csv'
  static PAYMENT_CREATED_FOR = 'Payment created for'
  static PAYMENT_DATE = 'Payment Date'
  static PAYMENT_DETAILS = 'Payment details'
  static PAYMENT_DUE_DATE_CONFIGURATION = 'Payment due date configuration'
  static PAYMENT_DUE_NET_DAYS = 'Net [x] days'
  static PAYMENT_DUE_SPECIFIC_DAY_OF_MONTH = 'Specific date'
  static PAYMENT_GROUPS = 'Payment groups'
  static PAYMENT_GROUP_CREATED_SUCCESS_MSG = 'Payment group created successfully'
  static PAYMENT_GROUP_NAME = 'Payment group name'
  static PAYMENT_GROUP_UPDATED_SUCCESS_MSG = 'Payment group updated successfully'
  static PAYMENT_HAS_PARTIAL_REFUNDS_MSG = 'Cannot fully reverse a payment that has partial refunds'
  static PAYMENT_ID = 'Payment ID'
  static PAYMENT_MARKED_AS_REVERSED_SUCCESSFULLY = 'Payment marked as reversed successfully'
  static PAYMENT_METHOD = 'Payment Method'
  static PAYMENT_METHOD_ADD_SUCCESS_MESSAGE = 'Payment method added successfully'
  static PAYMENT_METHOD_ALREADY_EXISTS = 'Payment method already exists'
  static PAYMENT_METHOD_DELETE_SUCCESS_MESSAGE = 'Payment method deleted successfully'
  static PAYMENT_METHOD_IS_REQUIRED = 'Payment method is required'
  static PAYMENT_NOTE = 'Payment note'
  static PAYMENT_PERMISSION_NOTE = 'View payments; edit notes on payments; collect new payment & refund payments'
  static PAYMENT_PROCESSING = 'Payment is processing ...'
  static PAYMENT_RECEIPT_CONFIRMATION = 'Payment receipt confirmation'
  static PAYMENT_REMOVED = 'Payment removed'
  static PAYMENT_REPORT = 'PAYMENT_REPORT'
  static PAYMENT_REPORT_TYPE_FILTER = 'PAYMENTS'
  static PAYMENT_REVERT_MSG = 'Payment is reverting'
  static PAYMENT_STATUS = 'Payment Status'
  static PAYMENT_TERMS = 'Payment terms'
  static PAYMENT_TERMS_HISTORY = 'Payment terms history'
  static PAYMENT_TERMS_UPDATED_DETAILED =
    'New payment terms successfully updated. To reflect changes on any old draft invoices, please regenerate them individually.'
  static PAYMENT_TERMS_UPDATED_SUCCESSFULLY = 'Payment terms updated successfully'
  static PAYMENT_TERMS_UPDATED_TITLE = 'Payment terms updated'
  static PAYMENT_TERM_TYPE = 'Payment term type'
  static PAYMENT_TRANSFER_MSG = 'Payment is transferring'
  static PAYMENT_TYPE = 'Payment Type'
  static PAYMENT_TYPE_MANUAL = 'Manual'
  static PAYMENT_VOIDED_SUCCESSFULLY = 'Payment voided successfully'
  static PAYMENT_WILL_BE_PROCESSED_WITHOUT_INVOICE_DETAILS = 'Payment will be processed without invoice details.'
  static PAYROLL = 'Payroll'
  static PAY_RATE = 'Pay Rate'
  static PCI_NOTE_WARNING_BODY =
    'Doing so violates compliance rules and, as a result, data may be purged during automated system PCI compliance scrubbing, leading to irrecoverable data loss.'
  static PCI_NOTE_WARNING_TITLE = 'Do not store Credit Card / ACH payment information in notes.'
  static PDF = 'PDF'
  static PENDING = 'Pending'
  static PENDING_DELETION = 'Pending deletion'
  static PENDING_LABEL = 'Pending'
  static PENDING_MOVES = 'Pending moves'
  static PENDING_PLACEMENT = 'Pending delivery'
  static PENDING_PLACEMENTS = 'Pending deliveries'
  static PENDING_PLACEMENTS_ARE_CANCELLED = 'pending deliveries are cancelled'
  static PENDING_PLACEMENT_IS_CANCELLED = 'pending delivery is cancelled'
  static PENDING_REVIEW = 'Pending review'
  static PEOPLE = 'People'
  static PERIOD = 'Period'
  static PERMANENT = 'Permanent'
  static PERMANENT_ACTION_CONFIRMATION = 'I understand that this action is permanent and cannot be undone.'
  static PERMANENT_CHANGE_RECURRENCE_DAY = 'Permanent change recurring day'
  static PERMANENT_CHANGE_RECURRENCE_WEEKLY_ONLY =
    'Currently, permanent changes to recurring services are only available for weekly services.'
  static PERMANENT_MOVE_CONFIRMATION = 'Permanent move confirmation'
  static PERMISSION = 'Permission'
  static PERMIT = 'Permit'
  static PERMIT_NUMBER_DESCRIPTION = 'Printed in the upper right of the postage area'
  static PERMIT_NUMBER_OPTIONAL = 'Permit # (optional)'
  static PERSONAL_INFORMATION = 'Personal Information'
  static PER_PAGE = 'per page'
  static PER_TAX = 'per tax'
  static PHONE = 'Phone'
  static PHONE_NUMBER = 'Phone Number'
  static PHONE_NUMBER_PROVISIONED = 'Phone number provisioned'
  static PHOTO = 'Photo'
  static PHOTOS = 'Photos'
  static PICK_FROM_INVENTORY = 'Pick from available numbers'
  static PICK_FROM_INVENTORY_DESCRIPTION =
    'Search by area code and claim a number from our pre-vetted inventory. Activates as soon as your campaign is approved.'
  static PIN = 'Pin'
  static PLACEMENT_CANCELLED = 'Delivery cancelled'
  static PLACEMENT_CANCEL_CONSEQUENCE = 'The delivery is cancelled. Nothing entered inventory, so nothing returns to a yard.'
  static PLEASE_FILL_OUT_ALL_FIELDS_BEFORE_SUBMITTING = 'Please fill out all fields before submitting the form.'
  static PLEASE_FIX_FORM_ERRORS = 'Please fix form errors'
  static PLEASE_MAP_AT_LEAST_ONE_CSV_COLUMN = 'Please map at least one CSV column to a payment field.'
  static PLEASE_SELECT = 'Please select'
  static PLEASE_SELECT_AN_INVOICE_ERROR = 'Please select an invoice'
  static PLEASE_SELECT_INVOICES = 'Please select invoices'
  static PLEASE_SELECT_LOCATION = 'Please select a location'
  static PLEASE_SELECT_PRICED_SERVICE = 'Please select a priced service'
  static PO = 'PO'
  static PORTAL = 'Portal'
  static PORT_EXISTING_NUMBER = 'Port an existing number'
  static PORT_EXISTING_NUMBER_CTA = 'Start a port request'
  static PORT_EXISTING_NUMBER_DESCRIPTION =
    'Move a number you already own to our platform. Requires carrier authorization details and a signed Letter of Authorization.'
  static POSITION = 'Position'
  static POSITIONING_STRATEGY_DIALOG_INTRO =
    'When you reorder stops on master, this decides how the change impacts each day, especially when there is variance from week to week.'
  static POSITIONING_STRATEGY_DIALOG_TITLE = 'How should master route changes update daily routes?'
  static POSITIONING_STRATEGY_DONT_SHOW_AGAIN = "Don't show this again on this browser"
  static POSITIONING_STRATEGY_FIXED_POSITION_BODY =
    'When you move a stop on the master, each corresponding stop on each upcoming day is given the same sequence number. This was the original implementation of the master route sequence tool and is offered for those who want to maintain the original pattern.'
  static POSITIONING_STRATEGY_FIXED_POSITION_TITLE = 'Fixed position'
  static POSITIONING_STRATEGY_PICK = 'Pick a strategy'
  static POSITIONING_STRATEGY_SMART_NEIGHBORS_BODY =
    "When you move a stop on the master, each corresponding stop on each upcoming day is moved so that it lands between the same two stops it sits between on the master. If a daily doesn't have one of those neighbors that day, the stop anchors to its nearest neighbor from the master instead, and only goes to the top when none of them are on that day."
  static POSITIONING_STRATEGY_SMART_NEIGHBORS_TITLE = 'Smart neighbors (recommended)'
  static POSITIONING_STRATEGY_USE_FIXED_POSITION = 'Use fixed position'
  static POSITIONING_STRATEGY_USE_SMART_NEIGHBORS = 'Use smart neighbors'
  static POSITION_IN_ROUTE = 'Position in route'
  static POSITION_PAST_THE_END_LANDS_LAST = 'A position past the end of the route puts the stop last.'
  static POST = 'Post'
  static POSTCARD = 'Postcard'
  static POSTCARDS_ON_PAGE = 'Postcards on page'
  static POSTCARD_LAYOUT = 'Postcard Layout'
  static POSTCARD_PREVIEW = 'Postcard Preview'
  static POSTCARD_SETUP = 'Postcard Setup'
  static POSTED = 'Posted'
  static POSTED_AND_PAID = 'Posted & Paid'
  static POSTED_DATE = 'Posted Date'
  static POSTING = 'Posting...'
  static POSTING_TAB_LABEL = 'Posting'
  static POSTS_TO = 'Posts to'
  static POST_AND_EMAIL = 'Post and email'
  static POST_AND_SEND_INVOICE_SUCCESS = 'Invoice posted and sent successfully'
  static POST_DRAFT = 'Post draft'
  static POST_DRAFTS = 'Post drafts'
  static POST_DRAFTS_AND_EMAIL = 'Post drafts and email'
  static POST_INVOICES_PAYMENT = 'Post Invoices and Payments'
  static POST_INVOICES_PAYMENTS = 'Post invoices & payments'
  static POST_INVOICE_SUCCESS = 'Invoices have been posted'
  static POST_NO_DRAFT_BATCHES = 'Post (no draft batches)'
  static POST_SELECT_DRAFT_ONLY = 'Select draft invoices only'
  static POST_SELECT_ONE_BATCH = 'Post (select one batch)'
  static POST_SINGLE_INVOICE_SUCCESS = 'Invoice has been posted'
  static POUND = 'Pound'
  static POUNDS_ABBR = 'lb'
  static POWER_UNIT = 'Power Unit'
  static PO_NUMBER_PLACEHOLDER = 'PO number'
  static PREFERENCES = 'Preferences'
  static PREMIUM_REASON = 'Premium Reason'
  static PRESERVE_SEQUENCE = 'Preserve sequence'
  static PRESSURE_SEAL_PREVIEW_CAPTION =
    'Every invoice in the group, on 8.5 × 11 pressure seal stock. Dashed lines are the fold and tear perforations — they do not print.'
  static PRESS_ENTER = 'press enter'
  static PREVIEW = 'Preview'
  static PREVIEW_BLOCKED_BY_OTHER_PREVIEW = 'Discard the current preview first.'
  static PREVIEW_RESTORE_BUTTON = 'Preview restore'
  static PREVIOUS_DATE = 'Previous Date'
  static PREVIOUS_EXCEPTION = 'Previous exception'
  static PREVIOUS_INVOICE = 'Previous invoice'
  static PREVIOUS_LOCATION = 'Previous location'
  static PREVIOUS_PHOTO = 'Previous photo'
  static PREVIOUS_STATE = 'Previous state'
  static PREVIOUS_WO = 'Previous WO #'
  static PRICE = 'Price'
  static PRICED_SERVICE = 'Priced Service'
  static PRICE_CHANGE_SOURCE_CONFIGURED_SERVICE = 'Changed on configured service'
  static PRICE_CHANGE_SOURCE_PRICE_BOOK = 'Propagated from price book'
  static PRICE_PERIOD = 'Price Period'
  static PRICING = 'Pricing'
  static PRICING_MANAGER = 'Pricing Manager'
  static PRICING_PERIOD = 'Pricing Period'
  static PRICING_PERIOD_LABEL = 'Pricing Period'
  static PRICING_ZONE = 'Pricing Zone'
  static PRINT = 'Print'
  static PRINTABLE_VIEW = 'Printable view'
  static PRINTED_COPY_CHANGEABLE_ON_BILLING_TAB = 'You can change this later on the customer’s Billing tab.'
  static PRINT_AND_DOWNLOAD = 'Print and download'
  static PRINT_OR_PDF = 'Print / PDF'
  static PRINT_REQUIRES_ROUTE = 'Printing is available once the work order is assigned to a route'
  static PRIORITY = 'Priority'
  static PRIVACY_POLICY = 'Privacy policy'
  static PRIVACY_POLICY_LINK = 'Privacy Policy Link'
  static PRIVACY_POLICY_TITLE = 'Privacy Policy'
  static PRIVACY_POLICY_URL = 'Privacy Policy URL'
  static PROCEED = 'Proceed'
  static PROCESS = 'Process'
  static PROCESSED = 'Processed'
  static PROCESSED_LOWER = 'processed'
  static PROCESSING_ACCOUNT = 'Processing account'
  static PROCESSING_ACCOUNTS_AND_INVOICES = 'Processing accounts and invoices'
  static PROCESSING_COMPLETE = 'Processing complete'
  static PROCESSING_PAYMENT_FOR_ACCOUNT = 'Processing payment for account'
  static PROCESS_RENTAL_FEE_DATES = 'Process rental fee dates'
  static PROCESS_RENTAL_FEE_DATES_DESCRIPTION =
    'You are about to process unbilled rental fees for inclusion on invoices. This action will also reset the grace period for these fees.'
  static PRODUCTIVITY = 'Productivity'
  static PRODUCTIVITY_ADD_ANOTHER_DISPOSAL_TICKET_TOOLTIP = 'Add another disposal ticket (a run can dump at more than one site)'
  static PRODUCTIVITY_ADD_ANOTHER_DOWNTIME_TOOLTIP = 'Add another downtime event'
  static PRODUCTIVITY_ADD_BREAK = 'Add break'
  static PRODUCTIVITY_ADD_CREW = 'Add crew'
  static PRODUCTIVITY_ADD_CREW_MEMBER = 'Add crew member'
  static PRODUCTIVITY_ADD_DOWNTIME = 'Add downtime'
  static PRODUCTIVITY_ADD_HELPER_TOOLTIP = 'Add another helper column'
  static PRODUCTIVITY_ADD_MATERIAL_PLACEHOLDER = '+ material'
  static PRODUCTIVITY_ADD_MATERIAL_TO_TICKET_TOOLTIP = 'Add a material to this ticket'
  static PRODUCTIVITY_ADD_REPLACEMENT_TRUCK = 'Add replacement truck'
  static PRODUCTIVITY_ADD_TICKET = 'Add ticket'
  static PRODUCTIVITY_ALL_DAYS = 'All days'
  static PRODUCTIVITY_ALL_DAYS_LOWERCASE = 'any selected day'
  static PRODUCTIVITY_ALL_ROUTES = 'All routes'
  static PRODUCTIVITY_ALL_ROUTES_ONE_DAY = 'All routes · one day'
  static PRODUCTIVITY_ALREADY_ON_RUN = 'Already on this run'
  static PRODUCTIVITY_ALREADY_SERVICED_SUFFIX = ' already serviced on that day'
  static PRODUCTIVITY_ARRIVED = 'Arrived'
  static PRODUCTIVITY_ARRIVE_FINAL_STOP = 'Arrive at the final stop'
  static PRODUCTIVITY_ATTACHED_TO_STOP_PREFIX = 'Attached to '
  static PRODUCTIVITY_AUTO_ASSIGNED_STOP_PREFIX = 'Auto-assigned to '
  static PRODUCTIVITY_AUTO_ASSIGNED_STOP_SUFFIX = ' — first open disposal stop. Click to change.'
  static PRODUCTIVITY_BATCH_SHEET_COLUMNS = 'Batch sheet columns'
  static PRODUCTIVITY_BLANK_LANDS_AT_END_HINT = 'Blank lands them at the end of the route'
  static PRODUCTIVITY_BREAK = 'Break'
  static PRODUCTIVITY_BREAKS_NO_CREW = 'Add a crew member to log breaks.'
  static PRODUCTIVITY_BREAKS_PER_PERSON = 'per person'
  static PRODUCTIVITY_BREAKS_TITLE = 'Breaks'
  static PRODUCTIVITY_BREAK_FOOTNOTE = "Each person's breaks are unpaid — carved from their own hours."
  static PRODUCTIVITY_BUILDING_DIRECTIONS = 'Building directions…'
  static PRODUCTIVITY_BUILDING_ROUTE = 'Building route…'
  static PRODUCTIVITY_BURDEN = 'Burden'
  static PRODUCTIVITY_CANCELED = 'Canceled'
  static PRODUCTIVITY_CARD_VIEW = 'Card view'
  static PRODUCTIVITY_CARD_WINDOW = 'Window'
  static PRODUCTIVITY_CHECK_STOPS_TO_MOVE_TOOLTIP = 'Check stops to move'
  static PRODUCTIVITY_CLEAR_ALL_DAYS = 'Clear all days'
  static PRODUCTIVITY_CLICK_LINE_TO_REROUTE = 'Click the line to reroute'
  static PRODUCTIVITY_CLICK_TO_SHOW_SUFFIX = ' — click to show'
  static PRODUCTIVITY_COLLAPSE_DIRECTIONS = 'Collapse directions'
  static PRODUCTIVITY_COLLAPSE_LEGEND = 'Collapse legend'
  static PRODUCTIVITY_COLLAPSE_RADIUS = 'Collapse radius'
  static PRODUCTIVITY_COLOR_PINS_BY_TOOLTIP = 'Color pins by route or by the days they run'
  static PRODUCTIVITY_COLUMNS = 'Columns'
  static PRODUCTIVITY_COL_BREAK_TIP = 'Unpaid break windows — each has a start and end; the total is carved out of working hours'
  static PRODUCTIVITY_COL_BURDEN_TIP =
    'Indirect burden, charged to Net Margin only — the employer burden on wages (Σ burden rate × hours). Equipment burden (truck depreciation, maintenance, insurance) isn’t stored yet, so it counts as $0 here.'
  static PRODUCTIVITY_COL_CREW_TIP =
    'Who was on the truck — each member’s pay + burden rates and hours (in the crew editor) price the labor'
  static PRODUCTIVITY_COL_DISPOSAL_FEE_TIP = 'Disposal fees paid at the site for the day’s tickets'
  static PRODUCTIVITY_COL_DISPOSAL_TIP = 'Disposal ticket(s) logged for this run — a run can dump at more than one site'
  static PRODUCTIVITY_COL_DISP_CHIP_TIP = 'Disposal ticket tons dumped at the site — fee = tons × site rate'
  static PRODUCTIVITY_COL_DOWNTIME_TIP =
    'Non-productive minutes + a reason code (breakdown, accident, traffic …) — carved out of working hours, so it’s the ‘why’ behind a low lifts/hr'
  static PRODUCTIVITY_COL_END_TIP = 'Run end — the driver’s logged clock-out'
  static PRODUCTIVITY_COL_FUEL = 'Fuel'
  static PRODUCTIVITY_COL_FUEL_COST = 'Fuel $'
  static PRODUCTIVITY_COL_FUEL_COST_TIP =
    'Fuel receipt total for the day, keyed by the office — this is what the margin charges; a day with no receipt keyed reads as a dash'
  static PRODUCTIVITY_COL_FUEL_TIP =
    'Fuel purchased on the run, in gallons — the receipt total beside it is what the margin charges; a cleared field reads as a dash, not a zero'
  static PRODUCTIVITY_COL_GROSS_MARGIN = 'Gross Margin'
  static PRODUCTIVITY_COL_GROSS_MARGIN_TIP =
    'Gross margin = Revenue − DIRECT costs (base labor + fuel + disposal). Employer burden is excluded — it’s an indirect cost, so it lands in Net Margin instead.'
  static PRODUCTIVITY_COL_LABOR_TIP =
    'Crew BASE wages — Σ (pay rate × hours) across everyone on the truck. A direct cost, so it’s what Gross Margin charges; the employer burden on these wages is the separate Burden column.'
  static PRODUCTIVITY_COL_LIFTS_HR = 'Lifts/hr'
  static PRODUCTIVITY_COL_LIFTS_HR_TIP = 'Productivity — target vs actual lifts per working hour'
  static PRODUCTIVITY_COL_LIFTS_TIP = 'Lifts recorded on the run, summed across container sizes — open to correct a count'
  static PRODUCTIVITY_COL_MATERIAL_TIP =
    'Material(s) the run dumped — read off the day’s disposal tickets, since that’s the operational record; a multi-site run lists every stream'
  static PRODUCTIVITY_COL_MILES = 'Miles'
  static PRODUCTIVITY_COL_MILES_TIP = 'Miles driven on the run — the odometer legs added up, one per truck it went out on'
  static PRODUCTIVITY_COL_NET_MARGIN = 'Net Margin'
  static PRODUCTIVITY_COL_NET_MARGIN_TIP =
    'Net margin = Gross margin − INDIRECT burden: the employer burden on wages (burden rate × hours), plus equipment burden once trucks carry one — nothing stores an equipment burden yet, so it counts as $0. This is the bottom line the loss flag keys on.'
  static PRODUCTIVITY_COL_ODO_END = 'Odo end'
  static PRODUCTIVITY_COL_ODO_END_TIP =
    'Odometer reading at the END of the route — a relief truck carries its own pair, kept in Truck & miles'
  static PRODUCTIVITY_COL_ODO_START = 'Odo start'
  static PRODUCTIVITY_COL_ODO_START_TIP = 'Odometer reading at the START of the route, on the truck it went out on'
  static PRODUCTIVITY_COL_OP_HRS = 'Op hrs'
  static PRODUCTIVITY_COL_OP_HRS_TIP = 'Working hours — clock window minus unpaid breaks and downtime'
  static PRODUCTIVITY_COL_POST_RELIEF = 'Post 2'
  static PRODUCTIVITY_COL_POST_RELIEF_TIP = 'Post-trip inspection on the truck that relieved the run — blank on a day that never swapped'
  static PRODUCTIVITY_COL_POST_TIP =
    'Post-trip inspection on the truck the run went out on — signed at return; unsigned runs need office follow-up'
  static PRODUCTIVITY_COL_PRE = 'Pre'
  static PRODUCTIVITY_COL_PRE_RELIEF = 'Pre 2'
  static PRODUCTIVITY_COL_PRE_RELIEF_TIP = 'Pre-trip inspection on the truck that relieved the run — blank on a day that never swapped'
  static PRODUCTIVITY_COL_PRE_TIP = 'Pre-trip inspection on the truck the run went out on — signed by the driver before rolling'
  static PRODUCTIVITY_COL_REVENUE_TIP =
    'Route revenue for the day (no tax). Recurring MONTHLY service is allocated per work order across the month’s scheduled service days, so each route-day carries its share of the monthly $ (matches the dashboard Routes table). One-time/on-request work orders book their full charge on the day serviced.'
  static PRODUCTIVITY_COL_START_TIP = 'Run start — the driver’s logged clock-in'
  static PRODUCTIVITY_COL_SVC_ZONE = 'Svc zone'
  static PRODUCTIVITY_COL_SVC_ZONE_TIP =
    'Service zone the run serviced. The CRM has no zone architecture yet, so this stays a free-typed placeholder'
  static PRODUCTIVITY_COL_TONS = 'Tons'
  static PRODUCTIVITY_COL_TONS_TIP = 'Total tons across every disposal ticket for the day — calculated, not editable'
  static PRODUCTIVITY_COL_UNIT_NO = 'Unit #'
  static PRODUCTIVITY_COL_UNIT_NO_TIP = 'Unit # — the truck the run went out on; type or pick from the units already on the sheet'
  static PRODUCTIVITY_COMPARE_ROUTE = 'Compare route'
  static PRODUCTIVITY_COMPARE_ROUTES = 'Compare routes'
  static PRODUCTIVITY_CONTAINER_OFFSET = 'Container offset'
  static PRODUCTIVITY_CONTAINER_OFFSET_TIP =
    'Fans containers recorded at the same spot apart from each other, so a stop with several reads as several pins.'
  static PRODUCTIVITY_CONTINUE_STRAIGHT = 'Continue straight'
  static PRODUCTIVITY_CREW = 'Crew'
  static PRODUCTIVITY_CREW_BURDEN_PREFIX = ' + Burden '
  static PRODUCTIVITY_CREW_FEEDS_MARGIN = ' · Labor feeds gross, both feed net'
  static PRODUCTIVITY_CREW_HOURS_WORKED_SUFFIX = 'h worked'
  static PRODUCTIVITY_CREW_LABOR_PREFIX = 'Labor '
  static PRODUCTIVITY_CREW_NONE_RECORDED = 'No crew recorded for this day'
  static PRODUCTIVITY_CREW_PAYROLL_HIDDEN = "Payroll hidden — you don't have payroll visibility"
  static PRODUCTIVITY_CREW_PAY_HIDDEN = 'pay hidden'
  static PRODUCTIVITY_CREW_ROSTER_EMPTY = 'Everyone is already on this run'
  static PRODUCTIVITY_CREW_ROUTE_DRIVERS_UNRECORDED = "this route's drivers. Nothing recorded on this day yet"
  static PRODUCTIVITY_CREW_ROUTE_DRIVER_UNRECORDED = "this route's driver. Nothing recorded on this day yet"
  static PRODUCTIVITY_CREW_RUN = 'run'
  static PRODUCTIVITY_CREW_RUN_LESS_BREAK = 'run less break'
  static PRODUCTIVITY_CREW_SEAT_ON_RUN = 'Seat on this run'
  static PRODUCTIVITY_CREW_TITLE = 'Crew & labor'
  static PRODUCTIVITY_DAYS_SAVED_SUFFIX = ' saved.'
  static PRODUCTIVITY_DAYS_UNSAVED_SUFFIX = ' could not be saved.'
  static PRODUCTIVITY_DAY_BREAKDOWN = 'Day breakdown'
  static PRODUCTIVITY_DELETE_PRESET_TOOLTIP = 'Delete preset'
  static PRODUCTIVITY_DEPARTED = 'Departed'
  static PRODUCTIVITY_DEPARTED_AFTER_ARRIVED = 'Departed must be after arrived'
  static PRODUCTIVITY_DEPART_YARD = 'Depart the yard'
  static PRODUCTIVITY_DISCARD_EDITS = 'Discard edits'
  static PRODUCTIVITY_DISPOSAL_FEE = 'Disposal fee'
  static PRODUCTIVITY_DISPOSAL_FEE_COLUMN = 'Disposal $'
  static PRODUCTIVITY_DISPOSAL_STOP = 'Disposal stop'
  static PRODUCTIVITY_DISPOSAL_TICKETS_TITLE_PREFIX = 'Disposal tickets · '
  static PRODUCTIVITY_DOWNTIME = 'Downtime'
  static PRODUCTIVITY_DOWNTIME_FOOTNOTE = ' · carved out of working hours'
  static PRODUCTIVITY_DOWNTIME_REASON_ACCIDENT = 'Accident'
  static PRODUCTIVITY_DOWNTIME_REASON_BREAKDOWN = 'Breakdown'
  static PRODUCTIVITY_DOWNTIME_REASON_INSPECTION = 'Inspection'
  static PRODUCTIVITY_DOWNTIME_REASON_TRAFFIC = 'Traffic'
  static PRODUCTIVITY_DOWNTIME_REASON_VANDALISM = 'Vandalism'
  static PRODUCTIVITY_DRIVER_ENTERED_READ_ONLY = 'Driver-entered — read-only'
  static PRODUCTIVITY_DRIVER_PATH_LOADING = 'Loading the recorded track…'
  static PRODUCTIVITY_DVIR_FOOTNOTE = 'Completed by the driver on the tablet — read-only here.'
  static PRODUCTIVITY_DVIR_NOT_LOGGED = 'Not logged'
  static PRODUCTIVITY_DVIR_POST_TRIP = 'Post-trip'
  static PRODUCTIVITY_DVIR_PRE_TRIP = 'Pre-trip'
  static PRODUCTIVITY_DVIR_SIGNED = 'Signed'
  static PRODUCTIVITY_DVIR_TITLE = 'Pre / post-trip inspection'
  static PRODUCTIVITY_EDITS_PENDING_SUFFIX = ' with unsaved edits'
  static PRODUCTIVITY_EDIT_ALL = 'Edit all'
  static PRODUCTIVITY_EDIT_ALL_DOWNTIME_TOOLTIP = 'Edit all downtime events'
  static PRODUCTIVITY_EDIT_ALL_TO_CHANGE = 'Read-only here — turn on Edit all to change these'
  static PRODUCTIVITY_EDIT_EVERY_ROW_INLINE = 'Edit every row inline'
  static PRODUCTIVITY_END_AFTER_START = 'End must be after start'
  static PRODUCTIVITY_END_OF_ROUTE_SHORT = 'end'
  static PRODUCTIVITY_ESTIMATED = 'estimated'
  static PRODUCTIVITY_EXIT_LASSO = 'Exit lasso'
  static PRODUCTIVITY_EXPAND_DIRECTIONS = 'Expand directions'
  static PRODUCTIVITY_EXPAND_LEGEND = 'Expand legend'
  static PRODUCTIVITY_EXPAND_RADIUS = 'Expand radius'
  static PRODUCTIVITY_FEE_FOLLOWS_RATE_TOOLTIP = 'Fee follows tons × rate'
  static PRODUCTIVITY_FEE_LOCKED_TOOLTIP = 'Fee locked — keyed off the ticket'
  static PRODUCTIVITY_FIELD_TRUCK_LEGS = 'Truck legs'
  static PRODUCTIVITY_FILL_PREVIOUS_HELPER = 'Fill the previous helper first'
  static PRODUCTIVITY_FLEET_GROSS_PREFIX = 'Gross '
  static PRODUCTIVITY_FLEET_NET_MARGIN = 'Fleet net margin'
  static PRODUCTIVITY_FLEET_ROUTES = 'Routes'
  static PRODUCTIVITY_FRI_SHORT = 'Fri'
  static PRODUCTIVITY_FUEL_COLUMN_EDIT_LABEL = 'Fuel · g'
  static PRODUCTIVITY_FUEL_PHOTO_TOOLTIP = "Pump and odometer photos come from the driver's app"
  static PRODUCTIVITY_FUEL_RECEIPT_TOTAL = 'Receipt total'
  static PRODUCTIVITY_GALLONS_UNIT = 'gallons'
  static PRODUCTIVITY_HAS_TICKET_HINT = '· has ticket'
  static PRODUCTIVITY_HELPER = 'Helper'
  static PRODUCTIVITY_HIDE_LAST_TICKET_COLUMNS_TOOLTIP = 'Hide the last disposal ticket columns'
  static PRODUCTIVITY_HIDE_LISTS_TOOLTIP = 'Hide the lists'
  static PRODUCTIVITY_HIDE_MAP_TOOLTIP = 'Hide the map'
  static PRODUCTIVITY_HOURS = 'Hours'
  static PRODUCTIVITY_HOURS_FOLLOW_WORKING_HOURS = "Hours follow the run's working hours"
  static PRODUCTIVITY_HRS = 'Hrs'
  static PRODUCTIVITY_IN_RADIUS = 'In radius'
  static PRODUCTIVITY_ISSUE_BREAKS_OVERLAP = 'two breaks overlap'
  static PRODUCTIVITY_ISSUE_BREAK_BACKWARDS = 'a break ends before it starts'
  static PRODUCTIVITY_ISSUE_BREAK_OUTSIDE_RUN = 'a break falls outside the run'
  static PRODUCTIVITY_ISSUE_CREW_TWICE = 'on the run twice'
  static PRODUCTIVITY_ISSUE_CREW_UNKNOWN = 'isn’t in your driver list, so the crew can’t save'
  static PRODUCTIVITY_ISSUE_DOWNTIME_BACKWARDS = 'Downtime ends before it starts'
  static PRODUCTIVITY_ISSUE_DOWNTIME_IN_BREAK = 'Downtime overlaps a break, so those minutes come off working hours twice'
  static PRODUCTIVITY_ISSUE_DOWNTIME_NO_REASON = 'Downtime with no reason code'
  static PRODUCTIVITY_ISSUE_DOWNTIME_NO_WINDOW = 'Downtime with no clock window'
  static PRODUCTIVITY_ISSUE_DOWNTIME_OUTSIDE_RUN = 'Downtime falls outside the run'
  static PRODUCTIVITY_ISSUE_DOWNTIME_OVERLAP = 'Two downtime events overlap on one truck, so those minutes count twice'
  static PRODUCTIVITY_ISSUE_DOWNTIME_UNKNOWN_TRUCK = 'Downtime is on a truck the run never used'
  static PRODUCTIVITY_ISSUE_FUEL_RATE = 'The fuel receipt works out to an unusual $/gal'
  static PRODUCTIVITY_ISSUE_HOURS_OVER_RUN = 'keyed more hours than the run lasted'
  static PRODUCTIVITY_ISSUE_LEG_NO_TRUCK = 'A leg carries odometer readings with no truck on it'
  static PRODUCTIVITY_ISSUE_LIFT_DUPLICATE = 'two lift rows share this container size'
  static PRODUCTIVITY_ISSUE_LIFT_NO_SIZE = 'A lift row has no container size, so the lift counts can’t save'
  static PRODUCTIVITY_ISSUE_LINE_NO_MATERIAL = 'A material line has a quantity but no material'
  static PRODUCTIVITY_ISSUE_MILES_IMPLAUSIBLE = 'The odometer span is unusually long for one run'
  static PRODUCTIVITY_ISSUE_NO_CREW = 'The run has hours but nobody on the crew, so labor reads $0'
  static PRODUCTIVITY_ISSUE_NO_WORKING_TIME = 'Break and downtime use up the whole run'
  static PRODUCTIVITY_ISSUE_ODO_BACKWARDS = 'odo end is below odo start'
  static PRODUCTIVITY_ISSUE_ODO_CONTINUITY = 'odo start is below the previous day’s odo end'
  static PRODUCTIVITY_ISSUE_RUN_BACKWARDS = 'The run ends before it starts'
  static PRODUCTIVITY_ISSUE_TICKET_BACKWARDS = 'A disposal ticket departs before it arrives'
  static PRODUCTIVITY_ISSUE_TICKET_DUPLICATE = 'two disposal tickets share this number'
  static PRODUCTIVITY_ISSUE_TICKET_FEE_OVERRIDE = 'A keyed disposal fee cannot be saved yet, so the tickets stay pending'
  static PRODUCTIVITY_ISSUE_TICKET_NEW_STOP = 'A disposal ticket points at a stop that does not exist yet'
  static PRODUCTIVITY_ISSUE_TICKET_NOT_LOADED = 'A saved disposal ticket has not loaded yet, so the tickets cannot save'
  static PRODUCTIVITY_ISSUE_TICKET_NO_NUMBER = 'A disposal ticket has no ticket #'
  static PRODUCTIVITY_ISSUE_TICKET_NO_SITE = 'A disposal ticket has no site'
  static PRODUCTIVITY_ISSUE_TICKET_OUTSIDE_RUN = 'A disposal ticket falls outside the run window'
  static PRODUCTIVITY_ISSUE_TRUCK_TWICE = 'on the run twice'
  static PRODUCTIVITY_ISSUE_UNIT_UNKNOWN = 'isn’t in your fleet, so the truck legs can’t save'
  static PRODUCTIVITY_LABEL_SPACING = 'Label spacing'
  static PRODUCTIVITY_LABEL_SPACING_TIP =
    'How much room a container label needs to keep. 0 labels every pin; higher spacing means fewer labels, and a pin that loses its label keeps its icon.'
  static PRODUCTIVITY_LABOR = 'Labor'
  static PRODUCTIVITY_LASSO_HINT_AND_DRAG = ' and drag to select · add '
  static PRODUCTIVITY_LASSO_HINT_CTRL = 'Ctrl'
  static PRODUCTIVITY_LASSO_HINT_DESELECT = ' to deselect · click a pin to toggle'
  static PRODUCTIVITY_LASSO_HINT_DRAG = 'Drag to lasso · add '
  static PRODUCTIVITY_LASSO_SELECT_STOPS_LABEL = 'Lasso-select stops'
  static PRODUCTIVITY_LASSO_TO_SELECT = 'Lasso to select a group'
  static PRODUCTIVITY_LAYER_CONTAINERS_TIP = 'Show container locations — sub-pin per container'
  static PRODUCTIVITY_LAYER_DRIVER_PATH_TIP = "Show the driver's actual GPS track for a day"
  static PRODUCTIVITY_LAYER_SEQUENCE_TIP = "Show each day's planned route, in stop order"
  static PRODUCTIVITY_LAYER_STOPS_TIP = 'Show stop pins, sliced by the days each is serviced on'
  static PRODUCTIVITY_LAYER_TURN_BY_TURN_TIP = 'Show driving directions for a day'
  static PRODUCTIVITY_LEGEND_COMPARED_LABEL = '(compared)'
  static PRODUCTIVITY_LEGEND_STOPS_SUFFIX = ' st'
  static PRODUCTIVITY_LIFTS = 'Lifts'
  static PRODUCTIVITY_LIFTS_FOOTNOTE = ' · counted per container size'
  static PRODUCTIVITY_LIFTS_LOWER = 'lifts'
  static PRODUCTIVITY_LIFTS_NONE_LOGGED = 'No lifts logged on this run'
  static PRODUCTIVITY_LIFTS_NO_SIZE = 'Unsized'
  static PRODUCTIVITY_LIST_COLUMNS = 'List columns'
  static PRODUCTIVITY_LOADING_SITES = 'Loading sites…'
  static PRODUCTIVITY_LOG_BREAK_WINDOWS = 'Log break windows'
  static PRODUCTIVITY_LOG_DOWNTIME_WINDOWS = 'Log downtime + reason'
  static PRODUCTIVITY_MAP_DISPLAY_OPTIONS = 'Map display options'
  static PRODUCTIVITY_MAP_LOADING_STOPS = 'Loading stops…'
  static PRODUCTIVITY_MAP_NO_MAPPABLE_STOPS = 'No mappable stops in this window.'
  static PRODUCTIVITY_MATERIALS = 'Materials'
  static PRODUCTIVITY_MATERIALS_DERIVED_SUFFIX = ' — dumped on the run’s disposal tickets'
  static PRODUCTIVITY_MATERIAL_C_AND_D = 'C & D'
  static PRODUCTIVITY_MATERIAL_MSW = 'MSW'
  static PRODUCTIVITY_MATERIAL_ORGANICS = 'Organics'
  static PRODUCTIVITY_MATERIAL_PLACEHOLDER = 'select material'
  static PRODUCTIVITY_MATERIAL_RECYCLE = 'Recycle'
  static PRODUCTIVITY_MILES_ODO_SPAN = 'odo end − start'
  static PRODUCTIVITY_MILES_PREFIX = 'Miles '
  static PRODUCTIVITY_MILES_SUFFIX = ' mi'
  static PRODUCTIVITY_MILES_SUM_OF_LEGS = 'sum of legs'
  static PRODUCTIVITY_MILES_UNIT = 'miles'
  static PRODUCTIVITY_MINUTES_SUFFIX = 'm'
  static PRODUCTIVITY_MON_SHORT = 'Mon'
  static PRODUCTIVITY_MORE_LOGGED_TICKETS_SUFFIX = ' more logged ticket'
  static PRODUCTIVITY_MOVED_PENDING_SUFFIX = ' moved · pending'
  static PRODUCTIVITY_MOVED_PILL = 'MOVED'
  static PRODUCTIVITY_MOVED_PILL_PERMANENT = 'MOVED · PERM'
  static PRODUCTIVITY_MOVED_PILL_PERMANENT_TOOLTIP = 'Moved here permanently — publish to apply'
  static PRODUCTIVITY_MOVED_PILL_TOOLTIP = 'Moved here — publish to apply'
  static PRODUCTIVITY_MOVE_CHECKED_STOPS_TOOLTIP = 'Move the checked stops to another route · day'
  static PRODUCTIVITY_MOVE_COMPLETED_RUN_TOOLTIP = "Completed run — stops can't move; reorder the sequence instead"
  static PRODUCTIVITY_NEW_DISPOSAL_STOP = 'New disposal stop'
  static PRODUCTIVITY_NEW_DISPOSAL_STOP_HINT = 'Created at the end of the route, before the yard.'
  static PRODUCTIVITY_NEW_STOP_LABEL = 'New stop · end of route'
  static PRODUCTIVITY_NEW_STOP_TOOLTIP =
    'A disposal stop will be created at the end of the route (before the return yard) when this saves. Set Arrived to sequence it by time.'
  static PRODUCTIVITY_NEXT_ROUTE = 'Next route'
  static PRODUCTIVITY_NEXT_STOP_FALLBACK = 'next stop'
  static PRODUCTIVITY_NOTHING_SAVED_ALL_BLOCKED = 'Nothing was written — fix the problems listed above first.'
  static PRODUCTIVITY_NOTHING_TO_SAVE = 'Nothing was written — none of these edits has a field on the endpoint yet.'
  static PRODUCTIVITY_NOT_WEEKLY_RECURRING_SUFFIX = ' not weekly-recurring'
  static PRODUCTIVITY_NO_BREAK = 'No break'
  static PRODUCTIVITY_NO_DIRECTIONS_AVAILABLE = 'No directions available for this day.'
  static PRODUCTIVITY_NO_DIRECTIONS_FOR_DAY = 'No directions for this day.'
  static PRODUCTIVITY_NO_DISPOSAL_STOP_YET = 'No disposal stop on this route yet.'
  static PRODUCTIVITY_NO_DISPOSAL_TICKET_FOR_RUN = 'No disposal ticket logged for this run.'
  static PRODUCTIVITY_NO_DISPOSAL_TICKET_LOGGED = 'No disposal ticket logged'
  static PRODUCTIVITY_NO_DOWNTIME_LOGGED = 'No downtime logged.'
  static PRODUCTIVITY_NO_DRIVER_PATH = 'No recorded track for'
  static PRODUCTIVITY_NO_MAPPABLE_STOPS = 'No mappable stops for this day.'
  static PRODUCTIVITY_NO_STOPS_SCHEDULED = 'No stops scheduled for this day.'
  static PRODUCTIVITY_NO_TRUCK_LOGGED = 'No truck logged'
  static PRODUCTIVITY_NO_UPCOMING_ROUTE_DAY = 'No upcoming route · day in view — add days above, or pick a current or future week'
  static PRODUCTIVITY_ODOMETER = 'Odometer'
  static PRODUCTIVITY_ODO_END_AFTER_START = 'Odo end must be above odo start'
  static PRODUCTIVITY_ON_REQUEST_SUFFIX = ' on-request (no recurrence to change)'
  static PRODUCTIVITY_OPEN_DRIVE_VIEW = 'Open drive view'
  static PRODUCTIVITY_ORDER_BY = 'Order by:'
  static PRODUCTIVITY_ORDER_LIFTS_HR = 'Lifts / hr'
  static PRODUCTIVITY_ORDER_MOST_STOPS = 'Most stops'
  static PRODUCTIVITY_OVER_CAPACITY_WARNING_PREFIX = 'Over capacity — rendering '
  static PRODUCTIVITY_OVER_CAPACITY_WARNING_SUFFIX = '. Reduce radius and/or day/route selection to improve performance.'
  static PRODUCTIVITY_PATH_SPACING = 'Path spacing'
  static PRODUCTIVITY_PATH_SPACING_TIP =
    "Fans overlapping route lines apart, so days that drive the same streets read separately. Each day's planned line and recorded track move together; the turn-by-turn stays on the true route."
  static PRODUCTIVITY_PERMANENT_BLOCKED_TOOLTIP = "Permanent changes can't start in the past"
  static PRODUCTIVITY_PERMANENT_MASTER = 'Permanent (master)'
  static PRODUCTIVITY_PERMANENT_TOOLTIP = 'Changes the master — this weekday, every week from now'
  static PRODUCTIVITY_PICK_A_SITE = 'Pick a site'
  static PRODUCTIVITY_PICK_MAP_ROUTE = 'Pick the route the per-day layers show'
  static PRODUCTIVITY_PIN_TO_FRONT = 'Pin to front'
  static PRODUCTIVITY_PRESET = 'Preset'
  static PRODUCTIVITY_PRESET_FINANCIAL_FOCUS = 'Financial focus'
  static PRODUCTIVITY_PRESET_PRODUCTIVITY_FOCUS = 'Productivity focus'
  static PRODUCTIVITY_PREVIOUS_ROUTE = 'Previous route'
  static PRODUCTIVITY_PUBLISH_MOVES = 'Publish moves'
  static PRODUCTIVITY_PUBLISH_MOVES_TOOLTIP = 'Apply the pending moves — routes and drivers pick up the new plan'
  static PRODUCTIVITY_QTY = 'Qty'
  static PRODUCTIVITY_RADIUS_HANDLE_TOOLTIP = 'Drag to move the radius · double-click to recenter'
  static PRODUCTIVITY_RATE_FOLLOWS_MEMBER = 'Rates follow the crew member — name the person first'
  static PRODUCTIVITY_REASON = 'Reason'
  static PRODUCTIVITY_REASON_PLACEHOLDER = 'reason?'
  static PRODUCTIVITY_REMOVE_DOWNTIME = 'Remove downtime'
  static PRODUCTIVITY_REMOVE_FROM_RUN = 'Remove from this run'
  static PRODUCTIVITY_REMOVE_HELPER_TOOLTIP = 'Remove the last (empty) helper column'
  static PRODUCTIVITY_REMOVE_MATERIAL = 'Remove material'
  static PRODUCTIVITY_REMOVE_MATERIAL_TOOLTIP = 'Remove the last (empty) material'
  static PRODUCTIVITY_REMOVE_TRUCK = 'Remove truck'
  static PRODUCTIVITY_REORDER = 'Reorder'
  static PRODUCTIVITY_REPLACEMENT = 'Replacement'
  static PRODUCTIVITY_REROUTED_THROUGH_PREFIX = 'Rerouted through '
  static PRODUCTIVITY_REROUTED_THROUGH_SUFFIX = ' point'
  static PRODUCTIVITY_RESET_PREFIX = 'Reset ('
  static PRODUCTIVITY_RESET_TO_DEFAULT = 'Reset to default'
  static PRODUCTIVITY_RESIZE_PANELS = 'Drag to resize the panels'
  static PRODUCTIVITY_ROLE_FILL_IN = 'Fill-in'
  static PRODUCTIVITY_ROW_DENSITY = 'Row density'
  static PRODUCTIVITY_SAT_SHORT = 'Sat'
  static PRODUCTIVITY_SAVE_AS_PRESET = 'Save as preset'
  static PRODUCTIVITY_SAVE_EDITS = 'Save edits'
  static PRODUCTIVITY_SAVE_EDITS_PARTIAL_PREFIX = 'Stays on this device: '
  static PRODUCTIVITY_SAVE_EDITS_PARTIAL_TOOLTIP =
    'These fields have no home on the endpoint yet, or their names did not resolve. Saving writes everything else.'
  static PRODUCTIVITY_SAVE_EDITS_TOOLTIP = 'Save the keyed times, fuel, tonnage, crew and truck legs to these route-days'
  static PRODUCTIVITY_SELECT_ALL_DAYS = 'Select all days'
  static PRODUCTIVITY_SELECT_DAYS_TO_COMPARE = 'Select one or more days above to compare.'
  static PRODUCTIVITY_SEQ = 'Seq'
  static PRODUCTIVITY_SHOW_LISTS_TOOLTIP = 'Show the route lists'
  static PRODUCTIVITY_SHOW_MAP_TOOLTIP = 'Show the map'
  static PRODUCTIVITY_SHOW_MORE_PREFIX = 'Show +'
  static PRODUCTIVITY_SKIPPED_PREFIX = 'Skipped — '
  static PRODUCTIVITY_SKIP_MISSING_DESTINATION = 'target a day no longer on screen'
  static PRODUCTIVITY_SKIP_NOT_WEEKLY_PERMANENT = "aren't weekly-recurring"
  static PRODUCTIVITY_SKIP_ON_REQUEST_PERMANENT = 'are on-request and have no recurrence to change'
  static PRODUCTIVITY_SKIP_PAST_DATE_PERMANENT = "can't change the master from a past date"
  static PRODUCTIVITY_SKIP_UNMAPPABLE_STOP = 'are missing data needed to move'
  static PRODUCTIVITY_STOPS_PUBLISHED_SUFFIX = ' published.'
  static PRODUCTIVITY_STOPS_SEPARATOR = ' Stops · '
  static PRODUCTIVITY_STOPS_SKIPPED_MIDDLE = ' skipped — they '
  static PRODUCTIVITY_STOPS_STILL_PENDING_SUFFIX = ' still pending — review and retry.'
  static PRODUCTIVITY_STOP_COMPARING_ROUTE = 'Stop comparing this route'
  static PRODUCTIVITY_STOP_OFFSET = 'Stop offset'
  static PRODUCTIVITY_STOP_OFFSET_TIP =
    'Spreads stop pins that sit on top of each other so each one is clickable. Display only — the stops stay where they are.'
  static PRODUCTIVITY_SUN_SHORT = 'Sun'
  static PRODUCTIVITY_SWAPPED = 'swapped'
  static PRODUCTIVITY_TABLE_VIEW = 'Table view'
  static PRODUCTIVITY_TAKEOVER_STOP = 'Took over at stop #'
  static PRODUCTIVITY_TAKEOVER_STOP_HINT = 'Blank splits each truck by its share of the miles. Stops on this day:'
  static PRODUCTIVITY_TAKEOVER_STOP_ORDER = 'Each truck has to take over at a later stop than the one before it'
  static PRODUCTIVITY_TAKEOVER_STOP_RANGE = 'Takeover stop has to be a stop on this day, after the first one'
  static PRODUCTIVITY_THIS_DAY_ONLY = 'This day only'
  static PRODUCTIVITY_THU_SHORT = 'Thu'
  static PRODUCTIVITY_TICKETS = 'Tickets'
  static PRODUCTIVITY_TICKET_NO = 'Ticket #'
  static PRODUCTIVITY_TICKET_STOP_VANISHED =
    'A disposal ticket could not be linked: its stop is no longer on the route. Reload the day and try again.'
  static PRODUCTIVITY_TIP_ADD_CREW = 'Adds another helper column to the sheet — rates edit in the crew editor'
  static PRODUCTIVITY_TIP_ADD_MATERIAL =
    'Add or remove a material line on this ticket — a load can be split into more than one material at the scale'
  static PRODUCTIVITY_TIP_ADD_TICKET = 'Adds another disposal ticket column set — a run can dump at more than one site'
  static PRODUCTIVITY_TIP_ARRIVED = 'When the driver arrived at the disposal site — reconciles against the site’s scale record'
  static PRODUCTIVITY_TIP_DEPARTED =
    'When the driver left the disposal site — optional; arrival is the field that matters, departure lets mobile auto-calc the dwell later'
  static PRODUCTIVITY_TIP_DISP_FEE = 'Disposal fee for this material line — qty × site rate, or the total keyed off the paper ticket'
  static PRODUCTIVITY_TIP_DISP_MATERIAL = 'Material dumped on this ticket — sets the unit + site rate'
  static PRODUCTIVITY_TIP_DISP_QTY = 'Quantity dumped for this material line — priced at the site rate'
  static PRODUCTIVITY_TIP_DISP_RATE = 'Site rate for the material — auto-filled from the material, editable; fee = qty × rate'
  static PRODUCTIVITY_TIP_DISP_SITE = 'Disposal site the run dumped at — picked from the operator’s disposal facilities, not free-typed'
  static PRODUCTIVITY_TIP_DISP_STOP =
    'Disposal STOP this ticket attaches to — the stop’s timing drives the run’s productivity; auto-assigned to the first open disposal stop, or a new one is created at the end of the route'
  static PRODUCTIVITY_TIP_DISP_UOM = 'Unit of measure for the material — auto-filled from the material, editable'
  static PRODUCTIVITY_TIP_DRIVER = 'Who drove the run — their pay + burden rate prices the labor'
  static PRODUCTIVITY_TIP_HELPER = 'Helper on the truck — own rate and hours'
  static PRODUCTIVITY_TIP_MEMBER_BURDEN =
    'Hourly burden on top of pay (taxes, insurance, benefits) — an indirect cost, so burden × hours hits net margin, not gross'
  static PRODUCTIVITY_TIP_MEMBER_HRS = 'This member’s hours — blank means the run’s working hours'
  static PRODUCTIVITY_TIP_MEMBER_PAY =
    'This member’s hourly pay rate for THIS run — a fill-in or negotiated helper rate reprices only this day'
  static PRODUCTIVITY_TIP_TICKET_NO = 'Disposal ticket # — the paper ticket’s number, keyed/corrected by the office'
  static PRODUCTIVITY_TOWARD = 'toward'
  static PRODUCTIVITY_TO_CHECK_SUFFIX = ' to check'
  static PRODUCTIVITY_TO_FIX_SUFFIX = ' to fix before saving'
  static PRODUCTIVITY_TO_SEQUENCE = 'To sequence'
  static PRODUCTIVITY_TRUCK_MILES_TITLE = 'Truck & miles'
  static PRODUCTIVITY_TRUCK_NUMBER = 'Truck #'
  static PRODUCTIVITY_TRUCK_SWAP = 'Truck swap'
  static PRODUCTIVITY_TRUCK_SWAP_CELL_TIP = 'This run swapped trucks — open Truck & miles to edit each one'
  static PRODUCTIVITY_TRUCK_SWAP_DRAG_TOOLTIP = 'Drag onto the stop the relief truck took over at'
  static PRODUCTIVITY_TRUCK_SWAP_EDIT_ALL_TOOLTIP = 'Turn on Edit all to move the swap to the stop the relief truck took over at'
  static PRODUCTIVITY_TRUCK_SWAP_ESTIMATED = 'estimated from the miles each truck drove'
  static PRODUCTIVITY_TRUCK_SWAP_REORDER_TOOLTIP = 'Turn on Reorder to drag the swap to the stop the relief truck took over at'
  static PRODUCTIVITY_TRUCK_SWAP_TOOK_OVER = 'took over at stop'
  static PRODUCTIVITY_TRUCK_SWAP_UNKNOWN_UNITS = 'Replacement truck'
  static PRODUCTIVITY_TUE_SHORT = 'Tue'
  static PRODUCTIVITY_TURN_BY_TURN = 'Turn-by-turn'
  static PRODUCTIVITY_TURN_LEFT = 'Turn left'
  static PRODUCTIVITY_TURN_RIGHT = 'Turn right'
  static PRODUCTIVITY_UNDO_HINT = 'Undo with ⌘Z'
  static PRODUCTIVITY_UNIT = 'Unit'
  static PRODUCTIVITY_VIA_HANDLE_TOOLTIP = 'Drag to reroute · double-click to remove'
  static PRODUCTIVITY_VS_ROUTE_PREFIX = 'vs '
  static PRODUCTIVITY_WED_SHORT = 'Wed'
  static PRODUCTIVITY_WEEKDAY_INITIAL_FRI = 'F'
  static PRODUCTIVITY_WEEKDAY_INITIAL_MON = 'M'
  static PRODUCTIVITY_WEEKDAY_INITIAL_SAT = 'S'
  static PRODUCTIVITY_WEEKDAY_INITIAL_SUN = 'S'
  static PRODUCTIVITY_WEEKDAY_INITIAL_THU = 'T'
  static PRODUCTIVITY_WEEKDAY_INITIAL_TUE = 'T'
  static PRODUCTIVITY_WEEKDAY_INITIAL_WED = 'W'
  static PRODUCTIVITY_WEEK_SPAN_1 = '1 wk'
  static PRODUCTIVITY_WEEK_SPAN_2 = '2 wk'
  static PRODUCTIVITY_WEEK_SPAN_4 = '4 wk'
  static PRODUCTIVITY_WEEK_SPAN_SUFFIX = ' wk'
  static PRODUCTIVITY_WHICH_TRUCK = 'Which truck…'
  static PRODUCTIVITY_YARDS_LOWER = 'yds'
  static PRODUCTIVITY_YDS = 'Yds'
  static PRODUCTIVITY_YDS_SEPARATOR = ' Yds · '
  static PRODUCTIVITY_ZOOM_IN = 'Zoom in'
  static PRODUCTIVITY_ZOOM_OUT = 'Zoom out'
  static PROFILE = 'Profile'
  static PROGRESS = 'Progress'
  static PROGRESS_SET_SUFFIX = 'set'
  static PROMOTE_APPLIED_MASTER_REVIEW_DAYS = 'Promoted to master — review how it propagates to the days, then Publish to apply'
  static PROMOTE_APPLIED_TO_MASTER = 'Daily order promoted to master'
  static PROMOTE_APPLYING = 'Applying…'
  static PROMOTE_APPLY_TO_MASTER = 'Apply to master'
  static PROMOTE_DISCARD = 'Discard'
  static PROMOTE_FANOUT_NOW_BLURB_PREFIX = 'Master and all'
  static PROMOTE_FANOUT_NOW_BLURB_SUFFIX = 'update right away — no review step.'
  static PROMOTE_INTRO_FOOTNOTE = "Nothing is applied yet — you'll review, curate, and confirm on the next screen."
  static PROMOTE_INTRO_LEGEND_HEADER = "What you'll see in the preview"
  static PROMOTE_INTRO_SUBTITLE = "Choose how this day's run order should land on master, then review every change before applying."
  static PROMOTE_INTRO_TITLE_PREFIX = 'Promote'
  static PROMOTE_INTRO_TITLE_SUFFIX = '→ master?'
  static PROMOTE_LEGEND_NOT_PROMOTED = 'Not promoted'
  static PROMOTE_LEGEND_NOT_PROMOTED_BLURB =
    "Stops that can't carry over are listed with the reason — on-request, service ended, or account off."
  static PROMOTE_LEGEND_RESEQUENCED = 'Resequenced'
  static PROMOTE_LEGEND_RESEQUENCED_BLURB =
    "Stops on both this day and master reorder to match the day's run — the chip shows the old → new position."
  static PROMOTE_MODE_CONSOLIDATE = 'Consolidate'
  static PROMOTE_MODE_CONSOLIDATE_BLURB =
    'Keep everything. This day sets the order, and stops that are only on master stay — tucked back beside the stops they normally sit next to.'
  static PROMOTE_MODE_REPLACE = 'Replace master'
  static PROMOTE_MODE_REPLACE_BLURB =
    "Start fresh from this day. Master becomes exactly this day's order; stops only on master are dropped (shown greyed so you can see what's leaving)."
  static PROMOTE_NOW = 'now'
  static PROMOTE_PAST_DAILY_BLOCKED_HINT = 'Save or undo your in-flight changes before promoting a past day'
  static PROMOTE_PAST_DAILY_CONFIRM_BODY =
    "Reorders the master sequence to match this day's order for the stops they share. Off-cycle master stops keep their place; stops only on this day are left out. You'll review the change on the current board and publish it yourself."
  static PROMOTE_PAST_DAILY_CONFIRM_BODY_WHOLESALE =
    "Replaces the master sequence entirely with this day's stops, in this day's order. You'll review the change on the current board and publish it yourself."
  static PROMOTE_PAST_DAILY_CONFIRM_TITLE = 'Promote this day to master?'
  static PROMOTE_PAST_DAILY_EMPTY_HINT = 'This day has no stops to promote'
  static PROMOTE_PAST_DAILY_TOOLTIP = 'Promote daily order to master — off-cycle stops stay anchored'
  static PROMOTE_PAST_DAILY_TO_MASTER = 'Promote this day to master'
  static PROMOTE_PREVIEW_CHANGES = 'Preview changes'
  static PROMOTE_RECOMMENDED = 'Recommended'
  static PROMOTE_RELOADING_BOARD = 'Applying your promotion…'
  static PROMOTE_REVIEW_DAYS_BLURB_PREFIX = 'Then review how the order cascades to the'
  static PROMOTE_REVIEW_DAYS_BLURB_SUFFIX = 'and Publish to apply.'
  static PROMOTE_SYNC_BANNER_HEADLINE_SUFFIX = 'will be fanned out to match the promoted master'
  static PROMOTE_SYNC_BANNER_KICKER = 'Fan-out preview'
  static PROMOTE_SYNC_BANNER_SUB =
    'Publishing fans the promoted master order out to these upcoming dailies — stops stay as-is, only the order changes.'
  static PROMOTE_UPCOMING = 'upcoming'
  static PROMOTE_UPDATE_MASTER = 'Update master'
  static PROMOTE_UPDATE_MASTER_NOW = 'Update master now'
  static PROPERTY = 'Property'
  static PROPERTY_OWNER = 'Property owner'
  static PROPOSED = 'Proposed'
  static PROPOSED_ROUTE = 'Proposed route'
  static PROPOSED_ROUTE_ON_THE_MAP = 'Proposed route on the map'
  static PROPOSED_SEQUENCE = 'Proposed sequence'
  static PRORATE = 'Prorate'
  static PRORATE_DO_NOT_BILL_DURING_SUSPENSION = 'Prorate ( do not bill them during suspension period )'
  static PRORATION = 'Proration'
  static PROVIDER_ACCOUNT_ID = 'Provider Account ID'
  static PROVISION_CONFIRM_TEXT = 'This number will be assigned to your campaign and used for all outbound SMS:'
  static PROVISION_NUMBER = 'Provision Number'
  static PROVISION_PHONE_NUMBER = 'Provision Phone Number'
  static PUBLISH = 'Publish'
  static PUBLISHED_SUCCESSFULLY = 'published successfully'
  static PUBLISHING = 'Publishing...'
  static PUBLISH_AFTER_EDITS = 'publish after edits'
  static PUBLISH_AND_RETURN = 'Publish & return'
  static PUBLISH_AND_RETURN_TO_ACCOUNT = 'Publish & return to account'
  static PUBLISH_AND_ROUTE = 'Publish & route'
  static PUBLISH_CHANGES_LIVE_TOOLTIP = 'Selecting will publish your current changes live, updating the route on mobile devices'
  static PUBLISH_MASTER_FAILED = 'publish master failed'
  static PUBLISH_MASTER_SEQUENCE = 'Publish master sequence'
  static PUBLISH_MASTER_SEQUENCE_TOOLTIP = 'This will update the master sequence and all future daily occurrences'
  static PUBLISH_NOW = 'Publish now'
  static PUMP = 'Pump'
  static PURCHASE_ORDER = 'Purchase Order #'
  static PURCHASE_ORDER_ADDED_SUCCESS_MSG = 'Purchase order added successfully'
  static PURCHASE_ORDER_LABEL = 'Purchase order'
  static PURCHASE_ORDER_UPDATED_SUCCESS_MSG = 'Purchase order updated successfully'
  static QR_CODE = 'QR code'
  static QTY = 'QTY'
  static QUANTITY = 'Quantity'
  static QUANTITY_MUST_BE_POSITIVE = 'Quantity must be greater than 0'
  static QUARTER = 'Quarter'
  static QUARTERLY = 'Quarterly'
  static QUARTERS = 'Quarters'
  static QUEUED = 'Queued'
  static QUICK_REVIEW = 'Quick Review'
  static QUICK_REVIEW_INTRO = 'Confirm or reject pending detections directly from the dashboard.'
  static RADIUS = 'Radius'
  static RATE = 'Rate'
  static RATE_ADJUSTMENTS = 'Rate adjustments'
  static RATE_ADJUSTMENT_INFO =
    'Rate adjustments are scheduled for future dates. The new rate will automatically take effect on the specified start date and prorate the difference.'
  static RATE_CHANGE_HISTORY = 'Rate change history'
  static RATE_CHANGE_HISTORY_HELPER = 'View past and upcoming rate changes'
  static RATE_CONFIGURATION = 'Rate Configuration'
  static RATE_DESCRIPTION_HELPER = 'This will be added to the activity history'
  static RATE_TOOLTIP =
    'Enable this to use a custom rate for this material. When enabled, the rate field will be active and override the disposal site rate. If disabled, the rate will be determined by the disposal site.'
  static RATE_TYPE = 'Rate type'
  static REACTIVATE = 'Reactivate'
  static REACTIVATE_ACCOUNT = 'Please reactivate account'
  static REACTIVATE_ACCOUNT_CAPTURE_LEAD = "You're about to reactivate "
  static REACTIVATE_ACCOUNT_DIALOG = 'Reactivate account'
  static REACTIVATE_LOCATIONS = 'Reactivate locations'
  static REACTIVATE_LOCATIONS_AND_SERVICES = 'Reactivate locations & services'
  static REACTIVATE_MULTIPLE_LOCATION = 'Reactivate location(s)'
  static REACTIVATION = 'Reactivation'
  static REACTIVATION_ACCOUNT_ONLY = 'Only the account will be reactivated. Its locations and services stay deactivated.'
  static REACTIVATION_NOTICE_BILLING = 'Billing will resume from today, and any billing end dates on these services will be cleared.'
  static REACTIVATION_NOTICE_BILLING_KEEP_ORIGINAL =
    'Each service keeps its original start date, and any billing end dates on these services will be cleared.'
  static REACTIVATION_NOTICE_SELECTION = 'The locations and services you select below will be turned back on.'
  static REACTIVATION_NOTICE_UNROUTED = 'Reactivated stops come back unrouted. Assign them in Route Manager.'
  static REACTIVATION_SELECTION_LOAD_ERROR = "Unable to load the account's locations and services. Refresh and try again."
  static REACTIVATION_START_DATES = 'Start dates'
  static REACTIVATION_START_DATES_KEEP_ORIGINAL = 'Keep original'
  static REACTIVATION_START_DATES_KEEP_ORIGINAL_WARNING = '(may bill for the time the account was deactivated)'
  static REACTIVATION_START_DATES_TOOLTIP =
    'A reactivated service bills and generates work orders from one start date. Today moves it to the reactivation date. You can change it on the service later.'
  static READ = 'Read'
  static READING_ACCOUNT_NUMBERS_FROM_CSV = 'Reading account numbers from CSV...'
  static READY_AND_CREATE_DRAFT = 'Ready & create draft'
  static READY_FOR_INVOICE = 'Ready for invoice'
  static READY_FOR_INVOICE_LABEL = 'Ready'
  static READY_TO_PUBLISH_BUT_STILL_DRAFT = 'This service is in draft and ready to publish. Click Publish to make it available.'
  static REASON = 'Reason'
  static REASON_IN_USE_DEACTIVATE_INSTEAD = 'This reason is used on existing accounts and cannot be deleted. Deactivate it instead?'
  static REASSIGN_MISSING_STOPS = 'Reassign missing stops to this route'
  static REASSIGN_MISSING_STOPS_HELPER =
    'Pull stops in this version that now live on another route — or are unassigned — back to this route. Their current routes lose them. This can’t be undone.'
  static RECEIPTS_ARE_REGENERATING = 'Receipts are regenerating'
  static RECEIPT_IS_REGENERATING = 'Receipt is regenerating'
  static RECEIVED = 'Received'
  static RECEIVES_PRINTED_COPY = 'Receives printed copy'
  static RECEIVES_PRINTED_COPY_TOOLTIP =
    'A printed invoice is mailed as well. Email still goes to the contacts with billing notifications on.'
  static RECENTLY_ADDED = 'Recently added'
  static RECENTLY_VIEWED = 'Recently viewed'
  static RECENT_ACTIVITY = 'Recent activity'
  static RECENT_MOVES = 'Recent moves'
  static RECIPIENT = 'Recipient'
  static RECIPIENTS = 'Recipients'
  static RECIPIENTS_SENT = 'Recipients sent'
  static RECIPIENT_MESSAGES_LOAD_FAILED = "This message's recipients couldn't be loaded."
  static RECOMMENDED = 'RECOMMENDED'
  static RECORDED = 'Recorded'
  static RECOVER = 'Recover'
  static RECOVER_PASSWORD_TITLE = 'Recover password'
  static RECURRENCE = 'Recurrence'
  static RECURRENCE_INTERVAL = 'Recurrence interval'
  static RECURRENCE_INTERVAL_HEADER = 'Recurrence interval'
  static RECURRENCE_UPDATED_SUCCESSFULLY = 'Recurrence updated successfully'
  static RECURRING = 'Recurring'
  static RECURRING_COLLECTION = 'Recurring collection'
  static RECURRING_DISPOSAL = 'Recurring disposal'
  static RECURRING_DISPOSAL_STOPPED = 'Recurring disposal stopped'
  static RECURRING_EVENTS_CANNOT_BE_EDITED = 'Recurring events cannot be edited'
  static RECURRING_SERVICE = 'Recurring service'
  static RECURRING_SERVICE_DESCRIPTION = 'Any recurring service'
  static RECURRING_WO_CANNOT_BE_DELETED = 'Recurring work orders cannot be deleted'
  static RECURRING_WO_CANNOT_BE_EDITED = 'Recurring work orders cannot be edited'
  static RECURS_EVERY_OTHER_WEEK = 'Recurs every other week'
  static REDO = 'Redo'
  static REFRESHING = 'Refreshing…'
  static REFRESH_CAMPAIGN_FROM_TCR_TOOLTIP = 'Pull the latest campaign state from TCR and Telgorithm'
  static REFRESH_FROM_TCR = 'Refresh'
  static REFRESH_FROM_TCR_TOOLTIP = 'Pull the latest brand state from TCR'
  static REFUNDED = 'Refunded'
  static REFUND_NOT_SUPPORTED = 'To enable customer refunds in the system, please contact payments@haulerhero.com.'
  static REFUND_PAYMENT = 'Refund Payment'
  static REGENERATE = 'Regenerate'
  static REGENERATE_ALL_RECEIPTS = 'Regenerate all receipts'
  static REGENERATE_AND_REPOST = 'Regenerate and repost'
  static REGENERATE_AND_REPOST_CONFIRM_MSG =
    'This invoice is unpaid and already posted. Regenerating will rebuild it from current work order data and repost it. Do you want to proceed?'
  static REGENERATE_AND_REPOST_INVOICE_SUCCESS = 'Invoice regenerated and reposted successfully'
  static REGENERATE_DRAFT_INVOICES = 'Regenerate draft invoices'
  static REGENERATE_DRAFT_INVOICES_PROMPT =
    'This account has draft invoice(s) created with the previous settings. If you select Dismiss, please regenerate them individually to reflect the changes.'
  static REGENERATE_DRAFT_INVOICES_TITLE = 'Regenerate draft invoices?'
  static REGENERATE_INVOICE = 'Regenerate invoice'
  static REGENERATE_INVOICES_SUCCESS_MSG =
    'Selected invoices successfully regenerated. Please allow a few seconds for this to reflect on the invoice PDF.'
  static REGENERATE_INVOICE_DISABLED_MSG = 'Cannot regenerate selected invoices. Please deselect invoices that are paid or voided'
  static REGENERATE_RECEIPT = 'Regenerate receipt'
  static REGISTRATION_FEES = 'Registration Fees'
  static REGISTRATION_STATUS = 'Registration Status'
  static REJECT = 'Reject'
  static REJECTED = 'Rejected'
  static REJECTED_BY_HEADER = 'Rejected by'
  static REJECT_ALL_MATCHES = 'Reject all matches'
  static REJECT_DETECTION = 'Reject detection'
  static REJECT_SELECTED = 'Reject selected'
  static RELEASE_NUMBER = 'Release'
  static RELEASE_NUMBER_CONFIRM_BUTTON = 'Release number'
  static RELEASE_NUMBER_CONFIRM_DESCRIPTION = 'Releasing this number will stop all SMS sending. You can provision a new number afterwards.'
  static RELEASE_NUMBER_CONFIRM_TITLE = 'Release phone number?'
  static RELEASE_NUMBER_FAILURE_MSG = 'Failed to release phone number'
  static RELEASE_NUMBER_SUCCESS_MSG = 'Phone number released'
  static RELEASE_NUMBER_SUSPENDED_TOOLTIP = 'Reactivate the campaign before releasing this phone number'
  static RELEASE_NUMBER_TOOLTIP = 'Release this phone number'
  static RELEASING_NUMBER = 'Releasing...'
  static RELOAD = 'Reload'
  static REMITTANCE = 'Remittance'
  static REMITTANCE_FREQUENCY = 'Remittance frequency'
  static REMOVE = 'Remove'
  static REMOVED_FROM_WO = 'Removed from WO'
  static REMOVE_ACCOUNTS = 'Remove account(s)'
  static REMOVE_ACCOUNTS_FROM_GROUP = 'Remove accounts from group'
  static REMOVE_ACCOUNTS_FROM_GROUP_SUCCESS_MSG = 'Selected accounts successfully removed from group'
  static REMOVE_ACCOUNT_FROM_GROUP_SUCCESS_MSG = 'Selected account successfully removed from group'
  static REMOVE_COMPANY_LOGO = 'Remove company logo'
  static REMOVE_CONDITION = 'Remove condition'
  static REMOVE_CUSTOMERS_BEFORE_ARCHIVE_LATE_FEE = 'Remove all customers to archive this fee'
  static REMOVE_DEFAULT_ROUTE_VIEW = 'Remove as my default view'
  static REMOVE_DEFAULT_SITE = 'Remove default site'
  static REMOVE_DISPOSAL_FEE = 'Remove disposal fee'
  static REMOVE_DISPOSAL_FEE_CONFIRM_MSG = 'Are you sure you want to remove this disposal fee?'
  static REMOVE_EXEMPTION = 'Remove exemption'
  static REMOVE_FROM_ACCOUNT_GROUP = 'Remove from account group'
  static REMOVE_FROM_GROUP = 'Remove from group'
  static REMOVE_FROM_SELECTION = 'Remove from selection'
  static REMOVE_FROM_WORK_ORDER = 'Remove from work order'
  static REMOVE_INVOICE = 'Remove invoice'
  static REMOVE_INVOICES = 'Remove invoice(s)'
  static REMOVE_INVOICES_FROM_GROUP_SUCCESS_MSG = 'Selected invoices successfully removed from group'
  static REMOVE_INVOICE_FROM_GROUP_SUCCESS_MSG = 'Selected invoice successfully removed from group'
  static REMOVE_LOGO = 'Remove logo'
  static REMOVE_PAYMENT = 'Remove payment'
  static REMOVE_PAYMENTS_FROM_GROUP_SUCCESS_MSG = 'Selected payments successfully removed from group'
  static REMOVE_PURCHASE_ORDER = 'Remove purchase order'
  static REMOVE_PURCHASE_ORDER_CONFIRM_MSG = 'Are you sure you want to remove this purchase order?'
  static REMOVE_PURCHASE_ORDER_SUCCESS_MSG = 'Purchase order removed successfully'
  static REMOVE_RENTAL_FEE = 'Remove rental fee'
  static REMOVE_RULE = 'Remove rule'
  static REMOVE_SELECTED = 'Remove selected'
  static REMOVE_SERVICE = 'Remove service'
  static REMOVE_SERVICES = 'Remove Services'
  static REMOVE_SERVICES_FROM_DISPOSAL_FEE = 'Remove services from disposal fee'
  static REMOVE_SERVICES_FROM_RENTAL_FEE = 'Remove services from rental fee'
  static REMOVE_TAX_EXEMPTION = 'Remove tax exemption?'
  static REMOVE_TAX_EXEMPTION_MESSAGE = 'Turning this off also deletes the tax exemption identifier on file: '
  static REMOVE_TAX_EXEMPTION_RESTORE_HINT = 'To restore it later, enter it again from Edit account details.'
  static RENTAL = 'Rental'
  static RENTAL_FEES = 'Rental fees'
  static RENTAL_FEES_ALREADY_LINKED_TO_PRICED_SERVICE = 'Rental fees already linked to this priced service'
  static RENTAL_FEES_SAVED_SUCCESSFULLY = 'Rental fees saved successfully'
  static RENTAL_FEE_ARCHIVED_SUCCESSFULLY = 'Rental fee archived successfully'
  static RENTAL_FEE_ARCHIVE_ASSOCIATION_MSG =
    'This rental fee is associated with some accounts, services, invoices, or configured services and cannot be archived'
  static RENTAL_FEE_CONTAINER_LIMIT_TOOLTIP = 'The number of rental fees cannot exceed the number of containers'
  static RENTAL_FEE_CREATED_SUCCESSFULLY = 'Rental fee created successfully'
  static RENTAL_FEE_DATES_PROCESSED_SUCCESSFULLY = 'Rental fee dates processed successfully'
  static RENTAL_FEE_DELETED_SUCCESSFULLY = 'Rental fee deleted successfully'
  static RENTAL_FEE_DELETE_ASSOCIATION_MSG =
    'This rental fee is associated with some accounts, services, invoices, or configured services and cannot be deleted'
  static RENTAL_FEE_INVOICING = 'Rental fee invoicing'
  static RENTAL_FEE_RESTORED_SUCCESSFULLY = 'Rental fee restored successfully'
  static RENTAL_FEE_SETTINGS = 'Rental fee settings'
  static RENTAL_FEE_UPDATED_SUCCESSFULLY = 'Rental fee updated successfully'
  static RENTAL_PERIOD = 'Rental period'
  static RENTAL_PERIOD_ACTIVITY = 'Rental period activity'
  static RENTAL_PERIOD_DATES_CANNOT_OVERLAP = 'New dates cannot overlap another rental period.'
  static RENTAL_PERIOD_END = 'Rental period end'
  static RENTAL_PERIOD_INVALID_DATE_RANGES_REMOVED = 'One or more rental periods had invalid date ranges and were removed.'
  static RENTAL_PERIOD_START = 'Rental period start'
  static REORDERED_BY_OPTIMIZATION = 'Reordered by optimization'
  static REPAIR = 'Repair'
  static REPEATS = 'Repeats'
  static REPLACE = 'Replace'
  static REPLACE_AND_ASSIGN_WORK_ORDER = 'Replace & Assign work order'
  static REPLACE_CONTAINER = 'Replace container'
  static REPLACE_INVENTORY = 'Replace inventory'
  static REPORTING = 'Reporting'
  static REPORTS = 'Reports'
  static REPORT_INFO = 'View, modify or schedule, create / delete reports'
  static REPOSITION = 'Reposition'
  static REQUESTED = 'Requested'
  static REQUESTED_LOWERCASE = 'requested'
  static REQUIRED = 'Required'
  static REQUIRED_FIELDS_TOOLTIP = "Required fields get an asterisk on the New Account form and block Create until they're filled in."
  static REQUIRED_FIELD_MSG = 'Please fill in all the required fields'
  static REQUIRED_HELPER_TEXT = 'Required'
  static REQUIRES = 'Requires'
  static REQUIRES_COMPETITOR = 'Requires competitor'
  static REQUIRES_COMPETITOR_HELP_PREFIX = 'Check'
  static REQUIRES_COMPETITOR_HELP_SUFFIX = 'on a reason that should prompt for a competitor when selected (e.g. \u201c{example}\u201d).'
  static REQUIRE_BILLING_EMAIL_ON_CREATE = 'Require a billing email when creating an account'
  static REQUIRE_BUSINESS_UNIT_ON_CREATE = 'Require a business unit when creating an account'
  static REQUIRE_LOSS_REASON_ON_DEACTIVATE = 'Require a loss reason when deactivating an account'
  static REQUIRE_PHONE_ON_CREATE = 'Require a contact phone when creating an account'
  static REQUIRE_PHOTO = 'Require Photo'
  static REQUIRE_WON_REASON_ON_CREATE = 'Require a won reason when creating an account'
  static REROUTE = 'Reroute'
  static RERUN_OPTIMIZATION = 'Re-run optimization'
  static RESEND = 'Resend'
  static RESEND_INVITE = 'Resend invite'
  static RESEND_UNPAID_INVOICES = 'Re-send unpaid invoices'
  static RESEQUENCE = 'Resequence'
  static RESET = 'Reset'
  static RESET_ALL = 'Reset all'
  static RESET_DATE = 'Reset date'
  static RESET_FILTERS = 'Reset filters'
  static RESET_GRACE_PERIOD = 'Reset grace period'
  static RESET_GRACE_PERIOD_SUCCESS_MSG = 'Grace period reset successfully'
  static RESET_PASSWORD = 'Reset Password'
  static RESET_PASSWORD_EMAIL_SENT_SUCCESSFULLY = 'Reset password email sent successfully'
  static RESET_SEQUENCE = 'Reset sequence'
  static RESET_USER_PWD = "Reset a user's password"
  static RESIDENTIAL = 'Residential'
  static RESOLVE = 'Resolve'
  static RESOLVE_CONTAINERS = 'Resolve containers'
  static RESOLVE_CONTAINERS_LATER = 'Resolve containers later'
  static RESPONSIBLE_PARTY = 'Responsible party'
  static RESTORE = 'Restore'
  static RESTORE_DAILY_SEQUENCE_VERSION = 'Restore daily sequence to this point?'
  static RESTORE_DAILY_SEQUENCE_VERSION_DESCRIPTION =
    'Preview this daily route as it was at the selected version, then publish to apply it.'
  static RESTORE_DAILY_SEQUENCE_VERSION_REASSIGN_WARNING =
    'Publishing the restored version reorders this daily route AND re-attaches stops that have been unassigned since — they will be taken from wherever they are now.'
  static RESTORE_DAILY_SEQUENCE_VERSION_WARNING =
    'Publishing the restored version reorders this daily route. Stops added since the version stay at the top in their current order.'
  static RESTORE_MASTER_SEQUENCE_VERSION = 'Restore master sequence to this point?'
  static RESTORE_MASTER_SEQUENCE_VERSION_DESCRIPTION =
    'Reorder the master sequence to match this version. Only the order changes — no stops are added or removed.'
  static RESTORE_MASTER_SEQUENCE_VERSION_REASSIGN_WARNING =
    'Stops in this version that now belong to other routes will be taken from those routes. Unassigned stops in this version will be assigned back to this route. The other routes lose those stops with no warning.'
  static RESTORE_MASTER_SEQUENCE_VERSION_WARNING =
    'Only the sequence order is restored. Stops added since this version stay on the master and move to the top. Stops that have been unassigned since this version will not come back.'
  static RESTORE_PREVIEW_BADGE = 'Restore preview'
  static RESTORE_PREVIEW_BADGE_HELPER = 'This date will be restored to the selected version'
  static RESTORE_PREVIEW_DISCARD_DESCRIPTION = 'You have a restore preview staged. Continuing will discard it.'
  static RESTORE_PREVIEW_DISCARD_TITLE = 'Discard restore preview?'
  static RESTORE_PREVIEW_EMPTY = 'Nothing to restore — the previewed sequence matches the current master.'
  static RESTORE_PREVIEW_HEADLINE_SUFFIX = 'will be restored from this version'
  static RESTORE_PREVIEW_INCOMPLETE_STOPS =
    'Some stops on this version are missing routing data and will stay where they are. Everything else will be restored.'
  static RESTORE_PREVIEW_KICKER = 'Restore preview'
  static RESTORE_PREVIEW_REASSIGN_TAG = 'Reassigning stops from other routes'
  static RESTORE_PREVIEW_STAGED = 'Restore preview staged · review on the board then publish'
  static RESTORE_PREVIEW_SUB = 'Master stops and future dailies follow this version. Confirm to restore.'
  static RESTORE_PREVIEW_SUB_DAILY = 'This daily route follows this version. Confirm to restore.'
  static RESTORE_THIS_VERSION = 'Restore this version'
  static RESTORE_TO_WORK_ORDER = 'Restore to work order'
  static RETRIEVALS_FOLLOW_END_DATE = 'Removals are set for this date unless you give a container its own.'
  static RETRIEVAL_DATE = 'Removal date'
  static RETRIEVAL_SCHEDULED = 'Removal scheduled'
  static RETRIEVED = 'Removed'
  static RETRY = 'Retry'
  static RETURNED_TO_INVENTORY = 'Returned to inventory'
  static RETURNED_TO_YARDS = 'Containers returned to their yards'
  static RETURN_TO = 'Return to'
  static RETURN_TO_INVENTORY = 'Return to inventory'
  static REVENUE = 'Revenue'
  static REVENUE_REPORT = 'REVENUE_REPORT'
  static REVENUE_REPORT_TYPE_FILTER = 'REVENUE'
  static REVERSED = 'Reversed'
  static REVERT = 'Revert'
  static REVERTED_TO_DRAFT = 'Reverted to draft'
  static REVERT_CONFIRM_BUTTON = 'Revert'
  static REVERT_CREDIT_MEMO_TO_DRAFT = 'Revert credit memo to draft'
  static REVERT_CREDIT_MEMO_TO_DRAFT_CONFIRMATION = 'This credit memo has already been sent to the customer. Do you want to proceed?'
  static REVERT_CREDIT_MEMO_TO_DRAFT_SUCCESS = 'Credit memo reverted to draft state'
  static REVERT_EDIT_CHANGES = 'Revert changes'
  static REVERT_INVOICE_TO_DRAFT_SUCCESS = 'Invoice reverted to draft state'
  static REVERT_INVOICE_TO_UNPAID_SUCCESS = 'Invoice reverted to unpaid state'
  static REVERT_POSTED_TO_DRAFT = 'Revert posted to draft'
  static REVERT_SELECT_UNPAID_OR_PAID = 'Select unpaid or paid invoices to revert to draft'
  static REVERT_TO_DRAFT = 'Revert to draft'
  static REVERT_TO_DRAFT_BULK_ACTION_SUCCESS = 'Invoices reverted to draft successfully'
  static REVERT_TO_UNPAID = 'Revert to unpaid'
  static REVIEW = 'Review'
  static REVIEWED = 'Reviewed'
  static REVIEW_ACTIONS_BEFORE_CONFIRMING = 'Review actions before confirming'
  static REVIEW_ACTIONS_DESCRIPTION = 'Each action is independent — uncheck to skip.'
  static REVIEW_ALL_FIELDS = 'Review all fields'
  static REVIEW_AND_CONFIRM = 'Review & confirm'
  static REVIEW_CONFIRM_DAYS = 'Review and confirm the following updates that will occur based on your changes.'
  static REVIEW_LAYOUT = 'Review layout'
  static REVIEW_OPTIMIZATION = 'Review optimization'
  static RE_ROUTE_UPDATES = 'Please Note: All affected work orders will be unassigned and will need to be re-routed.'
  static RFID_TAG = 'RFID tag'
  static RIGHT_TURNS = 'Right turns'
  static ROAD = 'Road'
  static ROAD_SIDE = 'Road side'
  static ROAD_SIDE_ANY = 'Any side'
  static ROAD_SIDE_HELP = 'Same side avoids cross-traffic stops for trucks.'
  static ROAD_SIDE_SAME = 'Same side as service address'
  static ROLE = 'Role'
  static ROLE_NAME = 'Role Name'
  static ROLLOFF = 'Roll-off'
  static ROUTABLE_STOP_CANNOT_BE_UNASSIGNED_BY_DRAG = 'This stop cannot be unassigned by dragging. Delete it instead.'
  static ROUTE = 'Route'
  static ROUTES = 'Routes'
  static ROUTES_LIKE_A_CAR = 'routes like a car (no truck size)'
  static ROUTES_UNAVAILABLE = 'Routes could not be loaded'
  static ROUTE_DELETED_SUCCESSFULLY = 'Route deleted successfully'
  static ROUTE_DELETE_WARNING =
    'removes it from every day, not just the selected date. All of its stops from today onward will be unassigned and its master sequences cleared. Recovering the route later will not restore its stops. Are you sure you want to continue?'
  static ROUTE_DETAILS = 'Route details'
  static ROUTE_DETAILS_SUBTITLE = 'Identity, yards, method, and driver assignment.'
  static ROUTE_DISTANCE_COMPARISON = 'Route distance comparison'
  static ROUTE_END_TIME = 'Route end time'
  static ROUTE_EXCEEDS_STOP_LIMIT = 'The selected route has more than 25 stops. Please select a route with 25 or fewer stops.'
  static ROUTE_FILTER_ALL = 'All Routes'
  static ROUTE_INFO =
    'View, modify, create or delete routes, assign stops to routes, reorder routes, add disposal sites, edit disposal site order'
  static ROUTE_LOOKUP = 'Route'
  static ROUTE_MANAGER = 'Route manager'
  static ROUTE_NAME = 'Route name'
  static ROUTE_NOTE = 'Route Note'
  static ROUTE_OPTIMIZATION = 'Route sequence optimization'
  static ROUTE_PLAN_ID = 'RP'
  static ROUTE_PLAN_ID_WRONG_COLUMN_ERROR =
    'Your sequence import did not have a column named Route Plan ID. Please try a route export and you’ll have a properly formatted file to import with a hidden Column O where Route Plan ID column is properly formatted with work orders that can be sequenced.'
  static ROUTE_PLAN_ID_WRONG_UUID_FORMAT =
    'Imported Route Plan IDs were not the correct format. Please try a route export and then make sure not to modify the format of hidden Column O, but the sequence only. Adding IDs or data to column O that are not in the export increases the chance of this error, and IDs that are not matching will be ignored for purposes of sequencing.'
  static ROUTE_RECOVERY = 'Route recovery'
  static ROUTE_START_TIME = 'Route start time'
  static ROUTE_STATUS_MAP_TOGGLE = 'Route'
  static ROUTE_STOPS_STILL_LOADING = "This route's stops are still loading; End and a set position can be saved once they're in."
  static ROUTE_SUCCESSFULLY_CREATED = 'Route successfully created'
  static ROUTE_SUCCESSFULLY_UPDATED = 'Route successfully updated'
  static ROUTE_TIMING = 'When'
  static ROUTING = 'Routing'
  static ROUTING_ACCOUNT_NUMBER = 'Routing Number / Account Number'
  static ROUTING_AND_WORK_ORDERS = 'Routing & Work Orders'
  static ROUTING_SAVED = 'Routing saved successfully'
  static ROW = 'Row'
  static ROWS = 'rows'
  static ROWS_HAD_ERRORS = 'rows had errors and could not be processed from'
  static ROW_ACTIONS = 'Row actions'
  static ROW_DENSITY = 'Row density'
  static RULES = 'Rules'
  static RULES_ARE_LIMITED_TO = 'Rules are limited to'
  static RULES_INFO = 'Accounts in any Include group, minus any that match an exclusion.'
  static RULES_NOT_EDITABLE = "These rules were built in a shape that can't be edited here."
  static RULE_FIELD = 'Field'
  static RULE_VALUE = 'Value'
  static RUN_LOWERCASE = 'Run'
  static SAFETY = 'Safety'
  static SALARY = 'Salary'
  static SALES = 'Sales'
  static SAME_AS_HOSTED_POLICY = 'Same as Hosted Policy'
  static SAME_AS_STARTING_YARD = 'Same as starting yard'
  static SAMPLE_MESSAGES_SECTION = 'Sample Messages'
  static SAMPLE_MESSAGE_1 = 'Sample Message 1'
  static SAMPLE_MESSAGE_2 = 'Sample Message 2'
  static SAMPLE_MESSAGE_REQUIREMENTS_TITLE = 'What carriers require in sample messages'
  static SATELLITE = 'Satellite'
  static SATURDAY = 'Saturday'
  static SAVE = 'Save'
  static SAVED = 'Saved'
  static SAVED_CHANGES = 'Saved changes'
  static SAVED_PAYMENT_METHOD = 'Saved payment method'
  static SAVED_VIEW = 'Saved View'
  static SAVE_AND_PUBLISH = 'Save & publish'
  static SAVE_CHANGES = 'Save changes'
  static SAVE_CURRENT_DAY = 'Save current day'
  static SAVE_DRAFT = 'Save draft'
  static SAVE_DRAFT_AND_PUBLISH = 'Save draft & publish'
  static SAVE_DRAFT_AND_PUBLISH_TOOLTIP =
    'Selecting will save your draft changes and publish your current changes live, updating the route on mobile devices'
  static SAVE_INTO_MASTER_ROUTE = 'Save into Master Route'
  static SAVE_MASTER_AND_FUTURE = 'Save master & future days'
  static SAVE_METHOD = 'Save method'
  static SAVE_PARTIALLY = 'Save partially'
  static SAVE_PERMANENT = 'Save permanent'
  static SAVE_PERMANENT_TOOLTIP =
    'While this saves updates to the master sequence, it makes guesses when the daily stop sequence already differs from the master stop sequence. To make precise changes, use "Edit Master Sequence"'
  static SAVE_REPORT = 'Save Report'
  static SAVE_TARGET_DAY = 'Save target day'
  static SAVE_VIEW = 'Save View'
  static SAVE_WITHOUT_MEASURE = 'Save without measure'
  static SAVING = 'Saving'
  static SAVING_SERVICE = 'Saving service...'
  static SCHEDULE = 'Schedule'
  static SCHEDULED = 'Scheduled'
  static SCHEDULED_DESCRIPTION =
    'The work order is queued for service on its assigned date. It has not yet been started or completed by a driver'
  static SCHEDULED_SERVICES = 'Scheduled services'
  static SCHEDULED_TO_DEACTIVATE_ON = 'This service is scheduled to deactivate on'
  static SCHEDULE_DEACTIVATION = 'Schedule deactivation'
  static SCHEDULE_DELIVERY = 'Schedule delivery'
  static SCHEDULE_FOR_LATER_COMING_SOON = 'Schedule-for-Later is coming soon — scheduled sends will appear here'
  static SCHEDULE_RATE_ADJUSTMENT = 'Schedule Rate Adjustment'
  static SCHEDULE_SEND = 'Schedule send'
  static SCHEDULE_SERVICE_DAY = 'Schedule service day'
  static SCHEDULING_RESULTS_CAPPED_ACTION = 'Reduce radius or apply filters'
  static SCHEDULING_RESULTS_CAPPED_MIDDLE = 'closest of'
  static SCHEDULING_RESULTS_CAPPED_PREFIX = 'Showing the'
  static SCHEDULING_RESULTS_CAPPED_SHORT_PREFIX = 'Showing'
  static SCREEN_POP_DEMO_CALL = 'Demo call'
  static SCREEN_POP_DEMO_CALL_FAILED = 'The demo call could not be started. Please try again.'
  static SCREEN_POP_INCOMING_CALL = 'Incoming call'
  static SCREEN_POP_NO_MATCH = 'No customer matches this number.'
  static SCREEN_POP_RECENT_CALLS = 'Recent calls with this number'
  static SEARCH = 'Search'
  static SEARCHING = 'Searching…'
  static SEARCH_ACCOUNT = 'Search account...'
  static SEARCH_ACCOUNTS = 'Search accounts by name or number'
  static SEARCH_ACCOUNTS_BY_ADDRESS = 'Search by account, name, city or zip'
  static SEARCH_ADDRESS_PLACEHOLDER = 'Start typing an address to search'
  static SEARCH_AVAILABLE_NUMBERS = 'Search Available Numbers'
  static SEARCH_BY_INVOICE = 'Search by invoice number'
  static SEARCH_CONTAINERS_HINT = 'Search by container #, OT#, or serial'
  static SEARCH_CUSTOMER = 'Search customer'
  static SEARCH_CUSTOMERS_PLACEHOLDER = 'Search customers by name, address or email'
  static SEARCH_CUSTOMER_BY_EMAIL = 'Search customer by email'
  static SEARCH_CUSTOMER_BY_PHONE = 'Search customer by phone'
  static SEARCH_EMAIL = 'Search email'
  static SEARCH_FILTERS = 'Search filters…'
  static SEARCH_GROUPS = 'Search by name'
  static SEARCH_INVOICE_PLACEHOLDER = 'Start typing an invoice number to search'
  static SEARCH_LOCATIONS = 'Search locations...'
  static SEARCH_MESSAGES = 'Search messages...'
  static SEARCH_NOTIFICATIONS_PLACEHOLDER = 'Search notifications, customers, invoice or WO numbers…'
  static SEARCH_PLACEHOLDER = 'Search...'
  static SEARCH_RULES = 'Search rules…'
  static SEARCH_SERVICES = 'Search Services'
  static SEARCH_SERVICE_PLACEHOLDER = 'Search Service...'
  static SEARCH_STOPS = 'Search stops'
  static SEARCH_TAXES = 'Search taxes…'
  static SEARCH_TO_SEE_NUMBERS = 'Enter an area code (or leave blank) and press Search to see available numbers.'
  static SEARCH_TRY_AGAIN = 'Please try another search'
  static SECOND = 'Second'
  static SECONDARY_TEXT_HEADINGS = 'Secondary (Page Headings)'
  static SECTION_HAS_ERRORS = 'Section has errors'
  static SEE_FULL_HISTORY = 'See full history'
  static SEGMENT = 'segment'
  static SEGMENTS = 'segments'
  static SELECT = 'Select'
  static SELECTED = 'selected'
  static SELECTED_COUNT_SUFFIX = 'selected'
  static SELECTED_FILE = 'Selected file:'
  static SELECTED_PRICED_SERVICE = 'Selected Priced Service'
  static SELECTED_ROUTE = 'Selected Route'
  static SELECTED_SERVICE = 'Selected service'
  static SELECTED_SERVICES = 'Selected Services'
  static SELECTION = 'Selection'
  static SELECT_ALL = 'Select all'
  static SELECT_ALL_IN_VIEW = 'Select all in view'
  static SELECT_A_BIN_TYPE = 'Select a bin type'
  static SELECT_A_CUSTOMER = 'Please select a customer to proceed'
  static SELECT_A_DATE = 'Select a date'
  static SELECT_A_PAYMENT_METHOD = 'Please select a payment method to proceed'
  static SELECT_A_ROUTE = 'Select a route'
  static SELECT_CONTAINERS_INSTRUCTION = 'You can select one or multiple containers using the checkboxes.'
  static SELECT_DAY_TO_SET_START_DATE = 'Select a day to set start date'
  static SELECT_DESTINATION_DATE_BEFORE_MOVING_STOPS = 'Select a destination date before moving stops.'
  static SELECT_DIFFERENT_FILE = 'Select a different file'
  static SELECT_DRAFT_BATCHES_TO_DELETE = 'Select draft batches to delete'
  static SELECT_DRIVER = 'Select a driver'
  static SELECT_DRIVERS = 'Select drivers'
  static SELECT_EXACTLY_ONE_DRAFT_BATCH_TO_POST = 'Select exactly one draft batch to post'
  static SELECT_EXPIRATION_DATE = 'Select expiration date'
  static SELECT_FEE_PLACEHOLDER = 'Select Fee'
  static SELECT_FILTER = 'Select Filter'
  static SELECT_GROUP = 'Select a group'
  static SELECT_METHOD_PLACEHOLDER = 'Select method'
  static SELECT_NEAREST_STOP_TO_ASSIGN = 'Select a nearest stop or route to assign this work order'
  static SELECT_OR_SEARCH_TO_ADD_RENTAL_FEE = 'Select or search to add rental fee'
  static SELECT_PAYMENT_TERMS_LABEL = 'Select payment terms'
  static SELECT_PERIOD_PLACEHOLDER = 'Select a period'
  static SELECT_PLACEHOLDER = 'Select...'
  static SELECT_RESET_OPTIONS_PLACEHOLDER = 'Select reset options'
  static SELECT_ROUTE = 'Select route'
  static SELECT_ROUTE_TO_OPTIMIZE = 'Select a route to optimize'
  static SELECT_ROUTE_TO_SEQUENCE = 'Select route to sequence'
  static SELECT_ROUTE_TO_VIEW_STOPS = 'Select a route to view and resequence its stops'
  static SELECT_SERVICE = 'Select a service'
  static SEND = 'Send'
  static SENDING = 'Sending...'
  static SENDING_INVOICES = 'Sending invoices...'
  static SENDING_STATEMENT = 'The statement is being sent'
  static SEND_AND_CONFIRM = 'Send & confirm'
  static SEND_AN_EMAIL = 'Send an email'
  static SEND_INVOICE_SUCCESS = 'Invoices have been sent. Please wait a few seconds for email activity.'
  static SEND_MESSAGE = 'Send message'
  static SEND_MESSAGE_CONFIRM_PREFIX = 'This message will be sent to'
  static SEND_MESSAGE_CONFIRM_TITLE = 'Send message?'
  static SEND_NOTIFICATION = 'Send notification'
  static SEND_OPTIONS = 'Send options'
  static SEND_PAYMENT_RECEIPTS_SUCCESS = 'Payment receipts have been sent'
  static SEND_PAYMENT_RECEIPT_SUCCESS = 'Payment receipt has been sent'
  static SEND_PORTAL_INVITE = 'Send portal invite'
  static SEND_RATE = 'Send rate'
  static SEND_RESET_PASSWORD_EMAIL = 'Customer will receive a password reset email. Would you like to continue?'
  static SEND_SMS = 'Send SMS'
  static SENT = 'Sent'
  static SENT_BROADCASTS_WILL_APPEAR_HERE = 'Sent broadcasts will appear here'
  static SENT_BY = 'Sent by'
  static SENT_INVOICES = 'Sent invoices'
  static SEQUENCE = 'Sequence'
  static SEQUENCE_AND_DRAFT_ROUTES_UPDATED_SUCCESSFULLY = 'Sequence and draft routes updated successfully'
  static SEQUENCE_AND_ROUTE = 'Sequence and route'
  static SEQUENCE_AND_ROUTE_AUTO = 'Auto sequence & route '
  static SEQUENCE_AND_ROUTE_MANUAL = 'Manual sequence and route'
  static SEQUENCE_LINE = 'Sequence line'
  static SEQUENCE_LINE_TOOLTIP = 'Show sequence line — planned path connecting stops in route order'
  static SEQUENCE_POSITION = 'Sequence position'
  static SEQUENCE_UPDATED_SUCCESSFULLY = 'Sequence updated successfully'
  static SEQUENCE_UPDATE_BLOCKED_INCOMPLETE_STOPS =
    'Some stops on this route are missing routing data, so publishing would drop them. Refresh the page and try again.'
  static SEQUENCE_UPDATE_BLOCKED_ROUTABLE_STOPS =
    'This route has disposal stops, which the current route manager cannot publish. Remove them, or ask an admin to turn on the new route manager.'
  static SEQUENCE_UPDATE_FAILED = 'Sequence Update Failed'
  static SEQUENCE_WITH_NEAREST_STOP = 'Sequence with nearest stop found'
  static SERIALIZATION = 'Serialization'
  static SERIAL_NO_SHORT = 'S/N'
  static SERIAL_NUMBER = 'Serial Number'
  static SERVICE = 'Service'
  static SERVICED = 'Serviced'
  static SERVICED_DESCRIPTION =
    'A driver has begun working on this stop. They may be en route, on-site, or actively performing the service. Only one stop per route should be in this state at a time.'
  static SERVICES = 'Services'
  static SERVICES_LOWERCASE = 'services'
  static SERVICES_PER_PERIOD = 'Services per Period'
  static SERVICE_ADDRESS = 'Service address'
  static SERVICE_ADDRESS_PLACEHOLDER = 'Service address'
  static SERVICE_AFTER = 'Service after'
  static SERVICE_ALREADY_DEACTIVATED = 'Service already deactivated'
  static SERVICE_ALREADY_SCHEDULED_ON_DAY = 'This service is already scheduled on %s.'
  static SERVICE_AND_BILLING = 'Service & Billing'
  static SERVICE_ATTRIBUTES = 'Service attributes'
  static SERVICE_BEFORE = 'Service before'
  static SERVICE_CITY = 'Service city'
  static SERVICE_CONTAINERS_LOAD_FAILED = 'Unable to load service containers — removed containers may be missing'
  static SERVICE_DEACTIVATED = 'Service deactivated'
  static SERVICE_DETAILS = 'Service details'
  static SERVICE_DUPLICATED_MSG = 'This pricing already exists and cannot be duplicated'
  static SERVICE_END_DATE = 'Service End Date'
  static SERVICE_GROUP = 'Service Group'
  static SERVICE_INFO = 'View services, service events and work orders; edit these; create / delete these'
  static SERVICE_INFORMATION = 'Service information'
  static SERVICE_INTERVAL = 'Service Interval'
  static SERVICE_INTERVAL_REQUIRED = 'Service interval is required'
  static SERVICE_LOCATION = 'Service Location'
  static SERVICE_LOCATION_ADDRESS_HEADER = 'Service location address'
  static SERVICE_LOCATION_NAME = 'Service Location Name'
  static SERVICE_LOCATION_REQUIRED_FOR_CONTAINERS = 'Service location is required to place containers on the map.'
  static SERVICE_LOWERCASE = 'service'
  static SERVICE_METHOD = 'Service method'
  static SERVICE_NAME = 'Service name'
  static SERVICE_NOTE = 'Service note'
  static SERVICE_NOTIFICATIONS = 'Service notifications'
  static SERVICE_PUBLISHED_SUCCESSFULLY = 'Service published successfully!'
  static SERVICE_REACTIVATED = 'Service reactivated'
  static SERVICE_REPORT = 'SERVICE_REPORT'
  static SERVICE_REPORT_TYPE_FILTER = 'SERVICES'
  static SERVICE_REVIEW = 'Service Review'
  static SERVICE_ROADS = 'Service roads'
  static SERVICE_SCHEDULE = 'Service schedule'
  static SERVICE_SET_TO_NO_CONTAINER = 'Service set to no container'
  static SERVICE_START_DATE = 'Service start date'
  static SERVICE_STATUS = 'Service status'
  static SERVICE_SUSPENSION = 'Service suspension'
  static SERVICE_TAG = 'Service tag'
  static SERVICE_TIME = 'Service time'
  static SERVICE_TIMES = 'Service times'
  static SERVICE_TIMESTAMPS = 'Service timestamps'
  static SERVICE_TYPE = 'Service type'
  static SERVICE_VERIFIED = 'Service Verified'
  static SERVICE_VIEW = 'Locations'
  static SERVICE_ZIP_CODE = 'Service zip code'
  static SERVICE_ZONE = 'Service Zone'
  static SETTINGS = 'Settings'
  static SETTINGS_ARIA_LABEL = 'settings'
  static SETTINGS_INTEGRATIONS_TITLE = 'Integrations'
  static SETTINGS_INTEGRATIONS_TITLE_PAYMENT = 'Payment Processing'
  static SETTINGS_INTEGRATIONS_TITLE_SCALE = 'Scale & Disposal Ticketing'
  static SETTINGS_INTEGRATION_AUTHENTICATION = 'Integration authentication'
  static SETTINGS_INTEGRATION_DEACTIVATE = 'Deactivate integration'
  static SETTINGS_INTEGRATION_DEACTIVATE_DESCRIPTION = 'Are you sure you want to deactivate this integration?'
  static SETTINGS_INTEGRATION_DEACTIVATE_SUCCESS_MESSAGE = 'Integration deactivated successfully'
  static SETTINGS_INTEGRATION_ERROR_MESSAGE = 'Error updating integration'
  static SETTINGS_INTEGRATION_INPUT_INVALID_UUID = 'Invalid ID - Try again'
  static SETTINGS_INTEGRATION_INPUT_LABEL = 'ID'
  static SETTINGS_INTEGRATION_INPUT_PLACEHOLDER = 'Enter Unique-ID'
  static SETTINGS_INTEGRATION_MENU_ID = 'Unique ID'
  static SETTINGS_INTEGRATION_SUCCESS_MESSAGE = 'Integration updated successfully'
  static SETTINGS_INTEGRATION_VALID_UUID = 'Valid Unique ID'
  static SETTINGS_SAVED_SUCCESSFULLY = 'Settings saved successfully'
  static SETTLEMENT_CUSTOMER_OWNED = 'Customer owned'
  static SETTLEMENT_HINT =
    'A container left on an ended service is an asset you stop billing for and stop collecting. Anything skipped here stays on the service until it is resolved.'
  static SETTLEMENT_NO_WRITE_PATH = 'Container outcomes cannot be saved yet, so they are resolved later.'
  static SET_AS_DEFAULT_ROUTE_VIEW = 'Set as my default view'
  static SET_AS_DEFAULT_SITE = 'Set as default site'
  static SET_BY_SUSPENDING_THE_ACCOUNT = 'Set by suspending the account'
  static SET_END_DATE = 'Set end date'
  static SET_OUTCOME = 'Set outcome'
  static SET_SERVICE_DETAILS_AND_PRICING = 'Set service dates & pricing'
  static SET_START_DATE = 'Set start date'
  static SET_TO_PRINT_ONLY = 'Set to print only'
  static SHARP_TURNS = 'Sharp turns'
  static SHORT_MONTH_CLAMP_INFO =
    'For months with fewer than 31 days (February, April, June, September, November), the due date will automatically default to the last day of the month.'
  static SHOW = 'Show'
  static SHOWING = 'Showing'
  static SHOW_ALL_RESULTS = 'Show all results for'
  static SHOW_ALL_SEQUENCE_CHANGES_TOOLTIP = 'Show all sequence changes including shifted stops'
  static SHOW_ALREADY_SET_PREFIX = 'Show the'
  static SHOW_AUTOPAY_INDICATOR = 'Show AutoPay indicator'
  static SHOW_AUTOPAY_INDICATOR_DESCRIPTION = 'Shown on accounts with AutoPay enabled'
  static SHOW_BUSINESS_PHONE_NUMBER = 'Show phone in return address'
  static SHOW_BUSINESS_PHONE_NUMBER_DESCRIPTION = 'Displays hauler phone in the return address block'
  static SHOW_CALENDAR = 'Show Calendar'
  static SHOW_DETAILS = 'Show details'
  static SHOW_DRIVER_PATH = 'Show driver path'
  static SHOW_EMPTY_YARDS = 'Show empty yards'
  static SHOW_FOR_ALL_WORK_ORDERS = 'Show for all work orders'
  static SHOW_INVOICE_NUMBER = 'Show invoice number'
  static SHOW_INVOICE_NUMBER_DESCRIPTION = 'Displays invoice # on left body and right stub'
  static SHOW_LATE_FEES_AS_LINE_ITEM = 'Show late fees as line item'
  static SHOW_LATE_FEES_AS_LINE_ITEM_DESCRIPTION = 'Itemizes each late fee with rate, due date, and balance'
  static SHOW_LEGEND = 'Show legend'
  static SHOW_MENU = 'Show menu'
  static SHOW_MILES_ON_ROUTE_LIST = 'Show Miles on Route List'
  static SHOW_MORE = 'Show more'
  static SHOW_MORE_ARIA_LABEL = 'show more'
  static SHOW_NOTE = 'Show Note'
  static SHOW_NOTIFICATION_VIEWS = 'Show notification views'
  static SHOW_ON_MOBILE = 'Show on mobile'
  static SHOW_PHONE_IN_MAILING_ADDRESS = 'Show phone in mailing area'
  static SHOW_PHONE_IN_MAILING_ADDRESS_DESCRIPTION = 'Displays hauler phone below the customer mailing address'
  static SHOW_PLACEHOLDER_CONTAINERS = 'Show placeholder containers'
  static SHOW_REVIEW_MENU = 'Show review menu'
  static SHOW_ROUTING = 'Show routing'
  static SHOW_SEQUENCE_CHANGES = 'Show sequence changes'
  static SHOW_SPLIT_INDICATOR = 'Show split indicator'
  static SHOW_SPLIT_INDICATOR_DESCRIPTION = 'Shows "(1 of 2)" on cards when an invoice spans multiple postcards'
  static SHOW_YARDS_ON_MAP = 'Show yards'
  static SIDE_BY_SIDE = 'Side by side'
  static SIGNATURE = 'Signature'
  static SIGNATURE_DATE_DIFFERS_FROM_WO = 'Signature date differs from the work order date.'
  static SIGNATURE_REQUIRED = 'Signature Required'
  static SINGLE_DISPOSAL_TICKET_LIMIT = 'Only one disposal ticket per work order is supported'
  static SINGLE_PAYMENT = 'Single payment'
  static SINGLE_POSTCARD = 'Single postcard'
  static SITE_MAPPING = 'Site mapping'
  static SITE_NAME = 'Site name'
  static SITE_RATE = 'Site rate'
  static SIZE = 'Size'
  static SI_REPORT = 'SI_REPORT'
  static SI_REPORT_TYPE_FILTER = 'SENT_INVOICES'
  static SKILL = 'Skill'
  static SKILLS_REQUIRED = 'Skills Required'
  static SKIP = 'Skip'
  static SKIPPED = 'Skipped'
  static SKIPPED_DESCRIPTION =
    'The driver was unable to complete service during this attempt, typically due to access issues, blocked containers, contamination, or other obstacles outside their control.'
  static SKIP_ZERO_AMOUNT_INVOICES = 'Skip $0 amount invoices'
  static SMS = 'SMS'
  static SMS_REGISTRATION = 'SMS Registration'
  static SMS_REGISTRATION_PAGE_SUBTITLE = 'Manage your 10DLC registration details and current status.'
  static SMS_REPLY = 'SMS Reply'
  static SNAPPING_TO_ROAD = 'Snapping to road'
  static SNAP_APPLIED_MANUAL = '%d placed by hand'
  static SNAP_APPLIED_N = '%d container locations updated'
  static SNAP_APPLIED_ONE = '1 container location updated'
  static SNAP_APPLY_N = 'Update %d locations'
  static SNAP_APPLY_ONE = 'Update 1 location'
  static SNAP_APPLY_SKIPPED = '%d skipped — those containers changed since the run'
  static SNAP_BULK_PLACE_AT_DRIVER_PATH = 'Place %d on driver path'
  static SNAP_BULK_PLACE_AT_STOP = 'Place %d at stop location'
  static SNAP_CHIP_ALREADY_ON_ROAD = 'Already on road'
  static SNAP_CHIP_ERROR = 'Snap error'
  static SNAP_CHIP_NO_LOCATION = 'No location'
  static SNAP_CHIP_NO_MATCH = 'No road match'
  static SNAP_CHIP_PLACED = 'Placed by hand'
  static SNAP_CHIP_PLACED_BY_HAND = 'Placed by hand'
  static SNAP_CHIP_UPDATING = 'Updating'
  static SNAP_CLASS_ALREADY_ON_ROAD = 'on road'
  static SNAP_CLASS_BIG_MOVE = 'need review'
  static SNAP_CLASS_ERROR = 'errored'
  static SNAP_CLASS_NO_LOCATION = 'no location'
  static SNAP_CLASS_NO_ROAD_MATCH = 'no road match'
  static SNAP_CLASS_SNAPPED = 'snapped'
  static SNAP_CONTAINER_UNNAMED = 'Unnamed'
  static SNAP_DETAIL_KEEPING = 'Keeping current location'
  static SNAP_DETAIL_SETTING_LOCATION = 'Setting a location'
  static SNAP_FEET = '%d ft'
  static SNAP_FILTER_FAILED = 'Failed'
  static SNAP_FILTER_FLAGGED = 'Flagged'
  static SNAP_FILTER_MOVING = 'Moving'
  static SNAP_FLAG_MOVES_OVER = 'Flag moves over'
  static SNAP_INCLUDE_CONTAINER = 'Include %s'
  static SNAP_LEGEND_FAILED = 'No road match'
  static SNAP_LEGEND_KEPT = 'Not updating'
  static SNAP_LEGEND_NEW = 'New location'
  static SNAP_LEGEND_OLD = 'Current location'
  static SNAP_NOTHING_TO_REVIEW = 'Nothing needs review'
  static SNAP_NO_LOCATION_MANY = 'containers have no location yet, so they cannot be corrected here.'
  static SNAP_NO_LOCATION_ONE = 'container has no location yet, so it cannot be corrected here.'
  static SNAP_N_CONTAINERS_TO_ROAD = 'Snap %d containers to road'
  static SNAP_N_OF_M_SELECTED = '%d of %m selected'
  static SNAP_N_OF_M_SELECTED_UPDATING = '%d of %m selected · %u updating'
  static SNAP_N_OF_M_TO_UPDATE = '%d of %m to update'
  static SNAP_ONE_CONTAINER_TO_ROAD = 'Snap 1 container to road'
  static SNAP_PLACED_AT_DRIVER_PATH = 'Moved to driver path'
  static SNAP_PLACED_AT_STOP = 'Moved to stop'
  static SNAP_PLACED_BY_DRAG = 'Placed by hand'
  static SNAP_PLACE_AT = 'Place at…'
  static SNAP_PLACE_AT_DRIVER_PATH = 'Nearest point on driver path'
  static SNAP_PLACE_AT_DRIVER_PATH_NO_PATH = 'Driver path — none recorded for this day'
  static SNAP_PLACE_AT_DRIVER_PATH_UNAVAILABLE = 'Driver path — turn the layer on to use'
  static SNAP_PLACE_AT_STOP = 'Stop location'
  static SNAP_PREVIEW_BANNER = 'Snap complete — nothing has moved yet.'
  static SNAP_PREVIEW_BANNER_TO_REVIEW = 'Snap complete, %d to review — nothing has moved yet.'
  static SNAP_RESULTS_ERROR = 'Could not load the snap results. Nothing has moved — reset and run again.'
  static SNAP_REVERTED_N = '%d container locations restored'
  static SNAP_REVERTED_ONE = '1 container location restored'
  static SNAP_REVERT_NOTHING = 'Nothing was restored — those containers have changed since the update'
  static SNAP_REVERT_SKIPPED = '%d not restored — those containers changed since the update'
  static SNAP_RUN_AT_DRIVER_PATH = 'Nearest point on driver path'
  static SNAP_RUN_AT_ROAD = 'Nearest road'
  static SNAP_RUN_AT_STOP = 'Stop location'
  static SNAP_RUN_CONTINUES_IN_BACKGROUND = 'This can take a few minutes. You can close the dialog — the run continues.'
  static SNAP_RUN_DESTINATION = 'Choose where to place them'
  static SNAP_RUN_STATUS_ERROR = 'Lost contact with the snap run — still retrying. Reset to start over.'
  static SNAP_TO_ROAD = 'Snap to road'
  static SNAP_UNDO_APPLY = 'Undo'
  static SNAP_UNDO_BANNER_N = '%d container locations updated at %s'
  static SNAP_UNDO_BANNER_ONE = '1 container location updated at %s'
  static SNAP_UNDO_DISMISS = 'Dismiss'
  static SNAP_UNDO_PLACEMENT = 'Undo placement'
  static SNAP_ZOOM_TO_CONTAINER = 'Zoom to this container'
  static SNAP_ZOOM_TO_STOP = 'Zoom to this stop'
  static SOLD_TO_CUSTOMER = 'Sold to customer'
  static SOLID_WASTE = 'Solid Waste'
  static SOMETHING_WENT_WRONG = 'Something went wrong.'
  static SORT = 'Sort'
  static SORT_ADDRESS_NAME_AZ = 'Sort by address name A-Z'
  static SORT_ADDRESS_NAME_ZA = 'Sort by address name Z-A'
  static SORT_ALPHABETICAL_A_Z = 'Alphabetical (A → Z)'
  static SORT_ALPHABETICAL_Z_A = 'Alphabetical (Z → A)'
  static SORT_BY = 'Sort by'
  static SORT_COMPLETION_ORDER = 'Completion order'
  static SORT_COMPLETION_ORDER_HINT = 'When each stop was actually serviced'
  static SORT_EFFECTIVE_DATE_NEWEST = 'Effective date (newest)'
  static SORT_FULL_ADDRESS_AZ = 'Sort by full address A-Z'
  static SORT_FULL_ADDRESS_ZA = 'Sort by full address Z-A'
  static SORT_NAME_A_Z = 'Name (A–Z)'
  static SORT_NAME_Z_A = 'Name (Z–A)'
  static SORT_PLANNED_SEQUENCE = 'Planned sequence'
  static SORT_PLANNED_SEQUENCE_HINT = 'The route as it was planned'
  static SORT_PRICE_HIGH_LOW = 'Price (high → low)'
  static SORT_PRICE_LOW_HIGH = 'Price (low → high)'
  static SORT_STOPS_BY = 'Sort stops by'
  static SOURCE = 'Source'
  static SOURCES = 'Sources'
  static SOURCE_DRIVER = 'Driver'
  static SOURCE_MANUAL = 'Manual'
  static SOURCE_MIX = 'Source Mix'
  static SOURCE_ML = 'Automated (ML)'
  static SPECIAL = 'Special'
  static SPECIAL_ITEM = 'Special item'
  static SPECIFIC_DATE = 'Specific Date'
  static SPECIFIC_DAYS = 'Specific Days'
  static SPEED = 'Speed'
  static SPOTS_HELD_FOR_REPLACEMENTS = 'Spots held for the replacements'
  static SPOTS_HELD_ON_REMOVE = 'The spots are held for replacements.'
  static SPOT_HELD_FOR_REPLACEMENT = 'Spot held for a replacement'
  static SPOT_HELD_ON_REMOVE = 'The spot is held for a replacement.'
  static STALE_ACCEPT_LATEST_CHANGES = 'Accept latest changes'
  static STALE_AGO_SUFFIX = 'ago'
  static STALE_BANNER_DESCRIPTION = 'Accept the latest changes, or save your edits as a draft to keep them.'
  static STALE_CONFLICT_BODY =
    'Your changes haven’t been published. To avoid overwriting their work, save your changes as a draft. You can review and publish later from the draft selector.'
  static STALE_CONFLICT_TITLE_PREFIX = 'This route was updated by'
  static STALE_CREATE_DRAFT = 'Create draft'
  static STALE_DISCARD_AND_RELOAD = 'Discard and reload'
  static STALE_DISMISS = 'dismiss'
  static STALE_JUST_NOW = 'just now'
  static STALE_KEEP_EDITING = 'Keep editing'
  static STALE_OVERWRITE_ANYWAY = 'Overwrite anyway'
  static STALE_SAVE_AS_DRAFT = 'Save as draft'
  static STALE_SOMEONE = 'Someone'
  static STALE_UPDATED_BY = 'Updated by'
  static STALE_UPDATED_REMOTELY = 'Updated remotely'
  static STANDARD = 'Standard'
  static START = 'Start'
  static STARTING_BASIC_CSV_IMPORT = 'Starting basic CSV import...'
  static STARTING_CSV_IMPORT = 'Starting CSV import...'
  static STARTING_YARD = 'Starting yard'
  static STARTS_WITH = 'starts with'
  static START_DATE = 'Start date'
  static START_FROM = 'Start from'
  static START_OVER = 'Start over'
  static START_TYPING_TO_SEARCH = 'Start typing to search'
  static STATE = 'State'
  static STATEMENT = 'Statement'
  static STATEMENT_IS_GENERATING = 'Statement is generating...'
  static STATEMENT_IS_REGENERATING = 'Statement is regenerating...'
  static STATEMENT_REGENERATION_DESCRIPTION =
    'Regenerating the statement will override and update any changes made to invoices and payments. Are you sure you want to proceed?'
  static STATEMENT_REGENERATION_TITLE = 'Regenerate statement confirmation'
  static STATIC = 'Static'
  static STATIC_LIST_HINT = 'A fixed set. The accounts you pick now, and only those, until you change them.'
  static STATISTICS = 'Statistics'
  static STATUS = 'Status'
  static STATUS_MAP_TOGGLE = 'Status'
  static STAY = 'Stay'
  static STAYS_NOT_YOURS_TO_RETRIEVE = 'Stays — not yours to remove'
  static STEP = 'Step'
  static STEPS = 'STEPS'
  static STOCK_EXCHANGE = 'Stock Exchange'
  static STOCK_SYMBOL = 'Stock Symbol'
  static STOP = 'stop'
  static STOPS = 'stops'
  static STOPS_LABEL = 'Stops'
  static STOPS_LOWERCASE = 'stops'
  static STOPS_MOVED = 'Stops moved'
  static STOP_COUNT_PLURAL = 'stops'
  static STOP_COUNT_SINGLE = 'stop'
  static STOP_LOWERCASE = 'stop'
  static STOP_SERVICE_TIME_TOOLTIP = 'Time window and service time'
  static STOP_TITLE = 'Stop'
  static STREET = 'Street'
  static STREET_ADDRESS = 'Street address'
  static STREET_LINE_2 = 'Street line 2'
  static SUBJECT = 'Subject'
  static SUBJECT_REQUIRED = 'Subject is required'
  static SUBJECT_TITLE = 'Subject title'
  static SUBMIT = 'Submit'
  static SUBMITTED_AT = 'Submitted'
  static SUBMITTING_CAMPAIGN = 'Submitting…'
  static SUBMITTING_REGISTRATION = 'Submitting...'
  static SUBMIT_CAMPAIGN = 'Submit'
  static SUBMIT_CAMPAIGN_BRAND_LOADING_TOOLTIP = 'Loading brand details…'
  static SUBMIT_CAMPAIGN_DISABLED_TOOLTIP = 'Only draft or failed campaigns can be submitted'
  static SUBMIT_CAMPAIGN_FAILURE_MSG = 'Failed to submit campaign'
  static SUBMIT_CAMPAIGN_SUCCESS_MSG = 'Campaign submitted'
  static SUBMIT_CAMPAIGN_TOOLTIP = 'Submit this campaign to TCR for review'
  static SUBSCRIBER_HELP = 'Subscriber Help'
  static SUBSCRIBER_OPT_IN = 'Subscriber Opt-In'
  static SUBSCRIBER_OPT_OUT = 'Subscriber Opt-Out'
  static SUBTOTAL = 'Subtotal'
  static SUB_ITEM = 'Sub-Item'
  static SUB_TOTAL = 'Subtotal'
  static SUB_USE_CASES = 'Sub Use Cases'
  static SUCCESS = 'Success'
  static SUCCESSFULLY_DELETED = 'Successfully deleted'
  static SUCCESSFULLY_IMPORTED = 'Successfully imported'
  static SUCCESSFULLY_PROCESSED = 'Successfully processed'
  static SUCCESS_IMPORT_SEQUENCE = 'Route Import Successful!'
  static SUGGEST_A_FEATURE = 'Suggest a feature'
  static SUMMARY = 'Summary'
  static SUNDAY = 'Sunday'
  static SUPPORT_EMAIL_ADDRESS = 'Support Email Address'
  static SUPPORT_PHONE = 'Support Phone'
  static SUPPRESSION_LIST = 'Suppression List'
  static SUPPRESSION_LIST_EMPTY = 'No opted-out numbers yet.'
  static SUPPRESSION_LIST_FOOTER = 'Opt-outs cannot be manually removed. Customers must re-subscribe by texting START to your number.'
  static SUPPRESSION_LIST_LOAD_FAILURE = 'Failed to load suppression list. Please try again.'
  static SUPPRESSION_LIST_NO_RESULTS = 'No results match your search.'
  static SUPPRESSION_LIST_SEARCH_PLACEHOLDER = 'Search phone or method…'
  static SUPPRESSION_LIST_SUBTITLE = 'Phone numbers that have opted out of SMS messages. These numbers can never be manually removed.'
  static SURCHARGE = 'Surcharge'
  static SURCHARGE_PER_AGREEMENT = 'surcharge — per service agreement'
  static SUSPEND = 'Suspend'
  static SUSPENDED = 'Suspended'
  static SUSPENDED_DATE = 'Suspended date'
  static SUSPENDED_DESCRIPTION =
    'Service has been stopped due to account suspension, typically for non-payment or other account standing issues. Unlike vacation holds, suspended work orders indicate an enforced pause requiring action to reinstate service. Drivers can see these stops (shown in red) so they know not to service them.'
  static SUSPENDED_GROUP_DESCRIPTION = 'Accounts with an active suspension.'
  static SUSPEND_ACCOUNT = 'Suspend account'
  static SUSPEND_ACCOUNTS = 'Suspend accounts'
  static SUSPEND_CUSTOMERS_EXCEED_CREDIT_LIMIT_TOOLTIP =
    'Suspend the account when its outstanding balance exceeds the credit limit set on the account. This rule is independent of days late, and either one alone is enough to suspend.'
  static SUSPEND_WHEN_BALANCE_EXCEEDS_CREDIT_LIMIT = 'Suspend when balance exceeds credit limit'
  static SUSPEND_WHEN_INVOICE_OVERDUE = 'Suspend when an invoice is overdue'
  static SUSPEND_WHEN_INVOICE_OVERDUE_TOOLTIP =
    'Suspend the account once an invoice is this many days overdue. Example: with days late set to 30, an invoice 3 days overdue will not suspend the account, but one 30 days overdue will. To disable this rule, uncheck the box.'
  static SUSPENSION = 'Suspension'
  static SUSPENSIONS = 'Suspensions'
  static SUSPENSION_AUTOMATION = 'Suspension automation'
  static SUSPENSION_AUTOMATION_DESCRIPTION =
    'Optionally automate suspensions for customers who exceed the specified days overdue or credit limit threshold. Accounts will be automatically un-suspended upon payment. Automation also takes over manually placed holds, replacing their type and reason while the account exceeds the threshold and lifting them once it no longer does.'
  static SUSPENSION_AUTOMATION_NO_CONDITIONS_ACTION = 'Enable at least one condition below, or turn automation off.'
  static SUSPENSION_AUTOMATION_NO_CONDITIONS_TITLE = 'Automation is on, but no suspension conditions are active.'
  static SUSPENSION_AUTOMATION_PROFILE_NO_CONDITIONS_ACTION = 'Update the billing profile to fix this.'
  static SUSPENSION_AUTOMATION_PROFILE_NO_CONDITIONS_TITLE =
    'This billing profile has automation on with no active suspension conditions, so it will never suspend or un-suspend this account.'
  static SUSPENSION_AUTOMATION_TOOLTIP =
    'Optionally automate suspensions for customers who exceed the specified days overdue or credit limit threshold. Accounts will be automatically un-suspended upon payment. Automation also takes over manually placed holds, replacing their type and reason while the account exceeds the threshold and lifting them once it no longer does.'
  static SUSPENSION_GROUPS = 'Suspension groups'
  static SUSPENSION_HISTORY = 'Suspension history'
  static SUSPENSION_PRORATION = 'Suspension proration'
  static SUSPENSION_PRORATION_DESCRIPTION =
    'Changing this setting will alter Suspension Proration for all accounts in this Bill Profile unless inheritability is turned off.'
  static SUSPENSION_PRORATION_OFF_TOOLTIP =
    'If Suspension Proration is Off, then any customer who is suspended will be charged during the period when that customer is suspended.'
  static SUSPENSION_PRORATION_ON_TOOLTIP =
    'If Suspension Proration is On, any customer who is suspended will not be charged during the period when that customer is suspended.'
  static SUSPENSION_PRORATION_SETTINGS_TOOLTIP =
    'Changing this setting will alter the Suspension Proration settings on all existing accounts in this Bill Profile as well as new accounts unless inheritability is turned off on a given Account.'
  static SWAP = 'Swap'
  static SWITCHING_TO = 'Switching to'
  static SWITCH_TO_DETAILS_TO_SAVE = 'Switch to Details to save changes'
  static SYNC_FUTURE_DAILY_ROUTES = 'Also update future daily routes to match'
  static SYNC_FUTURE_DAILY_ROUTES_HELPER =
    'Future daily routes on this day of the week will be reordered to match the restored sequence. Stops on those dailies stay as-is — no stops are added or removed.'
  static SYNC_MASTER_BANNER_HEADLINE_SUFFIX = 'will be reordered to match master'
  static SYNC_MASTER_BANNER_KICKER = 'Reorder preview'
  static SYNC_MASTER_BANNER_SUB = 'Stops on those dailies stay as-is — only the order changes.'
  static SYNC_MASTER_BANNER_UNSTAGE = 'Discard preview'
  static SYNC_MASTER_BUTTON_ARIA = 'Push master to days'
  static SYNC_MASTER_BUTTON_DISABLED_HINT = 'Publish your master changes first to push them to days'
  static SYNC_MASTER_BUTTON_PREVIEW_HINT = 'Publish or cancel the active preview before pushing master to days'
  static SYNC_MASTER_NO_DAILIES = 'No upcoming dailies on this route.'
  static SYNC_MASTER_POPOVER_DESCRIPTION =
    "Pick which upcoming days to reorder to match master's sequence. Only the order changes — no stops are added or removed. You'll preview the result before publishing."
  static SYNC_MASTER_POPOVER_TITLE = 'Push master sequence to days'
  static SYNC_MASTER_PREVIEW_BADGE = 'Reorder preview'
  static SYNC_MASTER_PREVIEW_BADGE_HELPER = 'Stops unchanged · order matches master'
  static SYNC_MASTER_STAGE_CLEAR = 'Clear preview'
  static SYNC_MASTER_STAGE_PREFIX = 'Preview resequence'
  static SYNC_MASTER_TOAST_PREFIX = 'Synced master to'
  static TAG = 'Tag'
  static TAGS = 'Tags'
  static TAGS_AND_NOTES = 'Tags and notes'
  static TAGS_UPDATED_SUCCESS_MSG = 'Tags updated successfully'
  static TAG_NAME = 'Tag Name'
  static TAKE_PAYMENT = 'Take Payment'
  static TANKER_TRUCK = 'Tanker'
  static TAX = 'Tax'
  static TAXABLE = 'Taxable'
  static TAXES = 'Taxes'
  static TAXES_INFO = 'View taxes and their rates; edit these; create / archive these'
  static TAXES_LOWERCASE = 'taxes'
  static TAXES_UPDATED_SUCCESSFULLY = 'Taxes updated successfully'
  static TAX_ACCOUNTING_HELPER = 'GL account and how often the tax is remitted.'
  static TAX_ACTIONS = 'Tax actions'
  static TAX_AMOUNT = 'Tax Amount'
  static TAX_APPLICATION = 'Tax Application'
  static TAX_APPLICATION_INFO = 'View where taxes apply; edit tax application and exception rules'
  static TAX_APPLICATION_INTRO =
    'Configure how this tax automatically applies to new and existing Accounts, Services, fees, and other taxable items. Changes to these rules will affect future billing — existing invoices remain unchanged.'
  static TAX_BASICS_HELPER = 'Name the tax and how it appears on invoices.'
  static TAX_DUPLICATED_MSG = 'This tax already exists and will not be duplicated'
  static TAX_EFFECTIVE_ONGOING = 'ongoing'
  static TAX_EXEMPT = 'Tax Exempt'
  static TAX_GROUPING_HELPER = "How this tax's lines appear on the invoice by default."
  static TAX_IDENTIFIER = 'Tax Exemption Identifier'
  static TAX_LOWERCASE = 'tax'
  static TAX_NAME = 'Tax name'
  static TAX_PREVIEW_DISCLAIMER = "Sample invoice — actual lines depend on the customer's services and tax zone."
  static TAX_PREVIEW_FLAT_NOTE = ' Flat-amount taxes are shown at an illustrative rate.'
  static TAX_PREVIEW_HELPER = 'See how this tax will appear on invoices. Updates live as you edit.'
  static TAX_RATE_HELPER = 'Set the rate and when it takes effect.'
  static TAX_STATUS = 'Tax status'
  static TAX_TYPE = 'Tax type'
  static TAX_ZONE = 'Tax Zone'
  static TAX_ZONES = 'Tax Zones'
  static TCR_BRAND_STATUS = 'TCR Brand Status'
  static TCR_CAMPAIGN_STATUS = 'TCR Campaign Status'
  static TCR_CREATED_DATE = 'TCR Created Date'
  static TEAM = 'Team'
  static TELGORITHM_SYNC = 'Telgorithm Sync'
  static TEMPLATES = 'Templates'
  static TEMPLATES_UNAVAILABLE = 'Message templates are coming soon'
  static TEMPORARILY_MOVE_BETWEEN_DAYS = 'Temporarily move between days'
  static TEMPORARY_MODE = 'Temporary mode'
  static TEMPORARY_MODE_BANNER = 'Temporary mode is on — moves and edits apply to %s only. The master sequence won’t change.'
  static TEMPORARY_MODE_DIALOG_DESCRIPTION = 'Any changes made in temporary mode will not affect future recurring stops'
  static TERMS_AND_CONDITIONS = 'Terms & Conditions'
  static TERMS_AND_CONDITIONS_LINK = 'Terms and Conditions Link'
  static TERMS_AND_CONDITIONS_URL = 'Terms & Conditions URL'
  static TERMS_CONDITIONS = 'Terms & Conditions'
  static TEXT_MESSAGE = 'Text message'
  static THAT_IS_EVERY_CONTAINER_ON_SERVICE = 'That is every container on this service.'
  static THEN_WHAT = 'Sold or written off'
  static THE_SERVICE_KEEPS = 'The service keeps'
  static THIRD = 'Third'
  static THIS_CAN_BE_SET_UP_LATER_MSG = '*You can set this later when you finish setup'
  static THIS_FIELD_IS_REQUIRED = 'This field is required'
  static THIS_MONTH = 'This Month'
  static THIS_ROUTE = 'this route'
  static THIS_TAX_APPLIES_TO = 'this tax applies to'
  static THIS_WEEK = 'This Week'
  static THIS_YEAR = 'This Year'
  static THRESHOLD = 'Threshold'
  static THROUGHPUT_LIMIT = 'Throughput (MPS)'
  static THURSDAY = 'Thursday'
  static TICKET = 'Ticket'
  static TICKET_REQUIRED = 'Ticket Required'
  static TIERS = 'Tiers'
  static TILE = 'Tile'
  static TIME = 'Time'
  static TIMELINE_MODE = 'Timeline Mode'
  static TIMER = 'Timer'
  static TIMESTAMP = 'Timestamp'
  static TIME_RANGE = 'Time range'
  static TIME_WINDOW = 'Time window'
  static TIME_ZONE = 'Time Zone'
  static TIMING = 'Timing (Invoice date)'
  static TIPPING_FEE = 'Tipping Fee'
  static TIRE = 'Tire'
  static TITLE = 'Title'
  static TO = 'To'
  static TODAY = 'Today'
  static TODAYS_DATE = "Today's date"
  static TOGGLE_AUTOMATIC_PRICE_CALCULATION = 'Toggle automatic price calculation'
  static TOLLS = 'Tolls'
  static TON = 'Ton'
  static TONS = 'tons'
  static TOP_OF_ROUTE = 'Top of route'
  static TOTAL = 'Total'
  static TOTAL_ATTACHMENT_SIZE_EXCEEDED = 'Unable to attach "{fileName}". Total attachments cannot exceed {maxSize} MB.'
  static TOTAL_CSV_ROWS = 'total CSV rows.'
  static TOTAL_DETECTIONS = 'Total detections'
  static TOTAL_DUE = 'Total due'
  static TOTAL_INVOICES = 'Total Invoices'
  static TOTAL_OPTED_OUT = 'Total Opted Out'
  static TOTAL_PICKUPS = 'Total pickups'
  static TOTAL_REVENUE = 'Total Revenue'
  static TOTAL_SERVICES = 'Total Services'
  static TO_ACCOUNT_DETAIL = 'to account detail'
  static TO_DATE = 'To date'
  static TO_RESOLVE = 'To resolve'
  static TRACKED_FOR_THE_DRIVER_NOT_YOUR_INVENTORY = 'Tracked for the driver. Not counted as your inventory.'
  static TRACKING = 'Tracking'
  static TRANSACTION_DATE = 'Transaction date'
  static TRANSACTION_DATE_CANNOT_BE_IN_FUTURE = 'Transaction date cannot be in the future'
  static TRANSACTION_DATE_IS_REQUIRED = 'Transaction date is required'
  static TRANSACTION_DATE_PLACEHOLDER = 'Transaction date'
  static TRANSACTION_STATUS = 'Transaction status'
  static TRANSACTION_SURCHARGE_DESCRIPTION =
    'We impose a surcharge on the transaction amount on some credit card products, which is not greater than our cost of acceptance. We do not surcharge debit cards.'
  static TRANSACTION_SURCHARGE_NOTE = 'Transactions will incur a surcharge where applicable.'
  static TRANSACTION_TYPE = 'Transaction type'
  static TRANSFER = 'Transfer'
  static TRANSFERRING_FROM = 'Transferring from'
  static TRANSFERRING_TO = 'Transferring to'
  static TRANSFER_TO_ACCOUNT = 'Transfer to account'
  static TRANSFER_TO_INVOICE = 'Transfer to invoice'
  static TRUCK = 'Truck'
  static TRUCK_PROFILE = 'Route around truck size'
  static TRUCK_PROFILE_HELP = 'Without it the optimizer routes like a car — ignoring low bridges, weight limits and truck bans.'
  static TRUCK_SIZE_ALL_OR_NONE = 'Height, width and length are used together — fill all three or leave all three empty.'
  static TRUCK_SIZE_NOT_SET = 'truck size not set'
  static TRUCK_START_SWAP = 'Truck start or swap'
  static TRUST_SCORE = 'Trust Score'
  static TRY_CHANGING_FILTERS = 'Try changing the filters'
  static TUESDAY = 'Tuesday'
  static TURNS = 'Turns'
  static TURN_OFF = 'Turn off'
  static TURN_OFF_BULK_UNASSIGN_MODE_TO_ASSIGN_STOPS = 'Turn off bulk unassign mode to assign stops'
  static TURN_OFF_SUSPENSION_PRORATION = 'Turn off suspension proration'
  static TURN_ON_RECEIVES_PRINTED_COPY = 'Turn on Receives printed copy'
  static TURN_ON_SUSPENSION_PRORATION = 'Turn on suspension proration'
  static TYPE = 'Type'
  static TYPE_AND_PRESS_ENTER = 'Type a value and press Enter'
  static TYPE_EMAIL_MESSAGE_HERE = 'Type your email message here...'
  static TYPE_SKILL_HERE = 'Type Skill Here'
  static TYPE_SMS_MESSAGE_HERE = 'Type your SMS message here...'
  static TYPE_TO_FILTER_PLACEHOLDER = 'Type to filter'
  static UNABLE_TO_LOAD_RENTAL_PERIOD_ACTIVITY = 'Unable to load rental period activity'
  static UNARCHIVE = 'Unarchive'
  static UNARCHIVE_NOTE = 'Unarchive note'
  static UNARCHIVE_NOTE_CONFIRMATION_DESCRIPTION = 'Are you sure you want to unarchive this note?'
  static UNASSIGN = 'Unassign'
  static UNASSIGNED = 'Unassigned'
  static UNASSIGNED_ROUTE = 'Unassigned route'
  static UNASSIGNED_ROUTE_DESCRIPTION = 'Any work orders without a route assignment'
  static UNASSIGNED_STOPS = 'Unassigned stops'
  static UNASSIGNED_STOPS_NO_ITEMS = 'No Unassigned Stops Available'
  static UNASSIGN_FROM_ROUTE = 'Unassign from route'
  static UNASSIGN_STOP = 'Unassign stop'
  static UNASSIGN_STOPS = 'Unassign stops'
  static UNASSIGN_STOP_CONFIRM_BOARD_MSG =
    'This stop will be removed from the route and moved back to unassigned stops. Do you want to continue?'
  static UNASSIGN_STOP_CONFIRM_MSG = 'Are you sure you want to unassign this stop?'
  static UNASSIGN_STOP_SUCCESS_MSG = 'Stop successfully unassigned'
  static UNASSIGN_WORK_ORDER = 'Unassign work order'
  static UNASSIGN_WORK_ORDER_CONFIRM_MSG = 'Are you sure you want to unassign this work order?'
  static UNBILLED = 'Unbilled'
  static UNBILLED_DAYS = 'Unbilled days'
  static UNCHECK_LATE_FEES_TO_INCLUDE_PREVIOUS_PERIODS = 'Uncheck "Include late fees" to enable billing of previous periods'
  static UNCOLLECTED_REVENUE = 'Uncollected revenue'
  static UNDO = 'Undo'
  static UNDO_DELETE = 'Undo delete'
  static UNDO_DRIVER_RESULTS = 'Undo it'
  static UNDO_DRIVER_RESULTS_HELP = 'Cancels the order and the service event'
  static UNDO_NEEDS_BACKEND = 'Undo is unavailable until reopening a reviewed detection is supported'
  static UNDO_RESET = 'Undo grace period reset'
  static UNDO_RESET_SUCCESS_MSG = 'Periods merged successfully'
  static UNEXPECTED_ERROR = 'There was an unexpected error.'
  static UNEXPECTED_ERROR_DELETING_BATCHES = 'An unexpected error occurred while deleting batches'
  static UNICODE = 'Unicode'
  static UNIFIED = 'Unified'
  static UNIT_OF_MEASURE = 'Unit of measure'
  static UNKNOWN = 'Unknown'
  static UNKNOWN_LOCATION = 'Unknown location'
  static UNKNOWN_ROUTE = 'Unknown Route'
  static UNLINK_ACCOUNTS_TO_LATE_FEE_SUCCESS_MSG = 'Selected accounts successfully unlinked from late fee'
  static UNLINK_ACCOUNT_TO_LATE_FEE_SUCCESS_MSG = 'Selected account successfully unlinked from late fee'
  static UNLOCKED_PRICE = 'Unlocked Price'
  static UNMATCH = 'Unmatch'
  static UNNAMED = 'Unnamed'
  static UNPAID = 'Unpaid'
  static UNPAID_INVOICES = 'Unpaid invoices'
  static UNPIN = 'Unpin'
  static UNPOSTED = 'Unposted'
  static UNPROCESSED = 'Unprocessed'
  static UNREAD = 'Unread'
  static UNSAVED_CHANGES = 'Unsaved changes'
  static UNSAVED_CONTAINER_CHANGES_WARNING = 'You have unsaved container changes. Are you sure you want to leave? All changes will be lost.'
  static UNSELECT_ALL = 'Unselect all'
  static UNSUSPEND = 'Unsuspend'
  static UNSUSPEND_ACCOUNT = 'Unsuspend account'
  static UNSUSPEND_ACCOUNTS = 'Unsuspend accounts'
  static UPDATE = 'Update'
  static UPDATED = 'Updated'
  static UPDATED_AT_HEADER = 'Updated at'
  static UPDATED_BY_HEADER = 'Updated by'
  static UPDATED_INVOICE = 'Updated invoice'
  static UPDATED_STATE = 'Updated state'
  static UPDATE_AGING = 'Update aging'
  static UPDATE_ALL_RELATED_CONFIGURED_SERVICES_PRICE = 'Update all related configured services price'
  static UPDATE_ASSOCIATED_WORK_ORDERS = 'Also update associated work orders'
  static UPDATE_BILLING_PROFILE_CONFIRM_DESCRIPTION =
    'Changes to this Billing Profile will be applied immediately to all customers assigned to this profile. Customers with custom settings (including but not limited to a custom invoice due date or a custom suspension setting) will maintain those custom settings.'
  static UPDATE_BILLING_PROFILE_CONFIRM_TITLE = 'Update billing profile'
  static UPDATE_BRANCH = 'Update branch'
  static UPDATE_CONTAINER_LOCATION = 'Update container location'
  static UPDATE_CONTAINER_PREFIX = 'Update container'
  static UPDATE_CONTAINER_RECORD = 'Update container record'
  static UPDATE_CONTAINER_TYPE = 'Update container type'
  static UPDATE_DRAFT = 'Update draft'
  static UPDATE_PRICE_ON_ALL_EXISTING_CONFIGURED_SERVICES = 'Update price on all existing configured services'
  static UPDATE_REPORT = 'Update Report'
  static UPDATING_RECURRENCE = 'Updating recurrence...'
  static UPDATING_SERVICE_DATE = 'Updating service date...'
  static UPLOAD = 'Upload'
  static UPLOAD_COMPANY_LOGO = 'Upload company logo'
  static UPLOAD_COMPLETED_SUCCESSFULLY = 'Upload completed successfully'
  static UPLOAD_CSV = 'Upload CSV'
  static UPLOAD_LOGO = 'Upload logo'
  static USER = 'User'
  static USER_DISCONNECTED_SUCCESSFULLY = 'User disconnected successfully'
  static USER_ID = 'User ID'
  static USER_INTENT_STATUS = 'User intent status'
  static USER_NAME = 'User name'
  static USE_AS_BILLING_ADDRESS = 'Use as billing address'
  static USE_AS_STARTING_POINT = 'Use as starting point \u2192'
  static USE_BROADCAST_TO_SEND_FIRST_MESSAGE = 'Use the Broadcast button to send your first message'
  static USE_CASE = 'Use Case'
  static USE_CASE_SECTION = 'Use Case'
  static USE_HOSTED_PRIVACY_POLICY = 'Use HaulerHero hosted privacy policy'
  static USE_SERVICE_ADDRESS_AS_BILLING_ADDRESS = 'Use service address as billing address'
  static U_TURNS = 'U-turns'
  static VACATION = 'Vacation'
  static VACATION_HOLD = 'Vacation hold'
  static VALUE = 'Value'
  static VALUES_LOWERCASE = 'values'
  static VARIABLES = 'Variables'
  static VARIABLES_UNAVAILABLE = "Variables aren't filled in per recipient yet"
  static VERIFIED_SERVICES = 'Verified Services'
  static VERIFIED_SERVICES_DESCRIPTION = 'Services reviewed and confirmed — the resolved end of the queue.'
  static VERTICAL = 'Vertical'
  static VIDEOS = 'Videos'
  static VIDEO_TIMELINE = 'Video timeline'
  static VIEW = 'View'
  static VIEWING = 'Viewing'
  static VIEW_ALL_ACTIVITY = 'View all activity'
  static VIEW_ALL_NOTES = 'View all notes'
  static VIEW_ALL_NOTIFICATIONS = 'View all notifications'
  static VIEW_APPLIED_OPTIMIZATION = 'View applied'
  static VIEW_ARCHIVED_NOTES = 'View archived notes'
  static VIEW_CONTACT_INFO = 'View the contact info for the service location'
  static VIEW_CUSTOMER_BILLING_PROFILE = 'View all elements of customer billing profile, edit these; create / delete these'
  static VIEW_DETAILS = 'View details'
  static VIEW_EXAMPLE_MESSAGES = 'View example messages for reference'
  static VIEW_INVOICES = 'View invoices'
  static VIEW_INVOICE_GROUP_DETAIL = 'View invoice group detail'
  static VIEW_MODE = 'View mode'
  static VIEW_NAME = 'View Name'
  static VIEW_NOTES = 'View notes'
  static VIEW_ON_MAP = 'View on map'
  static VIEW_PAYMENTS = 'View payments'
  static VIEW_PAYMENT_GROUP_DETAIL = 'View payment group detail'
  static VIEW_REPORT = 'View report'
  static VIEW_ROUTE = 'View route'
  static VIEW_SERVICE = 'View service'
  static VIEW_STATEMENT = 'View statement'
  static VISIBLE = 'visible'
  static VISION = 'Vision'
  static VISION_ML = 'Vision (ML)'
  static VISION_VIDEO = 'Vision video'
  static VOIDED = 'Voided'
  static VOID_PAYMENT = 'Void Payment'
  static VOLUME_BY_SOURCE = 'Volume by Source'
  static VOLUME_BY_SOURCE_HINT = 'Daily detection counts over the selected range. Toggle a legend item to hide.'
  static WAIVED = 'Waived'
  static WARNING_UNABLE_TO_LOAD_INVOICES = 'Warning: Unable to load invoices for'
  static WARRANTY_DATE = 'Warranty date'
  static WAS = 'was'
  static WEAK_PASSWORD_ERROR = 'The new password is weak, please create a strong password.'
  static WEBSITE = 'Website'
  static WEDNESDAY = 'Wednesday'
  static WEEK = 'Week'
  static WEEKEND = 'Weekend'
  static WEEKLY = 'Weekly'
  static WEEKS = 'Weeks'
  static WEEK_DAY = 'Week day'
  static WEIGHT = 'Weight'
  static WEIGHT_LBS = 'Weight (lbs)'
  static WHATS_NEW_ON_HAULER_HERO = "What's new on Hauler Hero"
  static WHAT_ARE_DRAFT_ROUTES = 'What are draft routes?'
  static WHEELS = 'Wheels'
  static WHERE = 'Where'
  static WHERE_IT_GOES = 'Where it goes'
  static WIDTH = 'Width'
  static WILL_BE_CANCELLED = 'Will be cancelled'
  static WILL_BE_REACTIVATED = 'will be reactivated'
  static WILL_RECEIVE = 'will receive'
  static WITHOUT_PHOTOS = 'Without photos'
  static WITH_PHOTOS = 'With photos'
  static WIZARD_NEXT = 'Next'
  static WO = 'WO#'
  static WON_FROM_COMPETITOR = 'Won from Competitor'
  static WON_REASON = 'Won reason'
  static WON_REASONS = 'Won reasons'
  static WON_REASONS_DESCRIPTION = 'Why an account was won, captured when creating an account.'
  static WON_REASONS_LOAD_ERROR = 'Unable to load won reasons. Refresh and try again.'
  static WON_REASON_LOGGED_FOR_REPORTING = 'Logged on the account for win/loss reporting.'
  static WORKING_DAYS = 'Working Days'
  static WORKING_DAYS_LABEL = 'Working days'
  static WORK_INFO = 'Work Information'
  static WORK_IN_PROGRESS = 'Work in progress'
  static WORK_ORDER = 'Work Order'
  static WORK_ORDERS = 'Work Orders'
  static WORK_ORDERS_DESCRIPTION = 'Number of work orders for the day'
  static WORK_ORDERS_LOAD_FAILED_NARROW_RANGE = 'Work orders could not be loaded for this date range. Try a narrower range.'
  static WORK_ORDERS_REVIEW = 'Work orders review'
  static WORK_ORDER_ACTIONS = 'Work order actions'
  static WORK_ORDER_AND_ROUTE_INFO = 'Work Order and Route Information'
  static WORK_ORDER_DELETED_SUCCESSFULLY = 'Work order deleted successfully'
  static WORK_ORDER_DETAILS = 'Work order details'
  static WORK_ORDER_DETAIL_TABS = 'Work order detail tabs'
  static WORK_ORDER_ID = 'Work Order'
  static WORK_ORDER_ID_COLUMN = 'Work Order ID'
  static WORK_ORDER_ID_WRONG_COLUMN_ERROR =
    'Your sequence import did not have a column named Work Order ID. Please try a route export and you’ll have a properly formatted file to import with a hidden Column O where Work Order ID column is properly formatted with work orders that can be sequenced.'
  static WORK_ORDER_ID_WRONG_UUID_FORMAT =
    'Imported Work Order IDs were not the correct format. Please try a route export and then make sure not to modify the format of hidden Column O, but the sequence only. Adding IDs or data to column O that are not in the export increases the chance of this error, and IDs that are not matching will be ignored for purposes of sequencing.'
  static WORK_ORDER_NOTE = 'Work order note'
  static WORK_ORDER_NOTES_DESCRIPTION = 'Any WO notes added'
  static WORK_ORDER_PREVIEW = 'Work order preview'
  static WORK_ORDER_STATUS = 'Work order status'
  static WORK_ORDER_STATUSES = 'Work order statuses'
  static WORK_ORDER_STATUSES_DESCRIPTION =
    'Shows where a stop is in the service lifecycle and any account-level conditions affecting service.'
  static WORK_ORDER_UNASSIGNED_FROM_ROUTE = 'Work order removed from route'
  static WO_DATE_CHANGE_MSG = 'Are you sure you want to change the Work Order Date?'
  static WO_DATE_CHANGE_MSG_INVOICED =
    'This Work Order has already been invoiced. Changing the date will not update the invoice line unless the invoice is regenerated. Regenerate the invoice if the data on the invoice line needs to reflect this date change.'
  static WO_DATE_CHANGE_SUCCESS = 'Work Order Date changed'
  static WO_DATE_CHANGE_SUCCESS_MSG = 'Please route this Work Order from the Route Manager.'
  static WO_DATE_REQUIRED_IF_ACTION_SET = 'A work order date is required if an action is selected'
  static WO_DETAILS_LOAD_ERROR = 'This work order could not be loaded'
  static WO_INVOICED_CANNOT_CHANGE_DATE =
    'This on-request work order is on an invoice. Requires the "Change date on invoiced work orders" permission.'
  static WO_INVOICED_CANNOT_CHANGE_STATUS = 'This work order is already invoiced — its invoice status can’t be changed'
  static WO_INVOICED_EXCEPTION_WARNING = 'This work order is already invoiced'
  static WO_PHOTOS = "Work Order's Photos"
  static WO_PRICE_HEADER = 'WO price'
  static WO_REPORT = 'WO_REPORT'
  static WO_SERVICED_CANNOT_CHANGE_DATE = 'This work order is already serviced — its service date can’t be changed'
  static WRITE_OFF = 'Write off'
  static WRITE_YOUR_EMAIL = 'Start writing your email…'
  static WRITE_YOUR_SMS = 'Type your SMS…'
  static WRITTEN_OFF = 'Written off'
  static WRITTEN_OFF_TOAST = 'Container written off'
  static WRONG_DISCREPANCY = 'Wrong discrepancy'
  static WRONG_EXCEPTION_TYPE = 'Wrong exception type'
  static WRONG_WORK_ORDER = 'Wrong work order'
  static XLS = 'XLS'
  static YARD = 'Yard'
  static YARDS = 'Yards'
  static YARD_SELECTION = 'Yard selection'
  static YARD_STOP = 'Yard stop'
  static YEAR = 'Year'
  static YEARLY_SERVICE_WORK_ORDER_WARNING =
    'Work orders are not generated for yearly services. This frequency is intended for attaching fees or other administrative purposes. Support for yearly work orders will be added in a future update.'
  static YEARS = 'Years'
  static YES = 'Yes'
  static YES_DELETE = 'Yes, delete'
  static YES_PROCEED = 'Yes, Proceed'
  static ZERO_PAYMENTS = 'None'
  static ZIP = 'Zip'
  static ZIP_CODE = 'Zip Code'
  static ZONE = 'Zone'
  static ZONES = 'Zones'
  static ZONES_INFO = 'View tax zones and their boundaries; edit these; create / archive these'
  static ZONE_NAME = 'Zone Name'
  static ZONE_SERVICE_PURPOSE_HELPER = 'Set the default schedule and route new services inherit at addresses in this zone.'
  static ZOOM = 'Zoom'
  static ZOOM_BLOCKS = 'Blocks'
  static ZOOM_BUILDINGS = 'Buildings'
  static ZOOM_CITIES = 'Cities'
  static ZOOM_DISABLED = 'Disabled'
  static ZOOM_DISTRICT = 'District'
  static ZOOM_STREETS = 'Streets'
  static ZOOM_TO_STOP = 'Zoom to stop'
}
